export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `Date` scalar type represents a date. The Date appears in a JSON
   * response as an ISO8601 formatted string, without a time component.
   */
  Date: any;
  /**
   * The `DateTime` scalar type represents a date and time in the UTC
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string, including UTC timezone ("Z"). The parsed date and time string will
   * be converted to UTC if there is an offset.
   */
  DateTime: any;
  /**
   * The `Decimal` scalar type represents signed double-precision fractional
   * values parsed by the `Decimal` library. The Decimal appears in a JSON
   * response as a string to preserve precision.
   */
  Decimal: any;
  /** HTML rich text (e.g. used in WYSIWG). It's safe to use dangerouslySetInnerHTML on these. */
  HtmlRichText: any;
  /**
   * The `Json` scalar type represents arbitrary json string data, represented as UTF-8
   * character sequences. The Json type is most often used to represent a free-form
   * human-readable json string.
   */
  Json: any;
  /**
   * The `Naive DateTime` scalar type represents a naive date and time without
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string.
   */
  NaiveDateTime: any;
  /** ISO time */
  Timestamp: any;
};

export type AcceptExpertInvitationInput = {
  clientMutationId: Scalars['String'];
  optedInMarketing?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
  token: Scalars['String'];
};

export type AcceptExpertInvitationPayload = {
  __typename?: 'AcceptExpertInvitationPayload';
  clientMutationId: Scalars['String'];
  isValid?: Maybe<Scalars['Boolean']>;
};

export type AcceptOfferInput = {
  clientMutationId: Scalars['String'];
  /** Id of the contract */
  contractId: Scalars['ID'];
};

export type AcceptOfferPayload = {
  __typename?: 'AcceptOfferPayload';
  clientMutationId: Scalars['String'];
  contract?: Maybe<Contract>;
};

export type AcceptOrganisationInvitationInput = {
  clientMutationId: Scalars['String'];
  code: Scalars['String'];
};

export type AcceptOrganisationInvitationPayload = {
  __typename?: 'AcceptOrganisationInvitationPayload';
  clientMutationId: Scalars['String'];
  organisationInvitation?: Maybe<OrganisationInvitation>;
};

export type Achievement = Node & {
  __typename?: 'Achievement';
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  /** The ID of an object */
  id: Scalars['ID'];
  isPublished?: Maybe<Scalars['Boolean']>;
  media?: Maybe<Array<AchievementMedia>>;
  role?: Maybe<Scalars['String']>;
  skills?: Maybe<Array<Skill>>;
  startDate?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
};

export type AchievementConnection = {
  __typename?: 'AchievementConnection';
  edges?: Maybe<Array<Maybe<AchievementEdge>>>;
  pageInfo: PageInfo;
};

export type AchievementEdge = {
  __typename?: 'AchievementEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Achievement>;
};

export type AchievementMedia = Node & {
  __typename?: 'AchievementMedia';
  /** The ID of an object */
  id: Scalars['ID'];
  isFeatured?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};


export type AchievementMediaSourceArgs = {
  size?: InputMaybe<AchievementMediaSize>;
};

export type AchievementMediaInput = {
  id?: InputMaybe<Scalars['ID']>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AchievementMediaType>;
};

export enum AchievementMediaSize {
  Large = 'LARGE',
  Thumbnail = 'THUMBNAIL'
}

export enum AchievementMediaType {
  Avif = 'avif',
  Jpeg = 'jpeg',
  Jpg = 'jpg',
  Png = 'png',
  Webp = 'webp'
}

export type AchievementsFilterInput = {
  /** Include unpublished achievements if the current user owns the achievement */
  unpublished?: InputMaybe<Scalars['Boolean']>;
};

export type ActivateProjectInput = {
  clientMutationId: Scalars['String'];
  code: Scalars['String'];
};

export type ActivateProjectPayload = {
  __typename?: 'ActivateProjectPayload';
  clientMutationId: Scalars['String'];
  project?: Maybe<Project>;
};

export type AddApplicationExperienceInput = {
  /** The project id of the application being applied to */
  applicationProjectId: Scalars['ID'];
  clientMutationId: Scalars['String'];
  /** The description to associate with a work history item or project */
  description?: InputMaybe<Scalars['String']>;
  /** The id of a project to associate a description with */
  projectId?: InputMaybe<Scalars['ID']>;
  /** The id of a work history item to associate a description with */
  workHistoryId?: InputMaybe<Scalars['ID']>;
};

export type AddApplicationExperiencePayload = {
  __typename?: 'AddApplicationExperiencePayload';
  application?: Maybe<Application>;
  applicationExperience?: Maybe<ApplicationExperience>;
  clientMutationId: Scalars['String'];
};

export type AddApplicationViewedInteractionInput = {
  /** Applicant id */
  applicantId?: InputMaybe<Scalars['ID']>;
  clientMutationId: Scalars['String'];
  /** Application project id */
  projectId?: InputMaybe<Scalars['ID']>;
};

export type AddApplicationViewedInteractionPayload = {
  __typename?: 'AddApplicationViewedInteractionPayload';
  application?: Maybe<Application>;
  clientMutationId: Scalars['String'];
};

export type AddAvailabilityEventInput = {
  clientMutationId: Scalars['String'];
  /** The end of the availability event */
  dateEnd: Scalars['String'];
  /** The start of the availability event */
  dateStart: Scalars['String'];
  /** The type of availability */
  type: EventType;
};

export type AddAvailabilityEventPayload = {
  __typename?: 'AddAvailabilityEventPayload';
  clientMutationId: Scalars['String'];
  events?: Maybe<Array<Maybe<EventMutationOutput>>>;
};

export type AddExpertBankAccountInput = {
  accountName?: InputMaybe<Scalars['String']>;
  accountNumber?: InputMaybe<Scalars['String']>;
  accountTitle?: InputMaybe<Scalars['String']>;
  bankAccountType?: InputMaybe<BankAccountType>;
  beneficiaryAddress?: InputMaybe<Scalars['String']>;
  bsb?: InputMaybe<Scalars['String']>;
  clientMutationId: Scalars['String'];
  iban?: InputMaybe<Scalars['String']>;
  routingNumber?: InputMaybe<Scalars['String']>;
  swiftCode?: InputMaybe<Scalars['String']>;
};

export type AddExpertBankAccountPayload = {
  __typename?: 'AddExpertBankAccountPayload';
  bankAccountAus?: Maybe<BankAccountAus>;
  bankAccountInternational?: Maybe<BankAccountInternational>;
  bankAccountNz?: Maybe<BankAccountNz>;
  bankAccountUs?: Maybe<BankAccountUs>;
  clientMutationId: Scalars['String'];
  user?: Maybe<User>;
};

export type AdminInviteToProjectInput = {
  clientMutationId: Scalars['String'];
  projectId: Scalars['String'];
  publicCode: Scalars['String'];
};

export type AdminInviteToProjectPayload = {
  __typename?: 'AdminInviteToProjectPayload';
  clientMutationId: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  projectCode?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ApplicantStatus = {
  __typename?: 'ApplicantStatus';
  expertDeclinedReason?: Maybe<Scalars['String']>;
  expertStatus?: Maybe<ExpertStatus>;
  expertStatusDate?: Maybe<Scalars['Timestamp']>;
  invited?: Maybe<Scalars['Boolean']>;
  invitedBy?: Maybe<Scalars['String']>;
  recommended?: Maybe<Scalars['Boolean']>;
  viewed?: Maybe<Scalars['Boolean']>;
};

export type Application = Node & {
  __typename?: 'Application';
  applicant?: Maybe<User>;
  applicantStatus?: Maybe<ApplicantStatus>;
  budget?: Maybe<Scalars['String']>;
  dateStart?: Maybe<Scalars['String']>;
  dateSubmitted?: Maybe<Scalars['Timestamp']>;
  /** The ID of an object */
  id: Scalars['ID'];
  projectId?: Maybe<Scalars['Int']>;
  proposedRate?: Maybe<Scalars['Decimal']>;
  proposedRateUnit?: Maybe<Scalars['String']>;
  /** Work and project experiences associated with this application */
  selectedExperiences?: Maybe<ApplicationExperienceConnection>;
  statement?: Maybe<Scalars['String']>;
  status?: Maybe<ApplicationStatus>;
};


export type ApplicationSelectedExperiencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ApplicationConnection = {
  __typename?: 'ApplicationConnection';
  edges?: Maybe<Array<Maybe<ApplicationEdge>>>;
  pageInfo: PageInfo;
};

export type ApplicationEdge = {
  __typename?: 'ApplicationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Application>;
};

export type ApplicationExperience = Node & {
  __typename?: 'ApplicationExperience';
  /** Description of a given work history item or project the applicant has worked on */
  description?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  item?: Maybe<ExperienceItem>;
  /** The project id this description relates to */
  projectId?: Maybe<Scalars['Int']>;
  /** The work history id this description relates to */
  workHistoryId?: Maybe<Scalars['Int']>;
};

export type ApplicationExperienceConnection = {
  __typename?: 'ApplicationExperienceConnection';
  edges?: Maybe<Array<Maybe<ApplicationExperienceEdge>>>;
  pageInfo: PageInfo;
};

export type ApplicationExperienceEdge = {
  __typename?: 'ApplicationExperienceEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<ApplicationExperience>;
};

export enum ApplicationStatus {
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED'
}

export enum ApplicationSteps {
  AccountCreated = 'ACCOUNT_CREATED',
  AdditionalDetailsAnswered = 'ADDITIONAL_DETAILS_ANSWERED',
  ApplicationCompleted = 'APPLICATION_COMPLETED',
  CvUploaded = 'CV_UPLOADED',
  EmploymentTypeAnswered = 'EMPLOYMENT_TYPE_ANSWERED',
  ExpertiseAndSkillsAnswered = 'EXPERTISE_AND_SKILLS_ANSWERED',
  PurposeAnswered = 'PURPOSE_ANSWERED',
  ReasonForJoiningAnswered = 'REASON_FOR_JOINING_ANSWERED',
  WorkLocationAnswered = 'WORK_LOCATION_ANSWERED'
}

export type ApproveContractOfferInput = {
  clientMutationId: Scalars['String'];
  email: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  /** approval token */
  token: Scalars['String'];
};

export type ApproveContractOfferPayload = {
  __typename?: 'ApproveContractOfferPayload';
  alreadyApproved?: Maybe<Scalars['Boolean']>;
  clientMutationId: Scalars['String'];
  manualApprovalRequired?: Maybe<Scalars['Boolean']>;
  manualApprovalUrl?: Maybe<Scalars['String']>;
};

export type ApproveOfferInput = {
  clientMutationId: Scalars['String'];
  /** Id of the contract */
  contractId: Scalars['ID'];
};

export type ApproveOfferPayload = {
  __typename?: 'ApproveOfferPayload';
  clientMutationId: Scalars['String'];
  contract?: Maybe<Contract>;
};

export type Article = Node & {
  __typename?: 'Article';
  articleFeaturedContent?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  authorProfilePicture?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  featured?: Maybe<Scalars['Boolean']>;
  /** The ID of an object */
  id: Scalars['ID'];
  mainImage?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  publishedOn?: Maybe<Scalars['DateTime']>;
  readingTime?: Maybe<Scalars['Int']>;
  releaseDate?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
};

export type ArticleConnection = {
  __typename?: 'ArticleConnection';
  edges?: Maybe<Array<Maybe<ArticleEdge>>>;
  pageInfo: PageInfo;
};

export type ArticleEdge = {
  __typename?: 'ArticleEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Article>;
};

export type AstuteRegistration = Node & OnboardingTask & {
  __typename?: 'AstuteRegistration';
  /** The ID of an object */
  id: Scalars['ID'];
  name: Scalars['String'];
  paymentInformation?: Maybe<PaymentInformation>;
  status: OnboardingTaskStatus;
};

export type Availability = {
  __typename?: 'Availability';
  currentAvailability?: Maybe<AvailabilityStatus>;
  /** Current availability status for the expert based on availability event for current date */
  currentStatus?: Maybe<EventType>;
  events?: Maybe<EventConnection>;
  unavailableUntilDate?: Maybe<Scalars['Date']>;
};


export type AvailabilityEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateRange: EventDateRangeInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export enum AvailabilityStatus {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE'
}

export type BackOffice = {
  __typename?: 'BackOffice';
  backOfficeLink?: Maybe<Scalars['String']>;
  dateAvailabilityUpdated?: Maybe<Scalars['Timestamp']>;
  /** The most recent activity of any kind on the platform. */
  dateLastActivity?: Maybe<Scalars['Timestamp']>;
  dateLastBrowsedProjects?: Maybe<Scalars['Timestamp']>;
  dateLastInteracted?: Maybe<Scalars['Timestamp']>;
  dateLastLogin?: Maybe<Scalars['Timestamp']>;
  dateRegistered?: Maybe<Scalars['Timestamp']>;
  dateUserLastUpdated?: Maybe<Scalars['Timestamp']>;
  isClaimed?: Maybe<Scalars['Boolean']>;
  isFutured?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  isPrivate?: Maybe<Scalars['Boolean']>;
};

export type BankAccountAus = {
  __typename?: 'BankAccountAus';
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  bsb?: Maybe<Scalars['String']>;
};

export type BankAccountInternational = {
  __typename?: 'BankAccountInternational';
  accountName?: Maybe<Scalars['String']>;
  beneficiaryAddress?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  swiftCode?: Maybe<Scalars['String']>;
};

export type BankAccountNz = {
  __typename?: 'BankAccountNz';
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
};

export enum BankAccountType {
  Aus = 'AUS',
  International = 'INTERNATIONAL',
  Nz = 'NZ',
  Payoneer = 'PAYONEER',
  Paypal = 'PAYPAL',
  Us = 'US'
}

export type BankAccountUs = {
  __typename?: 'BankAccountUs';
  accountNumber?: Maybe<Scalars['String']>;
  accountTitle?: Maybe<Scalars['String']>;
  beneficiaryAddress?: Maybe<Scalars['String']>;
  routingNumber?: Maybe<Scalars['String']>;
  swiftCode?: Maybe<Scalars['String']>;
};

/** A list of bookmarked objects */
export type Bookmark = Project;

export type BookmarkConnection = {
  __typename?: 'BookmarkConnection';
  edges?: Maybe<Array<Maybe<BookmarkEdge>>>;
  pageInfo: PageInfo;
};

export type BookmarkEdge = {
  __typename?: 'BookmarkEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Bookmark>;
};

export enum BudgetType {
  Fixed = 'FIXED',
  Variable = 'VARIABLE'
}

export enum BudgetUnit {
  PerDay = 'PER_DAY',
  PerHour = 'PER_HOUR',
  PerMonth = 'PER_MONTH',
  PerProject = 'PER_PROJECT',
  PerWeek = 'PER_WEEK'
}

export type BusinessInfo = {
  abn?: InputMaybe<Scalars['String']>;
  acn?: InputMaybe<Scalars['String']>;
  registeredBusinessName?: InputMaybe<Scalars['String']>;
};

/** Business Services */
export type BusinessService = Node & {
  __typename?: 'BusinessService';
  group: Scalars['String'];
  /** The ID of an object */
  id: Scalars['ID'];
  isApproved: Scalars['Boolean'];
  name: Scalars['String'];
};

export type BusinessServiceConnection = {
  __typename?: 'BusinessServiceConnection';
  edges?: Maybe<Array<Maybe<BusinessServiceEdge>>>;
  pageInfo: PageInfo;
};

export type BusinessServiceEdge = {
  __typename?: 'BusinessServiceEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<BusinessService>;
};

/** Calendly Event */
export type CalendlyEvent = Node & {
  __typename?: 'CalendlyEvent';
  calendlyEventId: Scalars['String'];
  calendlyInviteeId: Scalars['String'];
  /** The ID of an object */
  id: Scalars['ID'];
  insertedAt: Scalars['NaiveDateTime'];
};

export type CalendlyEventConnection = {
  __typename?: 'CalendlyEventConnection';
  edges?: Maybe<Array<Maybe<CalendlyEventEdge>>>;
  pageInfo: PageInfo;
};

export type CalendlyEventEdge = {
  __typename?: 'CalendlyEventEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CalendlyEvent>;
};

export type CancelProjectInput = {
  clientMutationId: Scalars['String'];
  projectId: Scalars['ID'];
};

export type CancelProjectPayload = {
  __typename?: 'CancelProjectPayload';
  clientMutationId: Scalars['String'];
  project?: Maybe<Project>;
};

export type ClaimMindTheGapInput = {
  clientMutationId: Scalars['String'];
};

export type ClaimMindTheGapPayload = {
  __typename?: 'ClaimMindTheGapPayload';
  clientMutationId: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
};

export type ClearEducationItemsPayload = {
  __typename?: 'ClearEducationItemsPayload';
  success?: Maybe<Scalars['Boolean']>;
};

export type ClearWorkItemsPayload = {
  __typename?: 'ClearWorkItemsPayload';
  success?: Maybe<Scalars['Boolean']>;
};

export enum ClearanceLevel {
  AuBaseline = 'AU_BASELINE',
  AuNv_1 = 'AU_NV_1',
  AuNv_2 = 'AU_NV_2',
  AuPv = 'AU_PV',
  NzCv = 'NZ_CV',
  NzDsc = 'NZ_DSC',
  NzSv = 'NZ_SV',
  NzTssv = 'NZ_TSSV',
  NzTsv = 'NZ_TSV'
}

export type Client = {
  __typename?: 'Client';
  /** A single contract viewable by the client given the contract code */
  contract?: Maybe<Contract>;
  isOrgAdmin?: Maybe<Scalars['Boolean']>;
  memberOf: Array<Organisation>;
  phoneMobile?: Maybe<Scalars['String']>;
  postedProjects?: Maybe<Array<Maybe<PostedProject>>>;
  profilePicture?: Maybe<ProfilePicture>;
  profileUrl?: Maybe<Scalars['String']>;
  /** A single project viewable by the client given the project code */
  project?: Maybe<Project>;
  /** A collection of projects for the client. */
  projects?: Maybe<ProjectConnection>;
  title?: Maybe<Scalars['String']>;
};


export type ClientContractArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ClientProfilePictureArgs = {
  size: ProfilePictureSize;
};


export type ClientProjectArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ClientProjectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ClientProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export enum ClientProjectFilter {
  Archived = 'ARCHIVED',
  Filled = 'FILLED',
  Sourcing = 'SOURCING'
}

export type CommunityEvent = Node & {
  __typename?: 'CommunityEvent';
  eventDate?: Maybe<Scalars['DateTime']>;
  eventDetails?: Maybe<Scalars['String']>;
  eventExternalLink?: Maybe<Scalars['String']>;
  guestName?: Maybe<Scalars['String']>;
  hostGuestProfilePicture?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organiser?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
};

export type CommunityEventConnection = {
  __typename?: 'CommunityEventConnection';
  edges?: Maybe<Array<Maybe<CommunityEventEdge>>>;
  pageInfo: PageInfo;
};

export type CommunityEventEdge = {
  __typename?: 'CommunityEventEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CommunityEvent>;
};

export type CompleteApplicationInput = {
  meetingUri?: InputMaybe<Scalars['String']>;
};

export type CompleteApplicationPayload = {
  __typename?: 'CompleteApplicationPayload';
  success?: Maybe<Scalars['Boolean']>;
};

export type ConfirmAbnAcnNonPayroll = Node & OnboardingTask & {
  __typename?: 'ConfirmAbnAcnNonPayroll';
  /** The ID of an object */
  id: Scalars['ID'];
  name: Scalars['String'];
  paymentInformation?: Maybe<PaymentInformation>;
  status: OnboardingTaskStatus;
};

export type ConfirmAbnAcnPayroll = Node & OnboardingTask & {
  __typename?: 'ConfirmAbnAcnPayroll';
  /** The ID of an object */
  id: Scalars['ID'];
  name: Scalars['String'];
  paymentInformation?: Maybe<PaymentInformation>;
  status: OnboardingTaskStatus;
};

export type ConfirmProjectOpportunityEmailInput = {
  clientMutationId: Scalars['String'];
  confirmProjectOpportunityToken: Scalars['String'];
};

export type ConfirmProjectOpportunityEmailPayload = {
  __typename?: 'ConfirmProjectOpportunityEmailPayload';
  alreadyConfirmed?: Maybe<Scalars['Boolean']>;
  clientMutationId: Scalars['String'];
};

export type Consultant = Node & {
  __typename?: 'Consultant';
  /** All active projects that the expert has been hired for. */
  activeHiredProjects?: Maybe<ProjectConnection>;
  /** Average Project Rating for an expert */
  averageProjectRating?: Maybe<Scalars['Float']>;
  /** A collection of projects for the consulant. */
  dashboardProjects?: Maybe<ProjectConnection>;
  /** Expert's dedicated contact information */
  dedicatedContact?: Maybe<DedicatedContact>;
  expertAvailability?: Maybe<Availability>;
  /** A collection of projects for which the consulant has an agreed contract. */
  hiredProjects?: Maybe<ProjectConnection>;
  /** The ID of an object */
  id: Scalars['ID'];
  /** The consultant's verification status */
  identityVerification?: Maybe<IdentityVerification>;
  /** Insurance information for an expert */
  insuranceInformation?: Maybe<InsuranceInformation>;
  /** Is this consultant a talent of any private cloud */
  isPrivateCloudMember?: Maybe<Scalars['Boolean']>;
  /** The consultant's latest milestone, (getting started, hired, project extended */
  latestMilestone?: Maybe<LatestMilestone>;
  /** Expert lifecycle information */
  lifecycle?: Maybe<Lifecycle>;
  /** Address information for an expert */
  locationAddress?: Maybe<LocationAddress>;
  /** The organisations this consultant is a member of */
  memberOf: Array<Organisation>;
  /** Eligibility status for a Pay360 user */
  pay360EligibilityStatus?: Maybe<Scalars['String']>;
  /** Pay360 Fee Percent for a Pay360 user */
  pay360FeePercent?: Maybe<Scalars['Decimal']>;
  /** A pay360 project by the projectCode */
  pay360Project?: Maybe<Pay360Project>;
  /** All Pay360 projects for the expert */
  pay360Projects?: Maybe<Array<Maybe<Pay360Project>>>;
  /** Expert payment information */
  paymentInformation?: Maybe<PaymentInformation>;
  private?: Maybe<Scalars['Boolean']>;
  profile?: Maybe<Profile>;
  /** Profile privacy setting for an expert */
  profilePrivacy?: Maybe<ExpertProfilePrivacy>;
  /** Project count for an expert (closed projects with hired contract for expert) */
  projectCount?: Maybe<Scalars['Int']>;
  receiveProjectInvitationEmail?: Maybe<Scalars['Boolean']>;
  receiveProjectOpportunityEmail?: Maybe<Scalars['Boolean']>;
  /** The consultant's recommended projects that they haven't applied to. In the following order: invited, matched, discipline. */
  recommendedProjects?: Maybe<ProjectConnection>;
  /** Total project count for an expert (all projects with hired contract for expert) */
  totalProjectCount?: Maybe<Scalars['Int']>;
  /** A collection of work history for the consultant. */
  workHistory?: Maybe<WorkHistoryConnection>;
};


export type ConsultantActiveHiredProjectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ConsultantDashboardProjectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  expertStage?: InputMaybe<ExpertStages>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ConsultantHiredProjectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeUnlisted?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ConsultantPay360ProjectArgs = {
  projectCode?: InputMaybe<Scalars['String']>;
};


export type ConsultantRecommendedProjectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ConsultantWorkHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export enum ConsultantBusinessType {
  FullTime = 'FULL_TIME',
  IndependentExpert = 'INDEPENDENT_EXPERT',
  MemberOfFirm = 'MEMBER_OF_FIRM',
  NextSteps = 'NEXT_STEPS'
}

export type Contact = Node & {
  __typename?: 'Contact';
  engagementType?: Maybe<EngagementType>;
  firstname?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  isViewer?: Maybe<Scalars['Boolean']>;
  lastname?: Maybe<Scalars['String']>;
  organisations?: Maybe<Array<Organisation>>;
  profilePicture?: Maybe<ProfilePicture>;
  profileUrl?: Maybe<Scalars['String']>;
};


export type ContactProfilePictureArgs = {
  size: ProfilePictureSize;
};

export type ContactConnection = {
  __typename?: 'ContactConnection';
  edges?: Maybe<Array<Maybe<ContactEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ContactEdge = {
  __typename?: 'ContactEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Contact>;
};

/** A contract is an agreement between a consultant client for work on a project. */
export type Contract = Node & {
  __typename?: 'Contract';
  /** Checks whether the contract is active */
  active?: Maybe<Scalars['Boolean']>;
  /** Checks whether the contract was agreed from both sides */
  agreed?: Maybe<Scalars['Boolean']>;
  agreedDate?: Maybe<Scalars['Timestamp']>;
  allowReimbursements?: Maybe<Scalars['Boolean']>;
  /** The fee agreed to be paid */
  amount?: Maybe<Scalars['Float']>;
  /** Application id for the contract */
  applicationId?: Maybe<Scalars['ID']>;
  approved?: Maybe<Scalars['Boolean']>;
  budgetType?: Maybe<Scalars['String']>;
  budgetUnit?: Maybe<Scalars['String']>;
  /** Can the current user approve this contract? */
  canApprove?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['Timestamp']>;
  currency?: Maybe<Scalars['String']>;
  detail?: Maybe<Scalars['String']>;
  disapproved?: Maybe<Scalars['Boolean']>;
  duration?: Maybe<Scalars['Int']>;
  durationUnit?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Timestamp']>;
  /** Checks whether the contract ended */
  ended?: Maybe<Scalars['Boolean']>;
  /** Checks whether the contract is ending soon */
  endingSoon?: Maybe<Scalars['Boolean']>;
  expensesCovered?: Maybe<Scalars['String']>;
  expert?: Maybe<User>;
  /** The ID of an object */
  id: Scalars['ID'];
  invoiceable?: Maybe<Scalars['Boolean']>;
  /** Fetches the invoicing periods for the contract */
  invoicedPeriods?: Maybe<Array<Maybe<InvoicingPeriod>>>;
  /** Whether this contract is for a LPS/Taska project */
  isLps?: Maybe<Scalars['Boolean']>;
  /** Whether this contract is for a Sourced project */
  isSourced?: Maybe<Scalars['Boolean']>;
  milestones?: Maybe<Scalars['String']>;
  /** Checks whether the contract was sent from an admin for client approval */
  offerInitiatedByAdmin?: Maybe<Scalars['Boolean']>;
  /** The onboarding tasks required before invoices can be processed and paid */
  onboardingChecklist?: Maybe<Array<Maybe<OnboardingTask>>>;
  paymentPolicy?: Maybe<PaymentPolicy>;
  /** All agreed upon or extended contracts related to this contract (in the same series) */
  relatedContracts?: Maybe<Array<Maybe<Contract>>>;
  requiredReceipts?: Maybe<Scalars['Boolean']>;
  review?: Maybe<RatingAndReview>;
  startDate?: Maybe<Scalars['Timestamp']>;
  status?: Maybe<ContractStatus>;
  taxRegion?: Maybe<TaxRegion>;
  /** Terms for the current user (either client or expert) */
  terms?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ContractConnection = {
  __typename?: 'ContractConnection';
  edges?: Maybe<Array<Maybe<ContractEdge>>>;
  pageInfo: PageInfo;
};

export type ContractEdge = {
  __typename?: 'ContractEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Contract>;
};

export type ContractPickerInput = {
  clientMutationId: Scalars['String'];
  endDate: Scalars['NaiveDateTime'];
  projectId: Scalars['ID'];
  startDate: Scalars['NaiveDateTime'];
};

export type ContractPickerPayload = {
  __typename?: 'ContractPickerPayload';
  clientMutationId: Scalars['String'];
  contracts?: Maybe<Array<Maybe<Contract>>>;
};

export enum ContractStatus {
  ProjectContractAgreed = 'PROJECT_CONTRACT_AGREED',
  ProjectContractConsultantOffered = 'PROJECT_CONTRACT_CONSULTANT_OFFERED',
  ProjectContractConsultantOfferedCancelled = 'PROJECT_CONTRACT_CONSULTANT_OFFERED_CANCELLED',
  ProjectContractCounteroffer = 'PROJECT_CONTRACT_COUNTEROFFER',
  ProjectContractDeclined = 'PROJECT_CONTRACT_DECLINED',
  ProjectContractExtended = 'PROJECT_CONTRACT_EXTENDED',
  ProjectContractExtensionAgreed = 'PROJECT_CONTRACT_EXTENSION_AGREED',
  ProjectContractExtensionDeclined = 'PROJECT_CONTRACT_EXTENSION_DECLINED',
  ProjectContractExtensionOffered = 'PROJECT_CONTRACT_EXTENSION_OFFERED',
  ProjectContractModified = 'PROJECT_CONTRACT_MODIFIED',
  ProjectContractOffered = 'PROJECT_CONTRACT_OFFERED',
  ProjectContractOfferedCancelled = 'PROJECT_CONTRACT_OFFERED_CANCELLED',
  ProjectContractVoided = 'PROJECT_CONTRACT_VOIDED'
}

export type ContractingCompany = Node & {
  __typename?: 'ContractingCompany';
  darkLogoUrl?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  lightLogoUrl?: Maybe<Scalars['String']>;
  name?: Maybe<ContractingCompanyName>;
};

export enum ContractingCompanyName {
  LpsNz = 'LPS_NZ',
  NonPayrolled = 'NON_PAYROLLED',
  Payrolled = 'PAYROLLED',
  Sourced = 'SOURCED',
  Taska = 'TASKA'
}

/** A country object. */
export type Country = Node & {
  __typename?: 'Country';
  /** The alpha2 code, e.g. AU for Australia */
  alpha2Code?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  /** The country name, e.g. Australia */
  name?: Maybe<Scalars['String']>;
};

export type CreateAchievementInput = {
  clientMutationId: Scalars['String'];
  description: Scalars['String'];
  endDate?: InputMaybe<Scalars['Date']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  media?: InputMaybe<Array<AchievementMediaInput>>;
  role: Scalars['String'];
  skills?: InputMaybe<Array<SkillInput>>;
  startDate: Scalars['Date'];
  title: Scalars['String'];
};

export type CreateAchievementPayload = {
  __typename?: 'CreateAchievementPayload';
  achievement?: Maybe<Achievement>;
  clientMutationId: Scalars['String'];
};

export type CreateEducationItemInput = {
  clientMutationId: Scalars['String'];
  educationItem?: InputMaybe<EducationItemInput>;
  profileCode: Scalars['String'];
};

export type CreateEducationItemPayload = {
  __typename?: 'CreateEducationItemPayload';
  clientMutationId: Scalars['String'];
  educationItem?: Maybe<EducationItem>;
};

export type CreateFavouriteInput = {
  clientMutationId: Scalars['String'];
  userId: Scalars['ID'];
};

export type CreateFavouritePayload = {
  __typename?: 'CreateFavouritePayload';
  clientMutationId: Scalars['String'];
  user?: Maybe<User>;
};

export type CreateMessageInput = {
  body: Scalars['String'];
  clientMutationId: Scalars['String'];
  recipientId: Scalars['ID'];
  senderId: Scalars['ID'];
};

export type CreateMessagePayload = {
  __typename?: 'CreateMessagePayload';
  clientMutationId: Scalars['String'];
  thread?: Maybe<ThreadEdge>;
};

export type CreateOfferInput = {
  /** Whether reimbursements are allowed */
  allowReimbursements?: InputMaybe<Scalars['Boolean']>;
  /** The amount of currency that will be paid */
  amount?: InputMaybe<Scalars['Float']>;
  /** Project application id */
  applicationId?: InputMaybe<Scalars['ID']>;
  /** The type of budget for this contract */
  budgetType?: InputMaybe<BudgetType>;
  /** The budget unit e.g. per-day */
  budgetUnit?: InputMaybe<BudgetUnit>;
  clientMutationId: Scalars['String'];
  /** Type of currency the payment will be in */
  currency?: InputMaybe<Scalars['String']>;
  /** Additional comments around deliverables, timeframes or fees */
  detail?: InputMaybe<Scalars['String']>;
  /** The length of the contract */
  duration?: InputMaybe<Scalars['String']>;
  /** The unit of length for the contract */
  durationUnit?: InputMaybe<DurationUnit>;
  /** Description of the expenses covered */
  expensesCovered?: InputMaybe<Scalars['String']>;
  /** Deliverables for the contract */
  milestones?: InputMaybe<Scalars['String']>;
  /** The note to send along to the expert with the contract */
  notes?: InputMaybe<Scalars['String']>;
  /** Public code of the client or expert being offered the contract */
  offeredUserCode: Scalars['String'];
  /** Project id of the contract */
  projectId: Scalars['ID'];
  /** If receipts are required to pay for expenses */
  requiredReceipts?: InputMaybe<Scalars['Boolean']>;
  /** Start date for the project */
  startDate: Scalars['NaiveDateTime'];
  /** Title of the contract */
  title: Scalars['String'];
};

export type CreateOfferPayload = {
  __typename?: 'CreateOfferPayload';
  clientMutationId: Scalars['String'];
  contract?: Maybe<Contract>;
};

export type CreateOrganisationInvitationInput = {
  clientMutationId: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type CreateOrganisationInvitationPayload = {
  __typename?: 'CreateOrganisationInvitationPayload';
  clientMutationId: Scalars['String'];
  organisationInvitation?: Maybe<OrganisationInvitation>;
  status?: Maybe<InvitationSentStatus>;
};

export type CreatePay360InvoiceInput = {
  amount: Scalars['Int'];
  clientMutationId: Scalars['String'];
  invoiceFileName?: InputMaybe<Scalars['String']>;
  invoiceFilePath: Scalars['String'];
  projectCode: Scalars['String'];
};

export type CreatePay360InvoicePayload = {
  __typename?: 'CreatePay360InvoicePayload';
  clientMutationId: Scalars['String'];
  pay360Invoice?: Maybe<Pay360Invoice>;
};

export type CreatePay360ProjectInput = {
  clientCompanyAbn?: InputMaybe<Scalars['String']>;
  clientCompanyName: Scalars['String'];
  clientEmail: Scalars['String'];
  clientMutationId: Scalars['String'];
  clientName: Scalars['String'];
  projectName?: InputMaybe<Scalars['String']>;
};

export type CreatePay360ProjectPayload = {
  __typename?: 'CreatePay360ProjectPayload';
  clientMutationId: Scalars['String'];
  pay360Project?: Maybe<Pay360Project>;
};

export type CreateProfileInterestInput = {
  clientMutationId: Scalars['String'];
  interestId: Scalars['ID'];
};

export type CreateProfileInterestPayload = {
  __typename?: 'CreateProfileInterestPayload';
  clientMutationId: Scalars['String'];
  interestId: Scalars['ID'];
};

export type CreateProjectBookmarkInput = {
  clientMutationId: Scalars['String'];
  projectId: Scalars['ID'];
};

export type CreateProjectBookmarkPayload = {
  __typename?: 'CreateProjectBookmarkPayload';
  clientMutationId: Scalars['String'];
  searchProject?: Maybe<SearchProject>;
};

export type CreateProjectInput = {
  clientMutationId: Scalars['String'];
  projectBrief?: InputMaybe<ProjectBriefInput>;
};

export type CreateProjectPageBookmarkInput = {
  clientMutationId: Scalars['String'];
  isPublic: Scalars['Boolean'];
  projectId: Scalars['ID'];
};

export type CreateProjectPageBookmarkPayload = {
  __typename?: 'CreateProjectPageBookmarkPayload';
  clientMutationId: Scalars['String'];
  viewerHasBookmarked?: Maybe<Scalars['Boolean']>;
};

export type CreateProjectPayload = {
  __typename?: 'CreateProjectPayload';
  clientMutationId: Scalars['String'];
  project?: Maybe<Project>;
};

export type CreateSavedSearchInput = {
  form: Scalars['String'];
  formValues: Scalars['Json'];
  name: Scalars['String'];
};

export type CreateSavedSearchPayload = {
  __typename?: 'CreateSavedSearchPayload';
  savedSearch?: Maybe<SavedSearch>;
};

export type CreateWorkItemInput = {
  clientMutationId: Scalars['String'];
  workItem?: InputMaybe<WorkItemInput>;
};

export type CreateWorkItemPayload = {
  __typename?: 'CreateWorkItemPayload';
  clientMutationId: Scalars['String'];
  lifecycle?: Maybe<Lifecycle>;
  workItem?: Maybe<WorkHistory>;
};

export enum Currency {
  Aud = 'AUD',
  Eur = 'EUR',
  Gbp = 'GBP',
  Idr = 'IDR',
  Inr = 'INR',
  Jpy = 'JPY',
  Krw = 'KRW',
  Myr = 'MYR',
  Nzd = 'NZD',
  Php = 'PHP',
  Sgd = 'SGD',
  Thb = 'THB',
  Usd = 'USD',
  Vnd = 'VND'
}

export type CustomFieldDefinition = Node & {
  __typename?: 'CustomFieldDefinition';
  default?: Maybe<Scalars['Json']>;
  description?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<CustomFieldDefinitionType>;
  values?: Maybe<Scalars['Json']>;
};

export enum CustomFieldDefinitionType {
  Date = 'DATE',
  Multiselect = 'MULTISELECT',
  Number = 'NUMBER',
  Select = 'SELECT',
  Switch = 'SWITCH',
  Text = 'TEXT',
  Textarea = 'TEXTAREA'
}

export type CustomFieldValue = Node & {
  __typename?: 'CustomFieldValue';
  definition?: Maybe<CustomFieldDefinition>;
  /** The ID of an object */
  id: Scalars['ID'];
  order?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Json']>;
};

/** Accepts a start and end date */
export type DateRangeInput = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type DeclineExpertApplicationInput = {
  /** Applicant id */
  applicantId?: InputMaybe<Scalars['ID']>;
  clientMutationId: Scalars['String'];
  /** Content */
  content?: InputMaybe<Scalars['String']>;
  /** Application project id */
  projectId?: InputMaybe<Scalars['ID']>;
};

export type DeclineExpertApplicationPayload = {
  __typename?: 'DeclineExpertApplicationPayload';
  application?: Maybe<Application>;
  clientMutationId: Scalars['String'];
};

export type DeclineOfferInput = {
  clientMutationId: Scalars['String'];
  /** Id of the contract */
  contractId: Scalars['ID'];
  /** reason for declining the offer */
  reason: Scalars['String'];
};

export type DeclineOfferPayload = {
  __typename?: 'DeclineOfferPayload';
  clientMutationId: Scalars['String'];
  contract?: Maybe<Contract>;
};

export type DeclinedInvitation = {
  __typename?: 'DeclinedInvitation';
  date?: Maybe<Scalars['Timestamp']>;
};

export type DedicatedContact = {
  __typename?: 'DedicatedContact';
  about?: Maybe<Scalars['String']>;
  chiliPiperUrl?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<ProfilePicture>;
  title?: Maybe<Scalars['String']>;
};


export type DedicatedContactProfilePictureArgs = {
  size: ProfilePictureSize;
};

export type DeleteAchievementInput = {
  achievementId: Scalars['ID'];
  clientMutationId: Scalars['String'];
};

export type DeleteAchievementPayload = {
  __typename?: 'DeleteAchievementPayload';
  achievement?: Maybe<Achievement>;
  clientMutationId: Scalars['String'];
};

export type DeleteDraftInvoiceInput = {
  clientMutationId: Scalars['String'];
  invoiceId: Scalars['ID'];
};

export type DeleteDraftInvoicePayload = {
  __typename?: 'DeleteDraftInvoicePayload';
  clientMutationId: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteEducationItemInput = {
  clientMutationId: Scalars['String'];
  educationItemId: Scalars['ID'];
};

export type DeleteEducationItemPayload = {
  __typename?: 'DeleteEducationItemPayload';
  clientMutationId: Scalars['String'];
  educationItem?: Maybe<EducationItem>;
};

export type DeleteExpertAccountInput = {
  clientMutationId: Scalars['String'];
  improve?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  reasons?: InputMaybe<Array<Scalars['String']>>;
};

export type DeleteExpertAccountPayload = {
  __typename?: 'DeleteExpertAccountPayload';
  clientMutationId: Scalars['String'];
  confirmation?: Maybe<Scalars['Boolean']>;
};

export type DeleteExpertBankAccountInput = {
  bankAccountType?: InputMaybe<BankAccountType>;
  clientMutationId: Scalars['String'];
};

export type DeleteExpertBankAccountPayload = {
  __typename?: 'DeleteExpertBankAccountPayload';
  clientMutationId: Scalars['String'];
  confirmation?: Maybe<Scalars['Boolean']>;
};

export type DeleteProfileInterestInput = {
  clientMutationId: Scalars['String'];
  interestId: Scalars['ID'];
};

export type DeleteProfileInterestPayload = {
  __typename?: 'DeleteProfileInterestPayload';
  clientMutationId: Scalars['String'];
  interestId: Scalars['ID'];
};

export type DeleteSavedSearchInput = {
  id: Scalars['ID'];
};

export type DeleteSavedSearchPayload = {
  __typename?: 'DeleteSavedSearchPayload';
  savedSearch?: Maybe<SavedSearch>;
};

export type DeleteWorkItemInput = {
  clientMutationId: Scalars['String'];
  workItemId: Scalars['ID'];
};

export type DeleteWorkItemPayload = {
  __typename?: 'DeleteWorkItemPayload';
  clientMutationId: Scalars['String'];
  workItem?: Maybe<WorkHistory>;
};

export type Deliverable = Node & {
  __typename?: 'Deliverable';
  amount?: Maybe<Scalars['Decimal']>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['NaiveDateTime']>;
  /** The ID of an object */
  id: Scalars['ID'];
  invoiceOnly?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  paymentInvoiceId?: Maybe<Scalars['Int']>;
};

export type DeliverableInput = {
  amount?: InputMaybe<Scalars['Decimal']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['NaiveDateTime']>;
  invoiceOnly?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
};

export type DisableTotpInput = {
  clientMutationId: Scalars['String'];
  totp?: InputMaybe<Scalars['String']>;
};

export type DisableTotpPayload = {
  __typename?: 'DisableTotpPayload';
  clientMutationId: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
};

export type DisapproveOfferInput = {
  clientMutationId: Scalars['String'];
  /** Id of the contract */
  contractId: Scalars['ID'];
  /** reason for disapproving the offer */
  reason: Scalars['String'];
};

export type DisapproveOfferPayload = {
  __typename?: 'DisapproveOfferPayload';
  clientMutationId: Scalars['String'];
  contract?: Maybe<Contract>;
};

export type Discipline = Node & {
  __typename?: 'Discipline';
  /** The ID of an object */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DisciplineConnection = {
  __typename?: 'DisciplineConnection';
  edges?: Maybe<Array<Maybe<DisciplineEdge>>>;
  pageInfo: PageInfo;
};

export type DisciplineEdge = {
  __typename?: 'DisciplineEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Discipline>;
};

export type DismissInviteModalInput = {
  clientMutationId: Scalars['String'];
};

export type DismissInviteModalPayload = {
  __typename?: 'DismissInviteModalPayload';
  clientMutationId: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
};

export type DismissLatestMilestoneInput = {
  clientMutationId: Scalars['String'];
};

export type DismissLatestMilestonePayload = {
  __typename?: 'DismissLatestMilestonePayload';
  clientMutationId: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
};

export enum DurationUnit {
  Days = 'DAYS',
  Hours = 'HOURS',
  Months = 'MONTHS',
  Weeks = 'WEEKS'
}

export type EditTimesheetInput = {
  clientMutationId: Scalars['String'];
  code?: InputMaybe<Scalars['String']>;
  dateEnd: Scalars['NaiveDateTime'];
  dateStart: Scalars['NaiveDateTime'];
  timesheets?: InputMaybe<Array<InputMaybe<TimesheetInput>>>;
};

export type EditTimesheetPayload = {
  __typename?: 'EditTimesheetPayload';
  clientMutationId: Scalars['String'];
  paymentInvoice?: Maybe<PaymentInvoice>;
};

export type EducationItem = Node & {
  __typename?: 'EducationItem';
  activities?: Maybe<Scalars['String']>;
  degree?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  endYear?: Maybe<Scalars['Int']>;
  fieldOfStudy?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  schoolName?: Maybe<Scalars['String']>;
  startYear?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** Education Item details */
export type EducationItemInput = {
  degree: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  endYear: Scalars['Int'];
  fieldOfStudy: Scalars['String'];
  schoolName: Scalars['String'];
  startYear: Scalars['Int'];
};

export type EnableTotpInput = {
  clientMutationId: Scalars['String'];
  totp?: InputMaybe<Scalars['String']>;
};

export type EnableTotpPayload = {
  __typename?: 'EnableTotpPayload';
  clientMutationId: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
};

/** Interaction engagement types */
export enum EngagementType {
  Hired = 'HIRED',
  Interviewed = 'INTERVIEWED'
}

export type Event = Node & {
  __typename?: 'Event';
  dateEnd?: Maybe<Scalars['Timestamp']>;
  dateStart?: Maybe<Scalars['Timestamp']>;
  /** The ID of an object */
  id: Scalars['ID'];
  type?: Maybe<EventType>;
};

export type EventConnection = {
  __typename?: 'EventConnection';
  edges?: Maybe<Array<Maybe<EventEdge>>>;
  pageInfo: PageInfo;
};

export type EventDateRangeInput = {
  dateEnd: Scalars['String'];
  dateStart: Scalars['String'];
};

export type EventEdge = {
  __typename?: 'EventEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Event>;
};

export type EventMutationOutput = {
  __typename?: 'EventMutationOutput';
  event?: Maybe<Event>;
  status?: Maybe<EventStatus>;
};

export enum EventStatus {
  Deleted = 'DELETED',
  Inserted = 'INSERTED',
  Updated = 'UPDATED'
}

export enum EventType {
  FullTimeAvailable = 'FULL_TIME_AVAILABLE',
  PartTimeAvailable = 'PART_TIME_AVAILABLE',
  Unavailable = 'UNAVAILABLE'
}

export type Expense = {
  __typename?: 'Expense';
  amount?: Maybe<Scalars['Decimal']>;
  date?: Maybe<Scalars['NaiveDateTime']>;
  description?: Maybe<Scalars['String']>;
  gst?: Maybe<Scalars['Decimal']>;
  receiptFileName?: Maybe<Scalars['String']>;
  receiptFileUuid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ExpenseInput = {
  amount: Scalars['Decimal'];
  date: Scalars['NaiveDateTime'];
  description?: InputMaybe<Scalars['String']>;
  gst: Scalars['Decimal'];
  receiptFileName?: InputMaybe<Scalars['String']>;
  receiptFileUuid?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

/** The project or work history item that is relevant experience for the application */
export type ExperienceItem = Project | WorkHistory;

export type Expert = {
  applicationNotes?: InputMaybe<Scalars['String']>;
  disciplineId?: InputMaybe<Scalars['Int']>;
  needsHelpSettingUp?: InputMaybe<Scalars['Boolean']>;
  operatingType?: InputMaybe<OperatingType>;
  registeredBusinessName?: InputMaybe<Scalars['String']>;
  uploadedCv?: InputMaybe<Scalars['String']>;
  workingSituation?: InputMaybe<WorkingSituation>;
};

export type ExpertCompanyInput = {
  companySizes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyStages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ExpertFilterInput = {
  /**
   * Only include experts who are more likely to apply to a project.
   *
   * This is determined from how recently the expert applied to a project,
   * updated their profile, updated availability, etc.
   *
   * Experts who are unavailable for the next 3 months or 'futured' will also be excluded.
   */
  approachable?: InputMaybe<Scalars['Boolean']>;
  /** Name of the primary business service of the expert, eg: "UI/UX" */
  businessService?: InputMaybe<Scalars['String']>;
  /** Only include experts who have claimed their account */
  claimed?: InputMaybe<Scalars['Boolean']>;
  /** Security clearances the expert holds */
  clearances?: InputMaybe<Array<Scalars['String']>>;
  /** Their current contract ends before this date. Use with `currentlyWorking` to exclude Experts that aren't on a contract */
  contractEndsBefore?: InputMaybe<Scalars['String']>;
  /**
   * 2-character country code, eg: "AU", "UK", "FR".
   *
   * Only experts based in the given country will be included in the search results.
   */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Only include Experts that are currently on a contract */
  currentlyWorking?: InputMaybe<Scalars['Boolean']>;
  /** Custom fields and values private cloud experts have */
  customFields?: InputMaybe<Array<Scalars['String']>>;
  /** Name of the primary discipline of the expert, eg: "Corporate Development" */
  discipline?: InputMaybe<Scalars['String']>;
  /** Only include experts who belongs to an expert type */
  expertType?: InputMaybe<Scalars['String']>;
  /** Only include experts who have been favourited */
  favourited?: InputMaybe<Scalars['Boolean']>;
  /** Name of industries the expert has previously worked in, eg: ["Diversified Financial Services"] */
  industries?: InputMaybe<Array<Scalars['String']>>;
  /** Languages an expert speaks eg: ["English", "Japanese"] */
  languages?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Node ID from a Location object.
   *
   * The geo coordinates of the location will be used to find
   * experts within a pre-configured radius of this location.
   */
  locationId?: InputMaybe<Scalars['ID']>;
  /** Names of organisations the expert has previously worked with, eg: ["Bain & Co", "PWC"] */
  organisationNames?: InputMaybe<Array<Scalars['String']>>;
  /** Names of the private clouds the experts are a part of */
  privateClouds?: InputMaybe<Array<Scalars['String']>>;
  /** Limits search results to experts with rate range that overlaps a given rate range. */
  rate?: InputMaybe<ExpertFilterRateInput>;
  /** Names of role title held at previous positions, eg: ["Management Consultant", "Change Manager"] */
  roleTitles?: InputMaybe<Array<Scalars['String']>>;
  /** Free-form search keywords will be matched against the experts profile, work history and skills. */
  searchTerm?: InputMaybe<Scalars['String']>;
  /** Names of required skills, eg: ["Change Management", "Financial Analysis"] */
  skills?: InputMaybe<Array<Scalars['String']>>;
  /** Names of tags, eg: ["Expert360", "NSW"] */
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type ExpertFilterRateInput = {
  currency: Currency;
  rateMax: Scalars['Decimal'];
  rateMin: Scalars['Decimal'];
  unit: ExpertRateUnit;
};

export type ExpertIdealRoleInput = {
  hoursPerWeek?: InputMaybe<Scalars['String']>;
  projectLength?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ExpertIndustryInput = {
  industry?: InputMaybe<Scalars['String']>;
};

export type ExpertInvitation = {
  __typename?: 'ExpertInvitation';
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  invitedBy?: Maybe<InvitedByUser>;
  isValid: Scalars['Boolean'];
  lastname?: Maybe<Scalars['String']>;
  token: Scalars['String'];
};

export type ExpertLocationInput = {
  daysWfh?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  officeLocation?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  order?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  travelDistance?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ExpertOrganisationInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export enum ExpertPaymentStatus {
  Cancelled = 'CANCELLED',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Pending = 'PENDING'
}

export enum ExpertProfilePrivacy {
  Expert360Clients = 'EXPERT360_CLIENTS',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum ExpertRateUnit {
  PerDay = 'PER_DAY',
  PerHour = 'PER_HOUR'
}

export type ExpertSkillInput = {
  classificationSkillId?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Scalars['String']>;
  skillLevel?: InputMaybe<Scalars['String']>;
};

export enum ExpertStages {
  Applied = 'APPLIED',
  Completed = 'COMPLETED',
  Hired = 'HIRED',
  Interviewing = 'INTERVIEWING',
  Invited = 'INVITED',
  Offered = 'OFFERED',
  PastApplied = 'PAST_APPLIED',
  PastInterviewed = 'PAST_INTERVIEWED',
  Saved = 'SAVED'
}

export enum ExpertStatus {
  ApplicationDeclined = 'APPLICATION_DECLINED',
  Applied = 'APPLIED',
  Closed = 'CLOSED',
  ExpertDeclined = 'EXPERT_DECLINED',
  ExpertOfferCancelled = 'EXPERT_OFFER_CANCELLED',
  Hired = 'HIRED',
  InterviewRequested = 'INTERVIEW_REQUESTED',
  Invited = 'INVITED',
  Matched = 'MATCHED',
  OfferCancelled = 'OFFER_CANCELLED',
  OfferModificationReceived = 'OFFER_MODIFICATION_RECEIVED',
  OfferModificationSent = 'OFFER_MODIFICATION_SENT',
  OfferReceived = 'OFFER_RECEIVED',
  OfferSent = 'OFFER_SENT',
  OfferVoided = 'OFFER_VOIDED',
  Suggested = 'SUGGESTED'
}

export type ExpertTitleInput = {
  jobTitle?: InputMaybe<Scalars['String']>;
};

export enum ExpertWorkingRights {
  No = 'NO',
  Unknown = 'UNKNOWN',
  Unsure = 'UNSURE',
  Yes = 'YES'
}

export enum ExtensionProbabilityType {
  High = 'HIGH',
  Low = 'LOW'
}

export type FeedbackSkill = {
  __typename?: 'FeedbackSkill';
  title: Scalars['String'];
};

export type FeedbackSkillRating = {
  __typename?: 'FeedbackSkillRating';
  feedbackSkill: FeedbackSkill;
  rating?: Maybe<Scalars['Float']>;
};

export type FeedbackUserPublic = {
  __typename?: 'FeedbackUserPublic';
  rating?: Maybe<Scalars['Float']>;
  review?: Maybe<Scalars['String']>;
};

export type IdentityVerification = {
  __typename?: 'IdentityVerification';
  /**
   * Whether or not we're still waiting on the verification results.
   *   False if verification hasn't started or already completed
   *   True if verification has started but not yet completed
   */
  awaitingResult?: Maybe<Scalars['Boolean']>;
  /** Whether or not their identity has been verified */
  verified?: Maybe<Scalars['Boolean']>;
};

export type Industry = Node & {
  __typename?: 'Industry';
  /** The ID of an object */
  id: Scalars['ID'];
  isHidden?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['Int']>;
  parentName?: Maybe<Scalars['String']>;
};

export type IndustryConnection = {
  __typename?: 'IndustryConnection';
  edges?: Maybe<Array<Maybe<IndustryEdge>>>;
  pageInfo: PageInfo;
};

export type IndustryEdge = {
  __typename?: 'IndustryEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Industry>;
};

export type IndustryInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type InitTotpSetupInput = {
  clientMutationId: Scalars['String'];
};

export type InitTotpSetupPayload = {
  __typename?: 'InitTotpSetupPayload';
  clientMutationId: Scalars['String'];
  secret?: Maybe<Scalars['String']>;
  totpUri?: Maybe<Scalars['String']>;
};

export type InsuranceInformation = {
  __typename?: 'InsuranceInformation';
  hasInsurance?: Maybe<Scalars['Boolean']>;
  professionalIndemnityLimitInMillion?: Maybe<Scalars['Int']>;
  publicLiabilityLimitInMillion?: Maybe<Scalars['Int']>;
  workersCompensationCover?: Maybe<Scalars['Boolean']>;
};

export type Interest = Node & {
  __typename?: 'Interest';
  /** The ID of an object */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type InterestConnection = {
  __typename?: 'InterestConnection';
  edges?: Maybe<Array<Maybe<InterestEdge>>>;
  pageInfo: PageInfo;
};

export type InterestEdge = {
  __typename?: 'InterestEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Interest>;
};

export enum InvitationMessageStatus {
  Accepted = 'ACCEPTED',
  Completed = 'COMPLETED',
  Invited = 'INVITED',
  Sent = 'SENT'
}

export enum InvitationSentStatus {
  New = 'NEW',
  Resent = 'RESENT'
}

export type InviteExpertToInterviewInput = {
  /** Applicant id */
  applicantId?: InputMaybe<Scalars['ID']>;
  clientMutationId: Scalars['String'];
  /** Application project id */
  projectId?: InputMaybe<Scalars['ID']>;
};

export type InviteExpertToInterviewPayload = {
  __typename?: 'InviteExpertToInterviewPayload';
  application?: Maybe<Application>;
  clientMutationId: Scalars['String'];
};

export type InviteToProjectInput = {
  clientMutationId: Scalars['String'];
  projectId: Scalars['String'];
  publicCode: Scalars['String'];
};

export type InviteToProjectPayload = {
  __typename?: 'InviteToProjectPayload';
  clientMutationId: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  projectCode?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type InvitedByUser = {
  __typename?: 'InvitedByUser';
  firstname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  phoneMobile?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<ProfilePicture>;
};


export type InvitedByUserProfilePictureArgs = {
  size: ProfilePictureSize;
};

export type Invoice = Node & {
  __typename?: 'Invoice';
  amount?: Maybe<Scalars['Decimal']>;
  dateEnd?: Maybe<Scalars['NaiveDateTime']>;
  dateStart?: Maybe<Scalars['NaiveDateTime']>;
  /** The ID of an object */
  id: Scalars['ID'];
  invoiceOnlyDeliverables?: Maybe<Array<Maybe<Deliverable>>>;
};

export type InvoiceInput = {
  budgetUnit?: InputMaybe<Scalars['String']>;
  clientName?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  contractId?: InputMaybe<Scalars['ID']>;
  currency?: InputMaybe<Scalars['String']>;
  dateEnd: Scalars['NaiveDateTime'];
  dateStart: Scalars['NaiveDateTime'];
  deliverables?: InputMaybe<Array<InputMaybe<DeliverableInput>>>;
  expenses?: InputMaybe<Array<InputMaybe<ExpenseInput>>>;
  expertPaymentTermDays?: InputMaybe<Scalars['Int']>;
  finalInvoice?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceAs?: InputMaybe<Scalars['String']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  paymentTermsType?: InputMaybe<PaymentTermsType>;
  projectId: Scalars['ID'];
  projectType?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['Decimal']>;
  remoteId?: InputMaybe<Scalars['String']>;
  timesheets?: InputMaybe<Array<InputMaybe<TimesheetInput>>>;
  totalAmount?: InputMaybe<Scalars['Decimal']>;
};

export enum InvoiceStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Invalid = 'INVALID',
  Invoiced = 'INVOICED',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Pending = 'PENDING',
  Submitted = 'SUBMITTED',
  TimesheetRejected = 'TIMESHEET_REJECTED'
}

export type InvoicingPeriod = {
  __typename?: 'InvoicingPeriod';
  dateEnd?: Maybe<Scalars['NaiveDateTime']>;
  dateStart?: Maybe<Scalars['NaiveDateTime']>;
};

export type Language = Node & {
  __typename?: 'Language';
  /** The ID of an object */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum LanguageProficiency {
  Advanced = 'ADVANCED',
  Beginner = 'BEGINNER',
  Fluent = 'FLUENT',
  Intermediate = 'INTERMEDIATE',
  Native = 'NATIVE'
}

export type LatestMilestone = {
  __typename?: 'LatestMilestone';
  name?: Maybe<MilestoneName>;
  /** The hash of the project the milestone is related to */
  projectHash?: Maybe<Scalars['String']>;
};

export type LegacyApplication = Node & {
  __typename?: 'LegacyApplication';
  dateSubmitted?: Maybe<Scalars['Timestamp']>;
  /** The ID of an object */
  id: Scalars['ID'];
  summary?: Maybe<Scalars['String']>;
};

export type LegacyApplicationConnection = {
  __typename?: 'LegacyApplicationConnection';
  edges?: Maybe<Array<Maybe<LegacyApplicationEdge>>>;
  pageInfo: PageInfo;
};

export type LegacyApplicationEdge = {
  __typename?: 'LegacyApplicationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<LegacyApplication>;
};

export type LegacyLocation = Node & {
  __typename?: 'LegacyLocation';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  subdivision?: Maybe<Scalars['String']>;
};

export type LegacyLocationConnection = {
  __typename?: 'LegacyLocationConnection';
  edges?: Maybe<Array<Maybe<LegacyLocationEdge>>>;
  pageInfo: PageInfo;
};

export type LegacyLocationEdge = {
  __typename?: 'LegacyLocationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<LegacyLocation>;
};

export type LegacyOrganisation = Node & {
  __typename?: 'LegacyOrganisation';
  /** The ID of an object */
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type LegacyOrganisationConnection = {
  __typename?: 'LegacyOrganisationConnection';
  edges?: Maybe<Array<Maybe<LegacyOrganisationEdge>>>;
  pageInfo: PageInfo;
};

export type LegacyOrganisationEdge = {
  __typename?: 'LegacyOrganisationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<LegacyOrganisation>;
};

export type Lifecycle = Node & {
  __typename?: 'Lifecycle';
  accepted?: Maybe<Scalars['Boolean']>;
  applicationCompleted?: Maybe<Scalars['Boolean']>;
  applicationStep?: Maybe<ApplicationSteps>;
  basicProfileCompleted?: Maybe<Scalars['Boolean']>;
  claimed?: Maybe<Scalars['Boolean']>;
  declined?: Maybe<Scalars['Boolean']>;
  emailVerified?: Maybe<Scalars['Boolean']>;
  futured?: Maybe<Scalars['Boolean']>;
  /** The ID of an object */
  id: Scalars['ID'];
  locked?: Maybe<Scalars['Boolean']>;
  marketplaceMember?: Maybe<Scalars['Boolean']>;
  moreInfoRequired?: Maybe<Scalars['Boolean']>;
  privateCloudTalent?: Maybe<Scalars['Boolean']>;
};

export enum LifecycleModifier {
  ApplicationsPaused = 'APPLICATIONS_PAUSED',
  OnHold = 'ON_HOLD'
}

export enum LifecycleStatus {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Hired = 'HIRED',
  Open = 'OPEN'
}

export type LocationAddress = {
  __typename?: 'LocationAddress';
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Int']>;
  postCode?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
};

export type LocationInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type MarkAllNotificationsAsReadInput = {
  clientMutationId: Scalars['String'];
};

export type MarkAllNotificationsAsReadPayload = {
  __typename?: 'MarkAllNotificationsAsReadPayload';
  clientMutationId: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
};

export type Message = Node & {
  __typename?: 'Message';
  body?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  read: Scalars['Boolean'];
  recipient?: Maybe<Contact>;
  sender?: Maybe<Contact>;
};

export enum MessageStatus {
  New = 'NEW',
  RepliedToYou = 'REPLIED_TO_YOU'
}

export enum MilestoneName {
  ApplicationCompleted = 'APPLICATION_COMPLETED',
  Counteroffered = 'COUNTEROFFERED',
  CvUploaded = 'CV_UPLOADED',
  Extended = 'EXTENDED',
  GettingStarted = 'GETTING_STARTED',
  Hired = 'HIRED',
  Modified = 'MODIFIED',
  Offered = 'OFFERED',
  ScreeningBooked = 'SCREENING_BOOKED',
  ScreeningSkipped = 'SCREENING_SKIPPED'
}

export type ModifyOfferInput = {
  /** Whether reimbursements are allowed */
  allowReimbursements?: InputMaybe<Scalars['Boolean']>;
  /** The amount of currency that will be paid */
  amount?: InputMaybe<Scalars['Float']>;
  /** The type of budget for this contract */
  budgetType?: InputMaybe<BudgetType>;
  /** The budget unit e.g. per-day */
  budgetUnit?: InputMaybe<BudgetUnit>;
  clientMutationId: Scalars['String'];
  /** Id of the contract */
  contractId: Scalars['ID'];
  /** Type of currency the payment will be in */
  currency?: InputMaybe<Scalars['String']>;
  /** Additional comments around deliverables, timeframes or fees */
  detail?: InputMaybe<Scalars['String']>;
  /** The length of the contract */
  duration?: InputMaybe<Scalars['String']>;
  /** The unit of length for the contract */
  durationUnit?: InputMaybe<DurationUnit>;
  /** Description of the expenses covered */
  expensesCovered?: InputMaybe<Scalars['String']>;
  /** Deliverables for the contract */
  milestones?: InputMaybe<Scalars['String']>;
  /** The note to send along to the expert with the contract */
  notes?: InputMaybe<Scalars['String']>;
  /** If receipts are required to pay for expenses */
  requiredReceipts?: InputMaybe<Scalars['Boolean']>;
  /** Start date for the project */
  startDate: Scalars['NaiveDateTime'];
  /** Title of the contract */
  title: Scalars['String'];
};

export type ModifyOfferPayload = {
  __typename?: 'ModifyOfferPayload';
  clientMutationId: Scalars['String'];
  contract?: Maybe<Contract>;
};

/** Mutations */
export type Mutation = {
  __typename?: 'Mutation';
  /** Accept an invitation as an Expert */
  acceptExpertInvitation?: Maybe<AcceptExpertInvitationPayload>;
  /** Accept a contract offer */
  acceptOffer?: Maybe<AcceptOfferPayload>;
  /** Accept a private invite to a cloud */
  acceptOrganisationInvitation?: Maybe<AcceptOrganisationInvitationPayload>;
  /** Activate project */
  activateProject?: Maybe<ActivateProjectPayload>;
  /** Persist selected experience for an application */
  addApplicationExperience?: Maybe<AddApplicationExperiencePayload>;
  /** Marks project application as viewed */
  addApplicationViewedInteraction?: Maybe<AddApplicationViewedInteractionPayload>;
  /** Add consultant availability */
  addAvailabilityEvent?: Maybe<AddAvailabilityEventPayload>;
  /** add an expert bank account */
  addExpertBankAccount?: Maybe<AddExpertBankAccountPayload>;
  /** Submit invitation to project as admin */
  adminInviteToProject?: Maybe<AdminInviteToProjectPayload>;
  /** Anonymously approve an contract that will be offered to an expert (payload received via email) */
  approveContractOffer?: Maybe<ApproveContractOfferPayload>;
  /** Approves a contract offer */
  approveOffer?: Maybe<ApproveOfferPayload>;
  /** Submit mutation to cancel a project */
  cancelProject?: Maybe<CancelProjectPayload>;
  claimMindTheGap?: Maybe<ClaimMindTheGapPayload>;
  /** Delete all education items on an Expert profile */
  clearEducationItems?: Maybe<ClearEducationItemsPayload>;
  /** Delete all work items on an Expert profile */
  clearWorkItems?: Maybe<ClearWorkItemsPayload>;
  /** Mark the Expert's application as completed */
  completeApplication?: Maybe<CompleteApplicationPayload>;
  /** Anonymously confirm an expert receiving project opportunity emails (payload received via email) */
  confirmProjectOpportunityEmail?: Maybe<ConfirmProjectOpportunityEmailPayload>;
  /** Get a list of contracts for a project between two dates */
  contractPicker?: Maybe<ContractPickerPayload>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createAchievement?: Maybe<CreateAchievementPayload>;
  /** Create an Education Item on Profile */
  createEducationItem?: Maybe<CreateEducationItemPayload>;
  /** Add the specified user to the viewer's favourites */
  createFavourite?: Maybe<CreateFavouritePayload>;
  /** Create a direct message between the current user and contact */
  createMessage?: Maybe<CreateMessagePayload>;
  /** Create a contract offer */
  createOffer?: Maybe<CreateOfferPayload>;
  /** Invite a user to an organisation */
  createOrganisationInvitation?: Maybe<CreateOrganisationInvitationPayload>;
  /** Create Pay360 invoice */
  createPay360Invoice?: Maybe<CreatePay360InvoicePayload>;
  /** Create Pay360 project */
  createPay360Project?: Maybe<CreatePay360ProjectPayload>;
  /** Add the specified interest to the user's profile */
  createProfileInterest?: Maybe<CreateProfileInterestPayload>;
  /** Submit mutation to create project */
  createProject?: Maybe<CreateProjectPayload>;
  /** Add the specified project to the viewer's bookmarks */
  createProjectBookmark?: Maybe<CreateProjectBookmarkPayload>;
  /** Add the specified project to the viewer's bookmarks - only used on project page */
  createProjectPageBookmark?: Maybe<CreateProjectPageBookmarkPayload>;
  createSavedSearch?: Maybe<CreateSavedSearchPayload>;
  /** Create a work item on an Expert profile */
  createWorkItem?: Maybe<CreateWorkItemPayload>;
  /** Inserts expert declined interaction */
  declineExpertApplication?: Maybe<DeclineExpertApplicationPayload>;
  /** Decline a contract offer */
  declineOffer?: Maybe<DeclineOfferPayload>;
  deleteAchievement?: Maybe<DeleteAchievementPayload>;
  deleteDraftInvoice?: Maybe<DeleteDraftInvoicePayload>;
  /** Delete an Education Item on Profile */
  deleteEducationItem?: Maybe<DeleteEducationItemPayload>;
  /** delete an expert account */
  deleteExpertAccount?: Maybe<DeleteExpertAccountPayload>;
  /** delete an expert bank account */
  deleteExpertBankAccount?: Maybe<DeleteExpertBankAccountPayload>;
  /** Delete an user interest on profile */
  deleteProfileInterest?: Maybe<DeleteProfileInterestPayload>;
  deleteSavedSearch?: Maybe<DeleteSavedSearchPayload>;
  /** Delete a work item on an Expert profile */
  deleteWorkItem?: Maybe<DeleteWorkItemPayload>;
  /** Disable TOTP, you must send a valid TOTP code to disable it */
  disableTotp?: Maybe<DisableTotpPayload>;
  /** Disapproves a contract offer */
  disapproveOffer?: Maybe<DisapproveOfferPayload>;
  /** Clears the 'displayInviteWelcome' flag on the Viewer */
  dismissInviteModal?: Maybe<DismissInviteModalPayload>;
  /** Marks all the user's notifications as read */
  dismissLatestMilestone?: Maybe<DismissLatestMilestonePayload>;
  /** Edit an invoice's timesheet */
  editTimesheet?: Maybe<EditTimesheetPayload>;
  /** Enables TOTP using the secret previously returned by initTotpSetup. You must call initTotpSetup first or this will fail. */
  enableTotp?: Maybe<EnableTotpPayload>;
  /** Creates and returns a new secret so the user can setup their TOTP */
  initTotpSetup?: Maybe<InitTotpSetupPayload>;
  /** Inserts interviewed interaction and sends emails to client and expert */
  inviteExpertToInterview?: Maybe<InviteExpertToInterviewPayload>;
  /** Submit invitation to project as client */
  inviteToProject?: Maybe<InviteToProjectPayload>;
  isDefault?: Maybe<Scalars['Int']>;
  /** Marks all the user's notifications as read */
  markAllNotificationsAsRead?: Maybe<MarkAllNotificationsAsReadPayload>;
  /** Modify a contract offer */
  modifyOffer?: Maybe<ModifyOfferPayload>;
  /** Submit mutation to onhold a project */
  onholdProject?: Maybe<OnholdProjectPayload>;
  /** Anonymously opt out of project (invitation/opportunity) emails (payload received via email) */
  optOutProjectEmail?: Maybe<OptOutProjectEmailPayload>;
  /** Create an account for a new private cloud invitee */
  organisationInvitationCreateAccount?: Maybe<OrganisationInvitationCreateAccountPayload>;
  /** Submit mutation to pause a project */
  pauseProject?: Maybe<PauseProjectPayload>;
  postCode?: Maybe<Scalars['String']>;
  /** Associates uploaded working rights documents with an expert */
  provideWorkingRightsDocuments?: Maybe<ProvideWorkingRightsDocumentsPayload>;
  /** Submit mutation to publish a project */
  publishProject?: Maybe<PublishProjectPayload>;
  /** Qualify Pay360 User */
  qualifyPay360User?: Maybe<QualifyPay360UserPayload>;
  /** Remove the specified user from the viewer's favourites */
  removeFavourite?: Maybe<RemoveFavouritePayload>;
  /** Remove the specified project from the viewer's bookmarks */
  removeProjectBookmark?: Maybe<RemoveProjectBookmarkPayload>;
  /** Remove the specified project from the viewer's bookmarks - only used on project page */
  removeProjectPageBookmark?: Maybe<RemoveProjectPageBookmarkPayload>;
  removeSavedBookmark?: Maybe<RemoveSavedBookmarkPayload>;
  renameSavedSearch?: Maybe<RenameSavedSearchPayload>;
  /** request password reset */
  requestPasswordReset?: Maybe<RequestPasswordResetPayload>;
  /** Send email to request resource */
  requestResource?: Maybe<RequestResourcePayload>;
  /** Resend fast apply email based on previous interaction */
  resendFastApplyEmail?: Maybe<ResendFastApplyEmailPayload>;
  /** Resend organisation invitation */
  resendOrganisationInvitation?: Maybe<ResendOrganisationInvitationPayload>;
  /** Review a timesheet associated with an invoice */
  reviewTimesheet?: Maybe<ReviewTimesheetPayload>;
  /** Review a timesheet associated with an invoice anonymously */
  reviewTimesheetAnonymously?: Maybe<ReviewTimesheetAnonymouslyPayload>;
  sendVerifyEmail?: Maybe<SendVerifyEmailPayload>;
  sendVerifySms?: Maybe<SendVerifySmsPayload>;
  /** Start user verification */
  startUserVerification?: Maybe<StartUserVerificationPayload>;
  stateCode?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  /** Submit an application to a project */
  submitApplication?: Maybe<SubmitApplicationPayload>;
  /** Submit decline invitation */
  submitDeclineInvitation?: Maybe<SubmitDeclineInvitationPayload>;
  /** submit expert application */
  submitExpertApplication?: Maybe<SubmitExpertApplicationPayload>;
  /** submit expert preferred company */
  submitExpertCompanies?: Maybe<SubmitExpertCompaniesPayload>;
  /** Submit expert ideal role */
  submitExpertIdealRole?: Maybe<SubmitExpertIdealRolePayload>;
  /** submit expert industries */
  submitExpertIndustries?: Maybe<SubmitExpertIndustriesPayload>;
  /** submit expert job titles */
  submitExpertJobTitles?: Maybe<SubmitExpertJobTitlesPayload>;
  /** submit expert locations */
  submitExpertLocations?: Maybe<SubmitExpertLocationsPayload>;
  /** submit expert top skills */
  submitExpertTopSkills?: Maybe<SubmitExpertTopSkillsPayload>;
  /** Provide consultant insurance declaration */
  submitInsuranceDeclaration?: Maybe<SubmitInsuranceDeclarationPayload>;
  /** Submit an invoice */
  submitInvoice?: Maybe<SubmitInvoicePayload>;
  /** Submit an invoice */
  submitMultiInvoice?: Maybe<SubmitMultiInvoicePayload>;
  /** Provide consultant working_rights declaration */
  submitWorkingRightsDeclaration?: Maybe<SubmitWorkingRightsDeclarationPayload>;
  suburb?: Maybe<Scalars['String']>;
  /** Submit mutation to unpause a project */
  unpauseProject?: Maybe<UnpauseProjectPayload>;
  updateAchievement?: Maybe<UpdateAchievementPayload>;
  /** Update an Education Item on Profile */
  updateEducationItem?: Maybe<UpdateEducationItemPayload>;
  /** Submit mutation to update expert */
  updateExpert?: Maybe<UpdateExpertPayload>;
  /** Update additional_roles on expert profile */
  updateExpertAdditionalRoles?: Maybe<UpdateExpertAdditionalRolesPayload>;
  /** Submit mutation to update an expert's availability, saved to user_expert_availability table */
  updateExpertAvailability?: Maybe<UpdateExpertAvailabilityPayload>;
  /** Submit mutation to update an expert's business details */
  updateExpertBusinessDetails?: Maybe<UpdateExpertBusinessDetailsPayload>;
  /** Update an Expert's Business Service */
  updateExpertBusinessService?: Maybe<UpdateExpertBusinessServicePayload>;
  updateExpertCommunicationPreference?: Maybe<UpdateExpertCommunicationPreferencePayload>;
  /** Submit mutation to update an expert's contact details */
  updateExpertContactDetails?: Maybe<UpdateExpertContactDetailsPayload>;
  /** Update the insurance settings for an expert */
  updateExpertInsuranceDeclaration?: Maybe<UpdateExpertInsuranceDeclarationPayload>;
  updateExpertLanguages?: Maybe<UpdateExpertLanguagesPayload>;
  /** Update an expert's payment information */
  updateExpertPaymentInformation?: Maybe<UpdateExpertPaymentInformationPayload>;
  /** Updates the rate ranges for an expert */
  updateExpertRates?: Maybe<UpdateExpertRatesPayload>;
  /** Submit mutation to update expert */
  updateExpertTaxSettings?: Maybe<UpdateExpertTaxSettingsPayload>;
  /** Update an Organisation's details */
  updateOrganisationDetails?: Maybe<UpdateOrganisationDetailsPayload>;
  /** update password */
  updatePassword?: Maybe<UpdatePasswordPayload>;
  /** Submit mutation to update profile */
  updateProfile?: Maybe<UpdateProfilePayload>;
  /** Submit mutation to edit a project */
  updateProject?: Maybe<UpdateProjectPayload>;
  /** Update skills on expert profile */
  updateSkills?: Maybe<UpdateSkillsPayload>;
  /** Update a work item on an Expert profile */
  updateWorkItem?: Maybe<UpdateWorkItemPayload>;
  verifyEmail?: Maybe<VerifyEmailPayload>;
  verifySms?: Maybe<VerifySmsPayload>;
};


/** Mutations */
export type MutationAcceptExpertInvitationArgs = {
  input: AcceptExpertInvitationInput;
};


/** Mutations */
export type MutationAcceptOfferArgs = {
  input: AcceptOfferInput;
};


/** Mutations */
export type MutationAcceptOrganisationInvitationArgs = {
  input: AcceptOrganisationInvitationInput;
};


/** Mutations */
export type MutationActivateProjectArgs = {
  input: ActivateProjectInput;
};


/** Mutations */
export type MutationAddApplicationExperienceArgs = {
  input: AddApplicationExperienceInput;
};


/** Mutations */
export type MutationAddApplicationViewedInteractionArgs = {
  input: AddApplicationViewedInteractionInput;
};


/** Mutations */
export type MutationAddAvailabilityEventArgs = {
  input: AddAvailabilityEventInput;
};


/** Mutations */
export type MutationAddExpertBankAccountArgs = {
  input: AddExpertBankAccountInput;
};


/** Mutations */
export type MutationAdminInviteToProjectArgs = {
  input: AdminInviteToProjectInput;
};


/** Mutations */
export type MutationApproveContractOfferArgs = {
  input: ApproveContractOfferInput;
};


/** Mutations */
export type MutationApproveOfferArgs = {
  input: ApproveOfferInput;
};


/** Mutations */
export type MutationCancelProjectArgs = {
  input: CancelProjectInput;
};


/** Mutations */
export type MutationClaimMindTheGapArgs = {
  input: ClaimMindTheGapInput;
};


/** Mutations */
export type MutationCompleteApplicationArgs = {
  input: CompleteApplicationInput;
};


/** Mutations */
export type MutationConfirmProjectOpportunityEmailArgs = {
  input: ConfirmProjectOpportunityEmailInput;
};


/** Mutations */
export type MutationContractPickerArgs = {
  input: ContractPickerInput;
};


/** Mutations */
export type MutationCreateAchievementArgs = {
  input: CreateAchievementInput;
};


/** Mutations */
export type MutationCreateEducationItemArgs = {
  input: CreateEducationItemInput;
};


/** Mutations */
export type MutationCreateFavouriteArgs = {
  input: CreateFavouriteInput;
};


/** Mutations */
export type MutationCreateMessageArgs = {
  input: CreateMessageInput;
};


/** Mutations */
export type MutationCreateOfferArgs = {
  input: CreateOfferInput;
};


/** Mutations */
export type MutationCreateOrganisationInvitationArgs = {
  input: CreateOrganisationInvitationInput;
};


/** Mutations */
export type MutationCreatePay360InvoiceArgs = {
  input: CreatePay360InvoiceInput;
};


/** Mutations */
export type MutationCreatePay360ProjectArgs = {
  input: CreatePay360ProjectInput;
};


/** Mutations */
export type MutationCreateProfileInterestArgs = {
  input: CreateProfileInterestInput;
};


/** Mutations */
export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


/** Mutations */
export type MutationCreateProjectBookmarkArgs = {
  input: CreateProjectBookmarkInput;
};


/** Mutations */
export type MutationCreateProjectPageBookmarkArgs = {
  input: CreateProjectPageBookmarkInput;
};


/** Mutations */
export type MutationCreateSavedSearchArgs = {
  input: CreateSavedSearchInput;
};


/** Mutations */
export type MutationCreateWorkItemArgs = {
  input: CreateWorkItemInput;
};


/** Mutations */
export type MutationDeclineExpertApplicationArgs = {
  input: DeclineExpertApplicationInput;
};


/** Mutations */
export type MutationDeclineOfferArgs = {
  input: DeclineOfferInput;
};


/** Mutations */
export type MutationDeleteAchievementArgs = {
  input: DeleteAchievementInput;
};


/** Mutations */
export type MutationDeleteDraftInvoiceArgs = {
  input: DeleteDraftInvoiceInput;
};


/** Mutations */
export type MutationDeleteEducationItemArgs = {
  input: DeleteEducationItemInput;
};


/** Mutations */
export type MutationDeleteExpertAccountArgs = {
  input: DeleteExpertAccountInput;
};


/** Mutations */
export type MutationDeleteExpertBankAccountArgs = {
  input: DeleteExpertBankAccountInput;
};


/** Mutations */
export type MutationDeleteProfileInterestArgs = {
  input: DeleteProfileInterestInput;
};


/** Mutations */
export type MutationDeleteSavedSearchArgs = {
  input: DeleteSavedSearchInput;
};


/** Mutations */
export type MutationDeleteWorkItemArgs = {
  input: DeleteWorkItemInput;
};


/** Mutations */
export type MutationDisableTotpArgs = {
  input: DisableTotpInput;
};


/** Mutations */
export type MutationDisapproveOfferArgs = {
  input: DisapproveOfferInput;
};


/** Mutations */
export type MutationDismissInviteModalArgs = {
  input: DismissInviteModalInput;
};


/** Mutations */
export type MutationDismissLatestMilestoneArgs = {
  input: DismissLatestMilestoneInput;
};


/** Mutations */
export type MutationEditTimesheetArgs = {
  input: EditTimesheetInput;
};


/** Mutations */
export type MutationEnableTotpArgs = {
  input: EnableTotpInput;
};


/** Mutations */
export type MutationInitTotpSetupArgs = {
  input: InitTotpSetupInput;
};


/** Mutations */
export type MutationInviteExpertToInterviewArgs = {
  input: InviteExpertToInterviewInput;
};


/** Mutations */
export type MutationInviteToProjectArgs = {
  input: InviteToProjectInput;
};


/** Mutations */
export type MutationMarkAllNotificationsAsReadArgs = {
  input: MarkAllNotificationsAsReadInput;
};


/** Mutations */
export type MutationModifyOfferArgs = {
  input: ModifyOfferInput;
};


/** Mutations */
export type MutationOnholdProjectArgs = {
  input: OnholdProjectInput;
};


/** Mutations */
export type MutationOptOutProjectEmailArgs = {
  input: OptOutProjectEmailInput;
};


/** Mutations */
export type MutationOrganisationInvitationCreateAccountArgs = {
  input: OrganisationInvitationCreateAccountInput;
};


/** Mutations */
export type MutationPauseProjectArgs = {
  input: PauseProjectInput;
};


/** Mutations */
export type MutationProvideWorkingRightsDocumentsArgs = {
  input: ProvideWorkingRightsDocumentsInput;
};


/** Mutations */
export type MutationPublishProjectArgs = {
  input: PublishProjectInput;
};


/** Mutations */
export type MutationQualifyPay360UserArgs = {
  input: QualifyPay360UserInput;
};


/** Mutations */
export type MutationRemoveFavouriteArgs = {
  input: RemoveFavouriteInput;
};


/** Mutations */
export type MutationRemoveProjectBookmarkArgs = {
  input: RemoveProjectBookmarkInput;
};


/** Mutations */
export type MutationRemoveProjectPageBookmarkArgs = {
  input: RemoveProjectPageBookmarkInput;
};


/** Mutations */
export type MutationRemoveSavedBookmarkArgs = {
  input: RemoveSavedBookmarkInput;
};


/** Mutations */
export type MutationRenameSavedSearchArgs = {
  input: RenameSavedSearchInput;
};


/** Mutations */
export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};


/** Mutations */
export type MutationRequestResourceArgs = {
  input: RequestResourceInput;
};


/** Mutations */
export type MutationResendFastApplyEmailArgs = {
  input: ResendFastApplyEmailInput;
};


/** Mutations */
export type MutationResendOrganisationInvitationArgs = {
  input: ResendOrganisationInvitationInput;
};


/** Mutations */
export type MutationReviewTimesheetArgs = {
  input: ReviewTimesheetInput;
};


/** Mutations */
export type MutationReviewTimesheetAnonymouslyArgs = {
  input: ReviewTimesheetAnonymouslyInput;
};


/** Mutations */
export type MutationSendVerifyEmailArgs = {
  input: SendVerifyEmailInput;
};


/** Mutations */
export type MutationSendVerifySmsArgs = {
  input: SendVerifySmsInput;
};


/** Mutations */
export type MutationStartUserVerificationArgs = {
  input: StartUserVerificationInput;
};


/** Mutations */
export type MutationSubmitApplicationArgs = {
  input: SubmitApplicationInput;
};


/** Mutations */
export type MutationSubmitDeclineInvitationArgs = {
  input: SubmitDeclineInvitationInput;
};


/** Mutations */
export type MutationSubmitExpertApplicationArgs = {
  input: SubmitExpertApplicationInput;
};


/** Mutations */
export type MutationSubmitExpertCompaniesArgs = {
  input: SubmitExpertCompaniesInput;
};


/** Mutations */
export type MutationSubmitExpertIdealRoleArgs = {
  input: SubmitExpertIdealRoleInput;
};


/** Mutations */
export type MutationSubmitExpertIndustriesArgs = {
  input: SubmitExpertIndustriesInput;
};


/** Mutations */
export type MutationSubmitExpertJobTitlesArgs = {
  input: SubmitExpertJobTitlesInput;
};


/** Mutations */
export type MutationSubmitExpertLocationsArgs = {
  input: SubmitExpertLocationsInput;
};


/** Mutations */
export type MutationSubmitExpertTopSkillsArgs = {
  input: SubmitExpertTopSkillsInput;
};


/** Mutations */
export type MutationSubmitInsuranceDeclarationArgs = {
  input: SubmitInsuranceDeclarationInput;
};


/** Mutations */
export type MutationSubmitInvoiceArgs = {
  input: SubmitInvoiceInput;
};


/** Mutations */
export type MutationSubmitMultiInvoiceArgs = {
  input: SubmitMultiInvoiceInput;
};


/** Mutations */
export type MutationSubmitWorkingRightsDeclarationArgs = {
  input: SubmitWorkingRightsDeclarationInput;
};


/** Mutations */
export type MutationUnpauseProjectArgs = {
  input: UnpauseProjectInput;
};


/** Mutations */
export type MutationUpdateAchievementArgs = {
  input: UpdateAchievementInput;
};


/** Mutations */
export type MutationUpdateEducationItemArgs = {
  input: UpdateEducationItemInput;
};


/** Mutations */
export type MutationUpdateExpertArgs = {
  input: UpdateExpertInput;
};


/** Mutations */
export type MutationUpdateExpertAdditionalRolesArgs = {
  input: UpdateExpertAdditionalRolesInput;
};


/** Mutations */
export type MutationUpdateExpertAvailabilityArgs = {
  input: UpdateExpertAvailabilityInput;
};


/** Mutations */
export type MutationUpdateExpertBusinessDetailsArgs = {
  input: UpdateExpertBusinessDetailsInput;
};


/** Mutations */
export type MutationUpdateExpertBusinessServiceArgs = {
  input: UpdateExpertBusinessServiceInput;
};


/** Mutations */
export type MutationUpdateExpertCommunicationPreferenceArgs = {
  input: UpdateExpertCommunicationPreferenceInput;
};


/** Mutations */
export type MutationUpdateExpertContactDetailsArgs = {
  input: UpdateExpertContactDetailsInput;
};


/** Mutations */
export type MutationUpdateExpertInsuranceDeclarationArgs = {
  input: UpdateExpertInsuranceDeclarationInput;
};


/** Mutations */
export type MutationUpdateExpertLanguagesArgs = {
  input: UpdateExpertLanguagesInput;
};


/** Mutations */
export type MutationUpdateExpertPaymentInformationArgs = {
  input: UpdateExpertPaymentInformationInput;
};


/** Mutations */
export type MutationUpdateExpertRatesArgs = {
  input: UpdateExpertRatesInput;
};


/** Mutations */
export type MutationUpdateExpertTaxSettingsArgs = {
  input: UpdateExpertTaxSettingsInput;
};


/** Mutations */
export type MutationUpdateOrganisationDetailsArgs = {
  input: UpdateOrganisationDetailsInput;
};


/** Mutations */
export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


/** Mutations */
export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


/** Mutations */
export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};


/** Mutations */
export type MutationUpdateSkillsArgs = {
  input: UpdateSkillsInput;
};


/** Mutations */
export type MutationUpdateWorkItemArgs = {
  input: UpdateWorkItemInput;
};


/** Mutations */
export type MutationVerifyEmailArgs = {
  input: VerifyEmailInput;
};


/** Mutations */
export type MutationVerifySmsArgs = {
  input: VerifySmsInput;
};

export type Node = {
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type Notification = {
  id: Scalars['ID'];
  insertedAt: Scalars['NaiveDateTime'];
  name: NotificationName;
  read: Scalars['Boolean'];
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  edges?: Maybe<Array<Maybe<NotificationEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Notification>;
};

export enum NotificationName {
  ProjectApplicationNotSelected = 'PROJECT_APPLICATION_NOT_SELECTED',
  ProjectApplicationViewed = 'PROJECT_APPLICATION_VIEWED',
  ProjectCancelled = 'PROJECT_CANCELLED',
  ProjectContractAgreed = 'PROJECT_CONTRACT_AGREED',
  ProjectContractExtensionOffered = 'PROJECT_CONTRACT_EXTENSION_OFFERED',
  ProjectContractOffered = 'PROJECT_CONTRACT_OFFERED',
  ProjectExpertBeingInterviewed = 'PROJECT_EXPERT_BEING_INTERVIEWED',
  ProjectExpertDeclined = 'PROJECT_EXPERT_DECLINED',
  ProjectExpertInvited = 'PROJECT_EXPERT_INVITED',
  ProjectExpertMatched = 'PROJECT_EXPERT_MATCHED',
  ProjectExpertShortlisted = 'PROJECT_EXPERT_SHORTLISTED',
  ProjectOnhold = 'PROJECT_ONHOLD'
}

export type OauthProfile = Node & {
  __typename?: 'OauthProfile';
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  provider?: Maybe<OauthProvider>;
};

export enum OauthProvider {
  Github = 'GITHUB',
  Google = 'GOOGLE',
  Linkedin = 'LINKEDIN'
}

export type OnboardingTask = {
  id: Scalars['ID'];
  name: Scalars['String'];
  status: OnboardingTaskStatus;
};

export enum OnboardingTaskStatus {
  /** The task is complete */
  Complete = 'COMPLETE',
  /** The task has not been completed by the expert */
  Incomplete = 'INCOMPLETE',
  /** The expert input must be checked or verified by e360 */
  Pending = 'PENDING'
}

export type OnholdProjectInput = {
  clientMutationId: Scalars['String'];
  projectId: Scalars['ID'];
};

export type OnholdProjectPayload = {
  __typename?: 'OnholdProjectPayload';
  clientMutationId: Scalars['String'];
  project?: Maybe<Project>;
};

export enum OperatingType {
  FullTime = 'FULL_TIME',
  IndependentExpert = 'INDEPENDENT_EXPERT',
  MemberOfFirm = 'MEMBER_OF_FIRM',
  NextSteps = 'NEXT_STEPS'
}

export type OptOutProjectEmailInput = {
  clientMutationId: Scalars['String'];
  expertPublicCode: Scalars['String'];
  /** public code hmac used for verification */
  tag: Scalars['String'];
  /** type of emails to opt out of e.g. opportunity or invitation */
  type: Scalars['String'];
};

export type OptOutProjectEmailPayload = {
  __typename?: 'OptOutProjectEmailPayload';
  clientMutationId: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
};

export type OrderInput = {
  direction: SortDirection;
  field: Scalars['String'];
};

export type Organisation = Node & {
  __typename?: 'Organisation';
  commission?: Maybe<Scalars['Float']>;
  companySize?: Maybe<Scalars['String']>;
  contractingCompany?: Maybe<Scalars['String']>;
  crn?: Maybe<Scalars['String']>;
  customFieldDefinitions: Array<CustomFieldDefinition>;
  description?: Maybe<Scalars['HtmlRichText']>;
  displayPaymentInformation?: Maybe<Scalars['Boolean']>;
  /** Number of business days to payment to expert */
  expertPaymentTermDays?: Maybe<Scalars['Int']>;
  gstPercentage?: Maybe<Scalars['Decimal']>;
  hasExplore?: Maybe<Scalars['Boolean']>;
  hasFms?: Maybe<Scalars['Boolean']>;
  hasMarketplace?: Maybe<Scalars['Boolean']>;
  hasPrivateCloud?: Maybe<Scalars['Boolean']>;
  /** Checks if organisation has an enterprise rate card product */
  hasRateCard?: Maybe<Scalars['Boolean']>;
  hasWhitelabel?: Maybe<Scalars['Boolean']>;
  /** The ID of an object */
  id: Scalars['ID'];
  industries?: Maybe<Array<Maybe<Industry>>>;
  industry?: Maybe<Industry>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']>;
  /** Checks to see if timesheet is required */
  isTimesheetRequired?: Maybe<Scalars['Boolean']>;
  /** URL for the white labelling image */
  lightWhitelabelImage?: Maybe<Scalars['String']>;
  location?: Maybe<LegacyLocation>;
  name: Scalars['String'];
  organisationDomains?: Maybe<Array<Maybe<OrganisationDomain>>>;
  /** Number of business days to payment */
  paymentTermDays?: Maybe<Scalars['Int']>;
  privateTalentTermsAndConditions?: Maybe<Scalars['String']>;
  /** The rate card roles associated with an organisation */
  rateCardRoles?: Maybe<Array<Maybe<RateCardRole>>>;
  ssoConfig?: Maybe<SsoConfig>;
  url?: Maybe<Scalars['String']>;
  usesOneRatePricingModel?: Maybe<Scalars['Boolean']>;
};

export type OrganisationConnection = {
  __typename?: 'OrganisationConnection';
  edges?: Maybe<Array<Maybe<OrganisationEdge>>>;
  pageInfo: PageInfo;
};

export type OrganisationDomain = Node & {
  __typename?: 'OrganisationDomain';
  /** The ID of an object */
  id: Scalars['ID'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']>;
  matchSignup?: Maybe<Scalars['Boolean']>;
  regex?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']>;
};

export type OrganisationEdge = {
  __typename?: 'OrganisationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Organisation>;
};

export type OrganisationInvitation = Node & {
  __typename?: 'OrganisationInvitation';
  acceptedAt?: Maybe<Scalars['NaiveDateTime']>;
  code?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['NaiveDateTime']>;
  firstName?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  organisation?: Maybe<Organisation>;
  recipient?: Maybe<Contact>;
  status?: Maybe<InvitationMessageStatus>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']>;
};

export type OrganisationInvitationConnection = {
  __typename?: 'OrganisationInvitationConnection';
  edges?: Maybe<Array<Maybe<OrganisationInvitationEdge>>>;
  pageInfo: PageInfo;
};

export type OrganisationInvitationCreateAccountInput = {
  clientMutationId: Scalars['String'];
  code: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
};

export type OrganisationInvitationCreateAccountPayload = {
  __typename?: 'OrganisationInvitationCreateAccountPayload';
  clientMutationId: Scalars['String'];
  code?: Maybe<Scalars['String']>;
};

export type OrganisationInvitationEdge = {
  __typename?: 'OrganisationInvitationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<OrganisationInvitation>;
};

export type OrganisationLegalDocumentation = Node & {
  __typename?: 'OrganisationLegalDocumentation';
  document?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']>;
  type?: Maybe<Scalars['String']>;
};

export enum OrganisationRole {
  Admin = 'ADMIN',
  Limited = 'LIMITED',
  Member = 'MEMBER'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PauseProjectInput = {
  clientMutationId: Scalars['String'];
  projectId: Scalars['ID'];
};

export type PauseProjectPayload = {
  __typename?: 'PauseProjectPayload';
  clientMutationId: Scalars['String'];
  project?: Maybe<Project>;
};

export enum Pay360EligibilityStatus {
  Eligible = 'ELIGIBLE',
  Ineligible = 'INELIGIBLE',
  Pending = 'PENDING'
}

export type Pay360Invoice = Node & {
  __typename?: 'Pay360Invoice';
  amount?: Maybe<Scalars['Int']>;
  datePaid?: Maybe<Scalars['NaiveDateTime']>;
  expertAmount?: Maybe<Scalars['Int']>;
  expertId?: Maybe<Scalars['Int']>;
  fileUrl?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']>;
  pay360FeePercent?: Maybe<Scalars['Decimal']>;
  reference?: Maybe<Scalars['String']>;
  status?: Maybe<Pay360InvoiceStatus>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']>;
};

export enum Pay360InvoiceStatus {
  Approved = 'APPROVED',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED'
}

export type Pay360Project = Node & {
  __typename?: 'Pay360Project';
  clientCompanyAbn?: Maybe<Scalars['String']>;
  clientCompanyName?: Maybe<Scalars['String']>;
  clientEmail?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  expertId?: Maybe<Scalars['Int']>;
  /** The ID of an object */
  id: Scalars['ID'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']>;
  invoices?: Maybe<Array<Maybe<Pay360Invoice>>>;
  pay360FeePercent?: Maybe<Scalars['Decimal']>;
  projectCode?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']>;
};

export type Pay360User = Node & {
  __typename?: 'Pay360User';
  eligibilityStatus?: Maybe<Pay360EligibilityStatus>;
  expertId?: Maybe<Scalars['Int']>;
  /** The ID of an object */
  id: Scalars['ID'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']>;
  pay360FeePercent?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']>;
};

export type PaymentInformation = Node & {
  __typename?: 'PaymentInformation';
  abn?: Maybe<Scalars['String']>;
  acn?: Maybe<Scalars['String']>;
  /** Expert Australian bank account */
  ausBankAccount?: Maybe<BankAccountAus>;
  ausResident?: Maybe<Scalars['Boolean']>;
  bankAccountType?: Maybe<BankAccountType>;
  earliestPaymentDate?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use TaxRegion on Contract instead */
  gstPercentage?: Maybe<Scalars['Decimal']>;
  gstRegistered?: Maybe<Scalars['Boolean']>;
  /** Whether or not consultant has a valid ACN */
  hasAcn?: Maybe<Scalars['Boolean']>;
  /** The ID of an object */
  id: Scalars['ID'];
  /** Expert insurance information */
  insuranceInformation?: Maybe<InsuranceInformation>;
  /** Expert International bank account */
  internationalBankAccount?: Maybe<BankAccountInternational>;
  isLegallyAuthorised?: Maybe<Scalars['Boolean']>;
  /** Expert New Zealand bank account */
  nzBankAccount?: Maybe<BankAccountNz>;
  operatingType?: Maybe<ConsultantBusinessType>;
  pay360FeePercent?: Maybe<Scalars['Decimal']>;
  paypalEmail?: Maybe<Scalars['String']>;
  registeredBusinessName?: Maybe<Scalars['String']>;
  residencyStatus?: Maybe<ResidencyStatusType>;
  residencyStatusOther?: Maybe<Scalars['String']>;
  tfn?: Maybe<Scalars['String']>;
  /** Expert US bank account */
  usBankAccount?: Maybe<BankAccountUs>;
};

export type PaymentInvoice = {
  __typename?: 'PaymentInvoice';
  amountOutstanding?: Maybe<Scalars['Decimal']>;
  amountPaid?: Maybe<Scalars['Decimal']>;
  clientName?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  contract?: Maybe<Contract>;
  customStatusExplanation?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['NaiveDateTime']>;
  dateEnd?: Maybe<Scalars['NaiveDateTime']>;
  datePaid?: Maybe<Scalars['NaiveDateTime']>;
  dateStart?: Maybe<Scalars['NaiveDateTime']>;
  dateStatusUpdated?: Maybe<Scalars['NaiveDateTime']>;
  dateTimesheetReviewed?: Maybe<Scalars['NaiveDateTime']>;
  deliverableGstTotal?: Maybe<Scalars['Decimal']>;
  deliverableSubtotal?: Maybe<Scalars['Decimal']>;
  deliverableTotal?: Maybe<Scalars['Decimal']>;
  deliverables?: Maybe<Array<Maybe<Deliverable>>>;
  displayPaymentInformation?: Maybe<Scalars['Boolean']>;
  expectedDatePaid?: Maybe<Scalars['NaiveDateTime']>;
  expectedPaymentDatesText?: Maybe<Scalars['String']>;
  expenseGstTotal?: Maybe<Scalars['Decimal']>;
  expenseSubtotal?: Maybe<Scalars['Decimal']>;
  expenseTotal?: Maybe<Scalars['Decimal']>;
  expenses?: Maybe<Array<Maybe<Expense>>>;
  expert?: Maybe<User>;
  expertBusinessName?: Maybe<Scalars['String']>;
  expertName?: Maybe<Scalars['String']>;
  expertPaymentStatus?: Maybe<ExpertPaymentStatus>;
  finalInvoice?: Maybe<Scalars['Boolean']>;
  gstRegistered?: Maybe<Scalars['Boolean']>;
  gstTotal?: Maybe<Scalars['Decimal']>;
  hasAcn?: Maybe<Scalars['Boolean']>;
  hasPartialPayments?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  invoiceAs?: Maybe<Scalars['String']>;
  isFortnightlyPayment?: Maybe<Scalars['Boolean']>;
  isMonthlyPayment?: Maybe<Scalars['Boolean']>;
  isOverdue?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  organisationName?: Maybe<Scalars['String']>;
  pay360FeePercent?: Maybe<Scalars['Decimal']>;
  paymentPolicy?: Maybe<PaymentPolicy>;
  paymentTermsFee?: Maybe<Scalars['Decimal']>;
  paymentTermsType?: Maybe<PaymentTermsType>;
  project?: Maybe<Project>;
  rate?: Maybe<Scalars['Decimal']>;
  remoteId?: Maybe<Scalars['String']>;
  showExpertGst?: Maybe<Scalars['Boolean']>;
  status?: Maybe<InvoiceStatus>;
  subtotal?: Maybe<Scalars['Decimal']>;
  timesheetGstTotal?: Maybe<Scalars['Decimal']>;
  timesheetQuantity?: Maybe<Scalars['Decimal']>;
  timesheetReviewer?: Maybe<Scalars['String']>;
  timesheetSubtotal?: Maybe<Scalars['Decimal']>;
  timesheetTotal?: Maybe<Scalars['Decimal']>;
  timesheets?: Maybe<Array<Maybe<Timesheet>>>;
  total?: Maybe<Scalars['Decimal']>;
};

export type PaymentInvoiceConnection = {
  __typename?: 'PaymentInvoiceConnection';
  edges?: Maybe<Array<Maybe<PaymentInvoiceEdge>>>;
  pageInfo: PageInfo;
};

export type PaymentInvoiceEdge = {
  __typename?: 'PaymentInvoiceEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PaymentInvoice>;
};

export enum PaymentPolicy {
  PayrollMonthly = 'PAYROLL_MONTHLY'
}

export enum PaymentTermsType {
  Fortnight = 'FORTNIGHT',
  Pay360 = 'PAY360',
  Standard = 'STANDARD'
}

export type PostedProject = {
  __typename?: 'PostedProject';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type Profile = Node & {
  __typename?: 'Profile';
  achievements?: Maybe<AchievementConnection>;
  availability?: Maybe<Scalars['String']>;
  /**
   * The availability status of the user.
   *
   * Returns an `EventType` for an expert.
   *
   * Returns `null` for a client.
   */
  availabilityStatus?: Maybe<EventType>;
  businessService?: Maybe<Scalars['String']>;
  businessServiceGroup?: Maybe<Scalars['String']>;
  businessServiceId?: Maybe<Scalars['ID']>;
  calendlyEvents?: Maybe<CalendlyEventConnection>;
  clearanceLevel?: Maybe<ClearanceLevel>;
  clearanceLevelExpiry?: Maybe<Scalars['Date']>;
  code: Scalars['String'];
  completionStatus?: Maybe<Scalars['Int']>;
  /** Profile user's curated project invitation communcation preference */
  curatedProjectInvitations?: Maybe<UserCommunicationPreference>;
  discipline?: Maybe<Scalars['String']>;
  educationItems?: Maybe<Array<EducationItem>>;
  hash?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  industries?: Maybe<Array<Industry>>;
  insuranceDeclarationDate?: Maybe<Scalars['Date']>;
  isTop1000?: Maybe<Scalars['Boolean']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  maxDailyRate?: Maybe<Scalars['Decimal']>;
  maxHourlyRate?: Maybe<Scalars['Decimal']>;
  minDailyRate?: Maybe<Scalars['Decimal']>;
  minHourlyRate?: Maybe<Scalars['Decimal']>;
  private?: Maybe<Scalars['Boolean']>;
  profileComplete?: Maybe<Scalars['Boolean']>;
  profileStep?: Maybe<Scalars['String']>;
  projectCount?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  skills?: Maybe<Array<Skill>>;
  summary?: Maybe<Scalars['HtmlRichText']>;
  testimonial?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['Int']>;
  user: User;
  vettedIntoMarketplace?: Maybe<Scalars['Boolean']>;
  /**
   * Organisation membership based on current user.
   *
   * The original intent of this field is to allow clients to determine if
   * someone with a profile is in their private cloud. This is plural as clients
   * might be in multiple private clouds.
   *
   * Currently only clients can see the orgs they share with this consultant.
   */
  viewerPrivateTalentOrganisations: Array<Organisation>;
  websiteUrl?: Maybe<Scalars['String']>;
  workItems?: Maybe<Array<WorkItem>>;
  workPreference?: Maybe<WorkPreference>;
  workingRights?: Maybe<ExpertWorkingRights>;
  workingRightsDeclarationDate?: Maybe<Scalars['NaiveDateTime']>;
};


export type ProfileAchievementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<AchievementsFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProfileCalendlyEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ProfileInterest = Node & {
  __typename?: 'ProfileInterest';
  /** The ID of an object */
  id: Scalars['ID'];
  interestId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type ProfilePicture = {
  __typename?: 'ProfilePicture';
  height: Scalars['Int'];
  source: Scalars['String'];
  width: Scalars['Int'];
};

/** Available profile picture sizes */
export enum ProfilePictureSize {
  Large = 'LARGE',
  Normal = 'NORMAL'
}

export type Project = Node & Projectable & {
  __typename?: 'Project';
  agreedContracts?: Maybe<ContractConnection>;
  applicantCount?: Maybe<Scalars['Int']>;
  /** A single Application for this project */
  application?: Maybe<Application>;
  /** Applications for this project */
  applications?: Maybe<ApplicationConnection>;
  appliedUsers?: Maybe<Array<User>>;
  audience?: Maybe<ProjectAudience>;
  budgetCurrency?: Maybe<Scalars['String']>;
  budgetMax?: Maybe<Scalars['Float']>;
  budgetMin?: Maybe<Scalars['Float']>;
  businessServices?: Maybe<Array<Maybe<Scalars['String']>>>;
  clearanceLevel?: Maybe<ClearanceLevel>;
  code?: Maybe<Scalars['String']>;
  /**
   * Resolving company name in here probably needs some more thought. This resolver
   *   uses a field on the project table called `showCompanyName` to determine if the
   *   project author has opted in to display the name of their company. This is separate
   *   from the organisation schema, and revolves around the project. This should be revisited
   *   in the future. One option is to make displaying this information permissions based,
   *   and another is to expose the `organisation` type on a project in order to know which
   *   organisation a project is related to.
   */
  companyName?: Maybe<Scalars['String']>;
  companyOverview?: Maybe<Scalars['String']>;
  companySize?: Maybe<Scalars['String']>;
  companyType?: Maybe<Scalars['String']>;
  /** Contract terms for the current user (either client or expert) */
  contractTerms?: Maybe<Scalars['String']>;
  contractingCompany?: Maybe<ContractingCompanyName>;
  contracts?: Maybe<ContractConnection>;
  created?: Maybe<Scalars['NaiveDateTime']>;
  createdBy?: Maybe<User>;
  currentContract?: Maybe<Contract>;
  customFieldValues?: Maybe<Array<Maybe<CustomFieldValue>>>;
  dateCompleted?: Maybe<Scalars['Timestamp']>;
  dateCreated?: Maybe<Scalars['Timestamp']>;
  dateEnd?: Maybe<Scalars['Timestamp']>;
  datePublished?: Maybe<Scalars['Timestamp']>;
  dateStart?: Maybe<Scalars['Timestamp']>;
  dateUpdated?: Maybe<Scalars['Timestamp']>;
  daysWfh?: Maybe<Scalars['Int']>;
  deprecatedStatus?: Maybe<Status>;
  duration?: Maybe<Scalars['String']>;
  /** Gets the start date of the logged in expert's earliest agreed contract */
  earliestContractStartDate?: Maybe<Scalars['Timestamp']>;
  earn?: Maybe<Scalars['String']>;
  enterpriseRateCardRole?: Maybe<Scalars['String']>;
  /** Gets all contracts that are either agreed or extended for the logged in expert */
  expertsContracts?: Maybe<ContractConnection>;
  extensionOffers?: Maybe<ContractConnection>;
  extensionProbability?: Maybe<ExtensionProbabilityType>;
  externalApplicationUrl?: Maybe<Scalars['String']>;
  hash?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  idealExpertSummary?: Maybe<Scalars['String']>;
  idealExpertTitle?: Maybe<Scalars['String']>;
  idealStart?: Maybe<Scalars['String']>;
  industries: Array<Industry>;
  industryName?: Maybe<Scalars['String']>;
  intensity?: Maybe<Scalars['String']>;
  invitedUsers?: Maybe<Array<User>>;
  invoices?: Maybe<PaymentInvoiceConnection>;
  /** States whether the current user is the project creator */
  isCreator?: Maybe<Scalars['Boolean']>;
  isInsured?: Maybe<ProjectIsInsured>;
  /** Whether this project is LPS/Taska */
  isLps?: Maybe<Scalars['Boolean']>;
  isSharedWithMarketplace?: Maybe<Scalars['Boolean']>;
  isSharedWithPrivateCloud?: Maybe<Scalars['Boolean']>;
  lastActivity?: Maybe<Scalars['Timestamp']>;
  lastInvoice?: Maybe<Invoice>;
  /** Applications that were submitted in the old flow (i.e. saved in the interactions table) */
  legacyApplications?: Maybe<LegacyApplicationConnection>;
  legacyLocations?: Maybe<Array<Maybe<LegacyLocation>>>;
  location?: Maybe<Scalars['String']>;
  locationDetails?: Maybe<LegacyLocation>;
  locationType?: Maybe<Scalars['String']>;
  offers?: Maybe<ContractConnection>;
  organisation?: Maybe<Organisation>;
  organisationIndustries?: Maybe<Array<Maybe<Industry>>>;
  organisationIndustry?: Maybe<Scalars['String']>;
  organisationMemberSinceDate?: Maybe<Scalars['NaiveDateTime']>;
  postedDate?: Maybe<Scalars['String']>;
  postedDateUtc?: Maybe<Scalars['Timestamp']>;
  /**
   * The privacy of the project.
   *
   * `PRIVATE` for private projects and `PUBLIC` for public projects.
   */
  privacy?: Maybe<ProjectPrivacy>;
  progressOfProject?: Maybe<Scalars['String']>;
  projectLocation?: Maybe<Scalars['String']>;
  /**
   * Rate card clients have a rate card role associated to their project.
   * See table 'Enterprise Rate Card Project & Enterprise Rate Card Role.'
   */
  rateCardRole?: Maybe<RateCardRole>;
  rateUnit?: Maybe<Scalars['String']>;
  /** Remote location settings if project is remote */
  remoteLocation?: Maybe<RemoteLocation>;
  roleTitleId?: Maybe<Scalars['ID']>;
  /** Used to determine if the client gets timesheet emails or not */
  sendTimesheetEmail?: Maybe<Scalars['Boolean']>;
  seniorityLevel?: Maybe<SeniorityLevel>;
  servicesRequired: Array<BusinessService>;
  showCompanyName?: Maybe<Scalars['Boolean']>;
  /** Whether the current logged in expert is supposed to be shown GST */
  showExpertGst?: Maybe<Scalars['Boolean']>;
  skills?: Maybe<Array<Maybe<Skill>>>;
  startAsap?: Maybe<Scalars['Boolean']>;
  state?: Maybe<ProjectState>;
  /** status from Service.Project.Status */
  status?: Maybe<ProjectStatus>;
  statusOfProject?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  unapprovedServicesRequired: Array<BusinessService>;
  unlisted?: Maybe<Scalars['Boolean']>;
  updated?: Maybe<Scalars['NaiveDateTime']>;
  usesOneRatePricingModel?: Maybe<Scalars['Boolean']>;
  viewerContract?: Maybe<Contract>;
  viewerHasBookmarked?: Maybe<Scalars['Boolean']>;
  viewerInvitation?: Maybe<ViewerInvitation>;
  yearsExperience?: Maybe<YearsExperience>;
};


export type ProjectAgreedContractsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  shouldGroupByExpert?: InputMaybe<Scalars['Boolean']>;
};


export type ProjectApplicationArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type ProjectApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProjectContractsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProjectExpertsContractsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProjectExtensionOffersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProjectInvoicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProjectLegacyApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProjectOffersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export enum ProjectAudience {
  DirectOffer = 'DIRECT_OFFER',
  InviteOnly = 'INVITE_ONLY',
  PrivateCloud = 'PRIVATE_CLOUD',
  Public = 'PUBLIC'
}

export type ProjectBriefInput = {
  budgetCurrency?: InputMaybe<Scalars['String']>;
  budgetMax?: InputMaybe<Scalars['Float']>;
  budgetMin?: InputMaybe<Scalars['Float']>;
  businessServices: Array<ServiceInput>;
  customBusinessServices?: InputMaybe<Array<Scalars['String']>>;
  dateEnd?: InputMaybe<Scalars['String']>;
  dateStart?: InputMaybe<Scalars['String']>;
  daysWfh?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<Scalars['String']>;
  extensionProbability?: InputMaybe<ExtensionProbabilityType>;
  idealExpertSummary?: InputMaybe<Scalars['String']>;
  idealExpertTitle?: InputMaybe<Scalars['String']>;
  industryIds: Array<ServiceInput>;
  intensity?: InputMaybe<Scalars['String']>;
  isSharedWithMarketplace?: InputMaybe<Scalars['Boolean']>;
  isSharedWithPrivateCloud?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['ID']>;
  locationIds?: InputMaybe<Array<InputMaybe<LocationInput>>>;
  locationType?: InputMaybe<Scalars['String']>;
  privacy?: InputMaybe<ProjectPrivacy>;
  rateUnit?: InputMaybe<Scalars['String']>;
  remoteCountryCode?: InputMaybe<Scalars['String']>;
  remoteTimezone?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['ID']>;
  roleTitleId?: InputMaybe<Scalars['ID']>;
  showCompanyName?: InputMaybe<Scalars['Boolean']>;
  skillIds?: InputMaybe<Array<SkillInput>>;
  startAsap?: InputMaybe<Scalars['Boolean']>;
  summary?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ProjectConnection = {
  __typename?: 'ProjectConnection';
  edges?: Maybe<Array<Maybe<ProjectEdge>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ProjectEdge = {
  __typename?: 'ProjectEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Project>;
};

export enum ProjectIsInsured {
  Covered = 'COVERED',
  NotCovered = 'NOT_COVERED',
  UnderReview = 'UNDER_REVIEW'
}

export type ProjectNotification = Node & Notification & {
  __typename?: 'ProjectNotification';
  /** The ID of an object */
  id: Scalars['ID'];
  insertedAt: Scalars['NaiveDateTime'];
  name: NotificationName;
  project?: Maybe<Project>;
  read: Scalars['Boolean'];
};

export enum ProjectPrivacy {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum ProjectState {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Hired = 'HIRED',
  New = 'NEW',
  OnHold = 'ON_HOLD',
  Open = 'OPEN',
  Paused = 'PAUSED'
}

export type ProjectStatus = {
  __typename?: 'ProjectStatus';
  applicationCount?: Maybe<Scalars['Int']>;
  applicationDeclinedCount?: Maybe<Scalars['Int']>;
  declineCount?: Maybe<Scalars['Int']>;
  expertDeclinedCount?: Maybe<Scalars['Int']>;
  expertHired?: Maybe<Scalars['Boolean']>;
  expertStatus?: Maybe<ExpertStatus>;
  expertStatusDate?: Maybe<Scalars['Timestamp']>;
  interviewCount?: Maybe<Scalars['Int']>;
  lifecycleStatus?: Maybe<LifecycleStatus>;
  lifecycleStatusDate?: Maybe<Scalars['Timestamp']>;
  modifier?: Maybe<LifecycleModifier>;
  modifierDate?: Maybe<Scalars['Timestamp']>;
  offerCount?: Maybe<Scalars['Int']>;
};

export type Projectable = {
  budgetCurrency?: Maybe<Scalars['String']>;
  budgetMax?: Maybe<Scalars['Float']>;
  budgetMin?: Maybe<Scalars['Float']>;
  businessServices?: Maybe<Array<Maybe<Scalars['String']>>>;
  clearanceLevel?: Maybe<ClearanceLevel>;
  code?: Maybe<Scalars['String']>;
  companyType?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['NaiveDateTime']>;
  duration?: Maybe<Scalars['String']>;
  earn?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idealStart?: Maybe<Scalars['String']>;
  intensity?: Maybe<Scalars['String']>;
  locationType?: Maybe<Scalars['String']>;
  organisationIndustry?: Maybe<Scalars['String']>;
  postedDate?: Maybe<Scalars['String']>;
  progressOfProject?: Maybe<Scalars['String']>;
  projectLocation?: Maybe<Scalars['String']>;
  rateUnit?: Maybe<Scalars['String']>;
  seniorityLevel?: Maybe<SeniorityLevel>;
  statusOfProject?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['NaiveDateTime']>;
  viewerHasBookmarked?: Maybe<Scalars['Boolean']>;
  yearsExperience?: Maybe<YearsExperience>;
};

export type ProvideWorkingRightsDocumentsInput = {
  /** Authorise sharing data with government authorities */
  authoriseDataSharing: Scalars['Boolean'];
  clientMutationId: Scalars['String'];
  /** Uploaded documents */
  documents?: InputMaybe<Array<InputMaybe<WorkingRightsDocumentInput>>>;
  /** Id of the onboarding task */
  onboardingTaskId?: InputMaybe<Scalars['ID']>;
};

export type ProvideWorkingRightsDocumentsPayload = {
  __typename?: 'ProvideWorkingRightsDocumentsPayload';
  clientMutationId: Scalars['String'];
  onboardingTask?: Maybe<OnboardingTask>;
  success?: Maybe<Scalars['Boolean']>;
};

export type PublishProjectInput = {
  clientMutationId: Scalars['String'];
  projectId: Scalars['ID'];
};

export type PublishProjectPayload = {
  __typename?: 'PublishProjectPayload';
  clientMutationId: Scalars['String'];
  project?: Maybe<Project>;
};

export type QualifyPay360UserInput = {
  businessInfo?: InputMaybe<BusinessInfo>;
  clientMutationId: Scalars['String'];
};

export type QualifyPay360UserPayload = {
  __typename?: 'QualifyPay360UserPayload';
  clientMutationId: Scalars['String'];
  pay360EligibilityStatus?: Maybe<Scalars['String']>;
};

/** Queries */
export type Query = {
  __typename?: 'Query';
  /** Get an invoice anonymously */
  anonymousInvoice?: Maybe<PaymentInvoice>;
  articles?: Maybe<ArticleConnection>;
  /** List all bookmarked projects */
  bookmarks?: Maybe<BookmarkConnection>;
  /** Lists all business services by matching string */
  businessServices?: Maybe<BusinessServiceConnection>;
  communityEvents?: Maybe<CommunityEventConnection>;
  /** List the current users contacts */
  contacts?: Maybe<ContactConnection>;
  /** Contracting company details */
  contractingCompany?: Maybe<ContractingCompany>;
  countries?: Maybe<Array<Maybe<Country>>>;
  /** Lists all disciplines by matching string */
  disciplines?: Maybe<DisciplineConnection>;
  /** Fetch an invite using its token */
  expertInvitation?: Maybe<ExpertInvitation>;
  /** Search for Experts using filters */
  experts?: Maybe<SearchConsultantConnection>;
  /** List the user favourites */
  favouriteContacts?: Maybe<ContactConnection>;
  /** Industry Autocomplete */
  industryAutocomplete?: Maybe<IndustryConnection>;
  /** Lists all interests by matching string */
  interests?: Maybe<InterestConnection>;
  /** A single invoice */
  invoice?: Maybe<PaymentInvoice>;
  /** Submitted or draft invoices */
  invoices?: Maybe<PaymentInvoiceConnection>;
  isAccountClaimed?: Maybe<Scalars['Boolean']>;
  isEmailAvailableForSignup?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Array<Language>>;
  /** Legacy Locations */
  legacyLocations?: Maybe<LegacyLocationConnection>;
  /** Legacy Organisations */
  legacyOrganisations?: Maybe<LegacyOrganisationConnection>;
  /** Get legal documentation by type */
  legalDocumentation?: Maybe<OrganisationLegalDocumentation>;
  node?: Maybe<Node>;
  /** Returns the OAuth profile, only has a value if the user has logged in using OAuth */
  oauthProfile?: Maybe<OauthProfile>;
  /** Organisation details */
  organisation?: Maybe<Organisation>;
  /** Single invitation */
  organisationInvitation?: Maybe<OrganisationInvitation>;
  /** Multiple invitations */
  organisationInvitations?: Maybe<OrganisationInvitationConnection>;
  /** Organisation members */
  organisationMembers?: Maybe<UserConnection>;
  /** Organisations */
  organisations?: Maybe<OrganisationConnection>;
  /** Private clouds */
  privateClouds?: Maybe<OrganisationConnection>;
  /** A User's Professional Profile */
  profile?: Maybe<Profile>;
  /** A single project */
  project?: Maybe<Project>;
  /**
   * List of projects.
   * Filtering by date range requires a user to be logged in
   * and will be limited to projects in organisations for
   * which they are admin.
   */
  projects?: Maybe<ProjectConnection>;
  /** Role Titles */
  roleTitles?: Maybe<RoleTitleConnection>;
  savedSearches?: Maybe<SavedSearchConnection>;
  /** List all search_consultants */
  search?: Maybe<SearchResultConnection>;
  /** List all search_filters */
  searchFilters?: Maybe<SearchFilters>;
  /** A user's shadow profile */
  shadowProfile?: Maybe<ShadowProfile>;
  /** Lists all skills by matching string or belonging to a BusinessService */
  skills?: Maybe<SkillConnection>;
  /** Tags */
  tags?: Maybe<TagConnection>;
  /** Lists all tax regions */
  taxRegions?: Maybe<TaxRegionConnection>;
  /** List all threads */
  threads?: Maybe<ThreadConnection>;
  /** Gives a list of all the timezones */
  timezones?: Maybe<Array<Timezone>>;
  /** Current User */
  viewer?: Maybe<Viewer>;
};


/** Queries */
export type QueryAnonymousInvoiceArgs = {
  code: Scalars['String'];
  tag: Scalars['String'];
};


/** Queries */
export type QueryArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Queries */
export type QueryBookmarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Queries */
export type QueryBusinessServicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  group?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QueryCommunityEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Queries */
export type QueryContactsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Queries */
export type QueryContractingCompanyArgs = {
  displayName?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QueryCountriesArgs = {
  alpha2?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QueryDisciplinesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  discipline?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Queries */
export type QueryExpertInvitationArgs = {
  token?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QueryExpertsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ExpertFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Queries */
export type QueryFavouriteContactsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Queries */
export type QueryIndustryAutocompleteArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};


/** Queries */
export type QueryInterestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  interest?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Queries */
export type QueryInvoiceArgs = {
  code?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QueryInvoicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  draftOnly?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QueryIsAccountClaimedArgs = {
  email?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QueryIsEmailAvailableForSignupArgs = {
  email?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QueryLanguagesArgs = {
  name?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QueryLegacyLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QueryLegacyOrganisationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};


/** Queries */
export type QueryLegalDocumentationArgs = {
  type?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QueryNodeArgs = {
  id: Scalars['ID'];
};


/** Queries */
export type QueryOrganisationArgs = {
  email?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QueryOrganisationInvitationArgs = {
  code?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QueryOrganisationInvitationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Queries */
export type QueryOrganisationMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Queries */
export type QueryOrganisationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QueryPrivateCloudsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Queries */
export type QueryProfileArgs = {
  code?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QueryProjectArgs = {
  code?: InputMaybe<Scalars['String']>;
  hash?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QueryProjectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateRangeInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<OrderInput>>>;
  profileSlug?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QueryRoleTitlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QuerySavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  form?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Queries */
export type QuerySearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<SearchQueryInput>;
};


/** Queries */
export type QuerySearchFiltersArgs = {
  query?: InputMaybe<SearchQueryInput>;
};


/** Queries */
export type QueryShadowProfileArgs = {
  code?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QuerySkillsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessServiceId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skill?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QueryTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};


/** Queries */
export type QueryTaxRegionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Queries */
export type QueryThreadsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryOptions = {
  advancedSearch?: InputMaybe<Scalars['Boolean']>;
};

export type RateCardRole = Node & {
  __typename?: 'RateCardRole';
  /** The ID of an object */
  id: Scalars['ID'];
  maximumRate?: Maybe<Scalars['Decimal']>;
  minimumRate?: Maybe<Scalars['Decimal']>;
  name?: Maybe<Scalars['String']>;
};

export enum RateUnit {
  Day = 'DAY',
  Fixed = 'FIXED',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type RatingAndReview = Node & {
  __typename?: 'RatingAndReview';
  feedbackSkillRating: Array<FeedbackSkillRating>;
  feedbackUserPublic?: Maybe<FeedbackUserPublic>;
  hash?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  project: Project;
};

export type RemoteLocation = {
  __typename?: 'RemoteLocation';
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  gmtOffset?: Maybe<Scalars['Float']>;
  timezone?: Maybe<Scalars['String']>;
  timezoneRange?: Maybe<Scalars['Int']>;
  type?: Maybe<RemoteLocationType>;
};

export enum RemoteLocationType {
  Country = 'COUNTRY',
  Timezone = 'TIMEZONE',
  Worldwide = 'WORLDWIDE'
}

export type RemoteWorkSafetyChecklist = Node & OnboardingTask & {
  __typename?: 'RemoteWorkSafetyChecklist';
  contract?: Maybe<Contract>;
  /** The ID of an object */
  id: Scalars['ID'];
  name: Scalars['String'];
  status: OnboardingTaskStatus;
  url?: Maybe<Scalars['String']>;
};

export type RemoveFavouriteInput = {
  clientMutationId: Scalars['String'];
  userId: Scalars['ID'];
};

export type RemoveFavouritePayload = {
  __typename?: 'RemoveFavouritePayload';
  clientMutationId: Scalars['String'];
  user?: Maybe<User>;
};

export type RemoveProjectBookmarkInput = {
  clientMutationId: Scalars['String'];
  projectId: Scalars['ID'];
};

export type RemoveProjectBookmarkPayload = {
  __typename?: 'RemoveProjectBookmarkPayload';
  clientMutationId: Scalars['String'];
  searchProject?: Maybe<SearchProject>;
};

export type RemoveProjectPageBookmarkInput = {
  clientMutationId: Scalars['String'];
  projectId: Scalars['ID'];
};

export type RemoveProjectPageBookmarkPayload = {
  __typename?: 'RemoveProjectPageBookmarkPayload';
  clientMutationId: Scalars['String'];
  viewerHasBookmarked?: Maybe<Scalars['Boolean']>;
};

export type RemoveSavedBookmarkInput = {
  clientMutationId: Scalars['String'];
  projectId: Scalars['ID'];
};

export type RemoveSavedBookmarkPayload = {
  __typename?: 'RemoveSavedBookmarkPayload';
  bookmark?: Maybe<BookmarkEdge>;
  clientMutationId: Scalars['String'];
};

export type RenameSavedSearchInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type RenameSavedSearchPayload = {
  __typename?: 'RenameSavedSearchPayload';
  savedSearch?: Maybe<SavedSearch>;
};

export type RequestPasswordResetInput = {
  clientMutationId: Scalars['String'];
  email: Scalars['String'];
};

export type RequestPasswordResetPayload = {
  __typename?: 'RequestPasswordResetPayload';
  clientMutationId: Scalars['String'];
  confirmation?: Maybe<Scalars['Boolean']>;
  hasSso?: Maybe<Scalars['Boolean']>;
  requireSso?: Maybe<Scalars['Boolean']>;
};

export type RequestResourceInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  clientMutationId: Scalars['String'];
  requestType: Scalars['String'];
};

export type RequestResourcePayload = {
  __typename?: 'RequestResourcePayload';
  clientMutationId: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
};

export type ResendFastApplyEmailInput = {
  email: Scalars['String'];
  projectCode: Scalars['String'];
};

export type ResendFastApplyEmailPayload = {
  __typename?: 'ResendFastApplyEmailPayload';
  success?: Maybe<Scalars['Boolean']>;
};

export type ResendOrganisationInvitationInput = {
  clientMutationId: Scalars['String'];
  code: Scalars['String'];
};

export type ResendOrganisationInvitationPayload = {
  __typename?: 'ResendOrganisationInvitationPayload';
  clientMutationId: Scalars['String'];
  organisationInvitation?: Maybe<OrganisationInvitation>;
};

export enum ResidencyStatusType {
  AusCitizen = 'AUS_CITIZEN',
  AusResident = 'AUS_RESIDENT',
  NzCitizen = 'NZ_CITIZEN',
  Other = 'OTHER'
}

export type ReviewTimesheetAnonymouslyInput = {
  clientMutationId: Scalars['String'];
  /** invoice code */
  code: Scalars['String'];
  email: Scalars['String'];
  /** invoice status */
  status: TimesheetReviewStatus;
  /** invoice HMAC tag used for authentication */
  tag: Scalars['String'];
};

export type ReviewTimesheetAnonymouslyPayload = {
  __typename?: 'ReviewTimesheetAnonymouslyPayload';
  alreadyReviewed?: Maybe<Scalars['Boolean']>;
  clientMutationId: Scalars['String'];
};

export type ReviewTimesheetInput = {
  clientMutationId: Scalars['String'];
  /** invoice code */
  code: Scalars['String'];
  /** invoice status explanation */
  customStatusExplanation?: InputMaybe<Scalars['String']>;
  /** invoice status */
  status: TimesheetReviewStatus;
  /** fullname of the timesheet reviewer */
  timesheetReviewer?: InputMaybe<Scalars['String']>;
};

export type ReviewTimesheetPayload = {
  __typename?: 'ReviewTimesheetPayload';
  clientMutationId: Scalars['String'];
  paymentInvoice?: Maybe<PaymentInvoice>;
};

export type RightToWorkInAustralia = Node & OnboardingTask & {
  __typename?: 'RightToWorkInAustralia';
  documents?: Maybe<Array<Maybe<WorkingRightsDocument>>>;
  /** The ID of an object */
  id: Scalars['ID'];
  name: Scalars['String'];
  status: OnboardingTaskStatus;
};

export enum Role {
  Admin = 'ADMIN',
  Client = 'CLIENT',
  Consultant = 'CONSULTANT',
  SuperAdmin = 'SUPER_ADMIN'
}

export type RoleTitle = Node & {
  __typename?: 'RoleTitle';
  /** The ID of an object */
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type RoleTitleConnection = {
  __typename?: 'RoleTitleConnection';
  edges?: Maybe<Array<Maybe<RoleTitleEdge>>>;
  pageInfo: PageInfo;
};

export type RoleTitleEdge = {
  __typename?: 'RoleTitleEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<RoleTitle>;
};

export type SavedSearch = Node & {
  __typename?: 'SavedSearch';
  form: Scalars['String'];
  formValues: Scalars['Json'];
  /** The ID of an object */
  id: Scalars['ID'];
  insertedAt: Scalars['NaiveDateTime'];
  name: Scalars['String'];
};

export type SavedSearchConnection = {
  __typename?: 'SavedSearchConnection';
  edges?: Maybe<Array<Maybe<SavedSearchEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SavedSearchEdge = {
  __typename?: 'SavedSearchEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<SavedSearch>;
};

export type SearchConsultant = Node & {
  __typename?: 'SearchConsultant';
  availability?: Maybe<Availability>;
  backOffice?: Maybe<BackOffice>;
  currency?: Maybe<Scalars['String']>;
  currentAvailability?: Maybe<Scalars['String']>;
  currentProject?: Maybe<Project>;
  dailyRate?: Maybe<Scalars['String']>;
  dateAvailable?: Maybe<Scalars['Date']>;
  dateLastActivity?: Maybe<Scalars['Timestamp']>;
  favourite?: Maybe<Scalars['Boolean']>;
  favouritedBy?: Maybe<Scalars['String']>;
  highlights?: Maybe<SearchExpertHighlights>;
  hourlyRate?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  languages?: Maybe<Array<UserLanguage>>;
  name: Scalars['String'];
  organisations?: Maybe<Array<SearchOrganisation>>;
  profile: SearchConsultantProfile;
  profilePicture?: Maybe<ProfilePicture>;
  profileUrl?: Maybe<Scalars['String']>;
  projectInvitationsEnabled?: Maybe<Scalars['Boolean']>;
  projectInvitationsSnoozedUntil?: Maybe<Scalars['Date']>;
  projects?: Maybe<ProjectConnection>;
  rating?: Maybe<Scalars['Float']>;
  skills?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type SearchConsultantProjectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type SearchConsultantConnection = {
  __typename?: 'SearchConsultantConnection';
  edges?: Maybe<Array<Maybe<SearchConsultantEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SearchConsultantEdge = {
  __typename?: 'SearchConsultantEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<SearchConsultant>;
};

export type SearchConsultantProfile = {
  __typename?: 'SearchConsultantProfile';
  businessService?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  discipline?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  location?: Maybe<SearchLocation>;
  maxDailyRate?: Maybe<Scalars['String']>;
  minDailyRate?: Maybe<Scalars['String']>;
  organisationNames?: Maybe<Array<Scalars['String']>>;
  projectCount?: Maybe<Scalars['Int']>;
  summary?: Maybe<Scalars['String']>;
  workItems?: Maybe<Array<SearchWorkItem>>;
};

export type SearchExpertHighlights = {
  __typename?: 'SearchExpertHighlights';
  industries?: Maybe<Array<Scalars['String']>>;
  organisations?: Maybe<Array<Scalars['String']>>;
  roleTitles?: Maybe<Array<Scalars['String']>>;
  skills?: Maybe<Array<Scalars['String']>>;
};

export type SearchFilter = {
  __typename?: 'SearchFilter';
  count?: Maybe<Scalars['Int']>;
  /** Resolving to different field name to prevent conflicts on id */
  filterId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  subCategories?: Maybe<Array<Maybe<SearchFilter>>>;
};

export type SearchFilterInput = {
  category?: InputMaybe<Scalars['String']>;
  filterId?: InputMaybe<Scalars['String']>;
};

export type SearchFilters = {
  __typename?: 'SearchFilters';
  availabilities?: Maybe<Array<Maybe<SearchFilter>>>;
  availabilityCapacity?: Maybe<Array<Maybe<SearchFilter>>>;
  availabilityDates?: Maybe<Array<Maybe<SearchFilter>>>;
  businessServices?: Maybe<Array<Maybe<SearchFilter>>>;
  cities?: Maybe<Array<Maybe<SearchFilter>>>;
  countries?: Maybe<Array<Maybe<SearchFilter>>>;
  locationTypes?: Maybe<Array<Maybe<SearchFilter>>>;
  newAvailability?: Maybe<Array<Maybe<SearchFilter>>>;
  organisations?: Maybe<Array<Maybe<SearchFilter>>>;
  tags?: Maybe<Array<Maybe<SearchFilter>>>;
};

export type SearchLocation = {
  __typename?: 'SearchLocation';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  subdivision?: Maybe<Scalars['String']>;
};

export type SearchOrganisation = {
  __typename?: 'SearchOrganisation';
  name?: Maybe<Scalars['String']>;
  /** Resolving to different field name to prevent conflicts on id */
  orgId?: Maybe<Scalars['String']>;
};

export type SearchProject = Node & Projectable & {
  __typename?: 'SearchProject';
  application?: Maybe<Application>;
  budgetCurrency?: Maybe<Scalars['String']>;
  budgetMax?: Maybe<Scalars['Float']>;
  budgetMin?: Maybe<Scalars['Float']>;
  businessServices?: Maybe<Array<Maybe<Scalars['String']>>>;
  clearanceLevel?: Maybe<ClearanceLevel>;
  code?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companySize?: Maybe<Scalars['String']>;
  companyType?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['NaiveDateTime']>;
  dateEnd?: Maybe<Scalars['NaiveDateTime']>;
  datePublished?: Maybe<Scalars['String']>;
  dateStart?: Maybe<Scalars['NaiveDateTime']>;
  duration?: Maybe<Scalars['String']>;
  earn?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  idealExpertSummary?: Maybe<Scalars['String']>;
  idealExpertTitle?: Maybe<Scalars['String']>;
  idealStart?: Maybe<Scalars['String']>;
  industries?: Maybe<Array<Maybe<Scalars['String']>>>;
  intensity?: Maybe<Scalars['String']>;
  lastActivity?: Maybe<Scalars['Timestamp']>;
  location?: Maybe<LegacyLocation>;
  locationType?: Maybe<Scalars['String']>;
  organisationIndustries: Array<Maybe<Scalars['String']>>;
  organisationIndustry?: Maybe<Scalars['String']>;
  organisations?: Maybe<Array<SearchOrganisation>>;
  postedDate?: Maybe<Scalars['String']>;
  postedDateUtc?: Maybe<Scalars['Timestamp']>;
  progressOfProject?: Maybe<Scalars['String']>;
  projectLocation?: Maybe<Scalars['String']>;
  rateUnit?: Maybe<Scalars['String']>;
  /** Remote location settings if project is remote */
  remoteLocation?: Maybe<RemoteLocation>;
  seniorityLevel?: Maybe<SeniorityLevel>;
  skills?: Maybe<Array<Maybe<Scalars['String']>>>;
  statusOfProject?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['NaiveDateTime']>;
  viewerHasBookmarked: Scalars['Boolean'];
  yearsExperience?: Maybe<YearsExperience>;
};

export type SearchQueryInput = {
  categorySearch?: InputMaybe<Array<InputMaybe<SearchFilterInput>>>;
  filters?: InputMaybe<Array<InputMaybe<SearchFilterInput>>>;
  options?: InputMaybe<QueryOptions>;
  searchWord?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<SearchQueryKey>;
};

export enum SearchQueryKey {
  Consultant = 'CONSULTANT',
  Project = 'PROJECT'
}

/** A search result */
export type SearchResult = SearchConsultant | SearchProject;

export type SearchResultConnection = {
  __typename?: 'SearchResultConnection';
  edges?: Maybe<Array<Maybe<SearchResultEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SearchResultEdge = {
  __typename?: 'SearchResultEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<SearchResult>;
};

export type SearchWorkItem = {
  __typename?: 'SearchWorkItem';
  organisation?: Maybe<SearchOrganisation>;
  roleTitle: Scalars['String'];
  summary: Scalars['String'];
};

export type SendVerifyEmailInput = {
  clientMutationId: Scalars['String'];
};

export type SendVerifyEmailPayload = {
  __typename?: 'SendVerifyEmailPayload';
  clientMutationId: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
};

export type SendVerifySmsInput = {
  clientMutationId: Scalars['String'];
};

export type SendVerifySmsPayload = {
  __typename?: 'SendVerifySmsPayload';
  clientMutationId: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
};

export enum SeniorityLevel {
  Director = 'DIRECTOR',
  EarlyCareer = 'EARLY_CAREER',
  Executive = 'EXECUTIVE',
  MidLevel = 'MID_LEVEL',
  Senior = 'SENIOR'
}

export type ServiceInput = {
  id: Scalars['ID'];
};

export type ShadowProfile = Node & {
  __typename?: 'ShadowProfile';
  certifications?: Maybe<Array<Maybe<ShadowProfileCertification>>>;
  clearanceConfidence?: Maybe<Scalars['String']>;
  clearanceLevel?: Maybe<Scalars['String']>;
  companyCategoryExperience?: Maybe<Array<Maybe<Scalars['String']>>>;
  experienceExplanation?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  roleTitle?: Maybe<Scalars['String']>;
  seniorityExplanation?: Maybe<Scalars['String']>;
  seniorityLevel?: Maybe<Scalars['String']>;
  skills?: Maybe<Array<Maybe<ShadowProfileSkill>>>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']>;
  yearsExperienceExplanation?: Maybe<Scalars['String']>;
  yearsExperienceNumber?: Maybe<Scalars['Int']>;
};

export type ShadowProfileCertification = Node & {
  __typename?: 'ShadowProfileCertification';
  code?: Maybe<Scalars['String']>;
  dateEarned?: Maybe<Scalars['Date']>;
  dateExpiry?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ShadowProfileSkill = Node & {
  __typename?: 'ShadowProfileSkill';
  /** The ID of an object */
  id: Scalars['ID'];
  skill: Scalars['String'];
  technical: Scalars['Boolean'];
};

export type Skill = Node & {
  __typename?: 'Skill';
  /** The ID of an object */
  id: Scalars['ID'];
  skill: Scalars['String'];
};

export type SkillConnection = {
  __typename?: 'SkillConnection';
  edges?: Maybe<Array<Maybe<SkillEdge>>>;
  pageInfo: PageInfo;
};

export type SkillEdge = {
  __typename?: 'SkillEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Skill>;
};

export type SkillInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Sort Direction */
export enum SortDirection {
  /** Ascending order direction */
  Asc = 'ASC',
  /** Descending order direction */
  Desc = 'DESC'
}

export type SsoConfig = Node & {
  __typename?: 'SsoConfig';
  /** The ID of an object */
  id: Scalars['ID'];
  requireSso?: Maybe<Scalars['Boolean']>;
};

export type StartUserVerificationInput = {
  clientMutationId: Scalars['String'];
  mobileNumber: Scalars['String'];
  mobilePrefix: Scalars['String'];
};

export type StartUserVerificationPayload = {
  __typename?: 'StartUserVerificationPayload';
  clientMutationId: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
};

export enum Status {
  Active = 'ACTIVE',
  Applications = 'APPLICATIONS',
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Hired = 'HIRED',
  Interviewing = 'INTERVIEWING'
}

export enum StatusOptions {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type SubmitApplicationExperience = {
  description?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['ID']>;
  workHistoryId?: InputMaybe<Scalars['ID']>;
};

export type SubmitApplicationInput = {
  /** The project id of the application being applied to */
  applicationProjectId: Scalars['ID'];
  /** The introductory statement the applicant wishes to offer */
  applicationStatement?: InputMaybe<Scalars['String']>;
  /** Status of the application to save */
  applicationStatus: ApplicationStatus;
  /** The budget the applicant wishes to propose */
  budgetSuggestion?: InputMaybe<Scalars['String']>;
  clientMutationId: Scalars['String'];
  /** The ideal start date the applicant wishes to propose */
  dateStartSuggestion?: InputMaybe<Scalars['String']>;
  /** Whether the application is from a public page */
  isFromPublic?: InputMaybe<Scalars['Boolean']>;
  /** The expert's proposed earning rate for this project */
  proposedRate?: InputMaybe<Scalars['Decimal']>;
  /** The unit of the rate e.g. per day */
  proposedRateUnit?: InputMaybe<RateUnit>;
  /** The chosen list of application experiences to include with the application */
  selectedExperiences: Array<SubmitApplicationExperience>;
};

export type SubmitApplicationPayload = {
  __typename?: 'SubmitApplicationPayload';
  application?: Maybe<Application>;
  clientMutationId: Scalars['String'];
};

export type SubmitDeclineInvitationInput = {
  clientMutationId: Scalars['String'];
  declineAdditionalComments?: InputMaybe<Scalars['String']>;
  declineReason: Scalars['String'];
  projectId: Scalars['String'];
};

export type SubmitDeclineInvitationPayload = {
  __typename?: 'SubmitDeclineInvitationPayload';
  clientMutationId: Scalars['String'];
  declinedInvitation?: Maybe<DeclinedInvitation>;
};

export type SubmitExpertApplicationInput = {
  applicationStep?: InputMaybe<Scalars['String']>;
  availability?: InputMaybe<Scalars['String']>;
  businessServiceId?: InputMaybe<Scalars['String']>;
  clientMutationId: Scalars['String'];
  disciplineId?: InputMaybe<Scalars['String']>;
  expert?: InputMaybe<Expert>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type SubmitExpertApplicationPayload = {
  __typename?: 'SubmitExpertApplicationPayload';
  clientMutationId: Scalars['String'];
  user?: Maybe<User>;
};

export type SubmitExpertCompaniesInput = {
  clientMutationId: Scalars['String'];
  preferredCompany?: InputMaybe<ExpertCompanyInput>;
};

export type SubmitExpertCompaniesPayload = {
  __typename?: 'SubmitExpertCompaniesPayload';
  clientMutationId: Scalars['String'];
  workPreferenceCompany?: Maybe<WorkPreferenceCompany>;
};

export type SubmitExpertIdealRoleInput = {
  clientMutationId: Scalars['String'];
  role?: InputMaybe<ExpertIdealRoleInput>;
};

export type SubmitExpertIdealRolePayload = {
  __typename?: 'SubmitExpertIdealRolePayload';
  clientMutationId: Scalars['String'];
  role?: Maybe<WorkPreferenceIdealRole>;
};

export type SubmitExpertIndustriesInput = {
  clientMutationId: Scalars['String'];
  preferredIndustries?: InputMaybe<Array<ExpertIndustryInput>>;
  undesirableIndustries?: InputMaybe<Array<ExpertIndustryInput>>;
};

export type SubmitExpertIndustriesPayload = {
  __typename?: 'SubmitExpertIndustriesPayload';
  clientMutationId: Scalars['String'];
  workPreferencePreferredIndustries?: Maybe<Array<Maybe<WorkPreferenceIndustry>>>;
  workPreferenceUndesirableIndustries?: Maybe<Array<Maybe<WorkPreferenceIndustry>>>;
};

export type SubmitExpertJobTitlesInput = {
  clientMutationId: Scalars['String'];
  titles?: InputMaybe<Array<ExpertTitleInput>>;
};

export type SubmitExpertJobTitlesPayload = {
  __typename?: 'SubmitExpertJobTitlesPayload';
  clientMutationId: Scalars['String'];
  workPreferenceJobTitles?: Maybe<Array<Maybe<WorkPreferenceJobTitle>>>;
};

export type SubmitExpertLocationsInput = {
  clientMutationId: Scalars['String'];
  isApplication?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<ExpertLocationInput>>;
};

export type SubmitExpertLocationsPayload = {
  __typename?: 'SubmitExpertLocationsPayload';
  clientMutationId: Scalars['String'];
  workPreferenceLocations?: Maybe<Array<Maybe<WorkPreferenceLocation>>>;
};

export type SubmitExpertTopSkillsInput = {
  clientMutationId: Scalars['String'];
  skills?: InputMaybe<Array<ExpertSkillInput>>;
};

export type SubmitExpertTopSkillsPayload = {
  __typename?: 'SubmitExpertTopSkillsPayload';
  clientMutationId: Scalars['String'];
  workPreferenceSkills?: Maybe<Array<Maybe<WorkPreferenceSkill>>>;
};

export type SubmitInsuranceDeclarationInput = {
  clientMutationId: Scalars['String'];
};

export type SubmitInsuranceDeclarationPayload = {
  __typename?: 'SubmitInsuranceDeclarationPayload';
  clientMutationId: Scalars['String'];
  insuranceDeclarationDate?: Maybe<Scalars['Date']>;
};

export type SubmitInvoiceInput = {
  budgetUnit?: InputMaybe<Scalars['String']>;
  clientMutationId: Scalars['String'];
  clientName?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  contractId?: InputMaybe<Scalars['ID']>;
  currency?: InputMaybe<Scalars['String']>;
  dateEnd: Scalars['NaiveDateTime'];
  dateStart: Scalars['NaiveDateTime'];
  deliverables?: InputMaybe<Array<InputMaybe<DeliverableInput>>>;
  expenses?: InputMaybe<Array<InputMaybe<ExpenseInput>>>;
  expertPaymentTermDays?: InputMaybe<Scalars['Int']>;
  finalInvoice?: InputMaybe<Scalars['Boolean']>;
  invoiceAs?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  paymentTermsType?: InputMaybe<PaymentTermsType>;
  projectId: Scalars['ID'];
  projectType?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['Decimal']>;
  remoteId?: InputMaybe<Scalars['String']>;
  timesheets?: InputMaybe<Array<InputMaybe<TimesheetInput>>>;
  totalAmount?: InputMaybe<Scalars['Decimal']>;
};

export type SubmitInvoicePayload = {
  __typename?: 'SubmitInvoicePayload';
  clientMutationId: Scalars['String'];
  paymentInvoice?: Maybe<PaymentInvoice>;
};

export type SubmitMultiInvoiceInput = {
  clientMutationId: Scalars['String'];
  invoices?: InputMaybe<Array<InputMaybe<InvoiceInput>>>;
};

export type SubmitMultiInvoicePayload = {
  __typename?: 'SubmitMultiInvoicePayload';
  clientMutationId: Scalars['String'];
  paymentInvoices?: Maybe<Array<Maybe<PaymentInvoice>>>;
};

export type SubmitWorkingRightsDeclarationInput = {
  clientMutationId: Scalars['String'];
  workingRights?: InputMaybe<ExpertWorkingRights>;
};

export type SubmitWorkingRightsDeclarationPayload = {
  __typename?: 'SubmitWorkingRightsDeclarationPayload';
  clientMutationId: Scalars['String'];
  workingRights?: Maybe<ExpertWorkingRights>;
  workingRightsDeclarationDate?: Maybe<Scalars['Date']>;
};

export type Tag = Node & {
  __typename?: 'Tag';
  /** The ID of an object */
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type TagConnection = {
  __typename?: 'TagConnection';
  edges?: Maybe<Array<Maybe<TagEdge>>>;
  pageInfo: PageInfo;
};

export type TagEdge = {
  __typename?: 'TagEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Tag>;
};

export type TaxRate = Node & {
  __typename?: 'TaxRate';
  /** The ID of an object */
  id: Scalars['ID'];
  rate: Scalars['Float'];
  startDate: Scalars['Timestamp'];
};

export type TaxRegion = Node & {
  __typename?: 'TaxRegion';
  countryCode: Scalars['String'];
  currentRate: Scalars['Float'];
  /** The ID of an object */
  id: Scalars['ID'];
  name: Scalars['String'];
  rates: Array<TaxRate>;
};

export type TaxRegionConnection = {
  __typename?: 'TaxRegionConnection';
  edges?: Maybe<Array<Maybe<TaxRegionEdge>>>;
  pageInfo: PageInfo;
};

export type TaxRegionEdge = {
  __typename?: 'TaxRegionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<TaxRegion>;
};

export type Thread = Node & {
  __typename?: 'Thread';
  /** The ID of an object */
  id: Scalars['ID'];
  latestMessageTimestamp: Scalars['String'];
  messages?: Maybe<Array<Maybe<Message>>>;
  participants?: Maybe<Array<Maybe<Contact>>>;
  profileCode?: Maybe<Scalars['String']>;
  projectCode: Scalars['String'];
  status?: Maybe<MessageStatus>;
  unread: Scalars['Boolean'];
};

export type ThreadConnection = {
  __typename?: 'ThreadConnection';
  edges?: Maybe<Array<Maybe<ThreadEdge>>>;
  pageInfo: PageInfo;
};

export type ThreadEdge = {
  __typename?: 'ThreadEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Thread>;
};

export type Timesheet = {
  __typename?: 'Timesheet';
  dateStart?: Maybe<Scalars['NaiveDateTime']>;
  note?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Decimal']>;
};

export type TimesheetInput = {
  dateStart: Scalars['NaiveDateTime'];
  note?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Decimal'];
};

export enum TimesheetReviewStatus {
  Submitted = 'SUBMITTED',
  TimesheetRejected = 'TIMESHEET_REJECTED'
}

export type Timezone = {
  __typename?: 'Timezone';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type UnpauseProjectInput = {
  clientMutationId: Scalars['String'];
  projectId: Scalars['ID'];
};

export type UnpauseProjectPayload = {
  __typename?: 'UnpauseProjectPayload';
  clientMutationId: Scalars['String'];
  project?: Maybe<Project>;
};

export type UpdateAchievementInput = {
  clientMutationId: Scalars['String'];
  description: Scalars['String'];
  endDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  isPublished?: InputMaybe<Scalars['Boolean']>;
  /**
   * Including media will do 3 things: insert new media, update existing media if
   * it has an id and delete any existing media if its not provided.
   */
  media?: InputMaybe<Array<AchievementMediaInput>>;
  role: Scalars['String'];
  skills?: InputMaybe<Array<SkillInput>>;
  startDate: Scalars['Date'];
  title: Scalars['String'];
};

export type UpdateAchievementPayload = {
  __typename?: 'UpdateAchievementPayload';
  achievement?: Maybe<Achievement>;
  clientMutationId: Scalars['String'];
};

export type UpdateEducationItemInput = {
  clientMutationId: Scalars['String'];
  educationItem?: InputMaybe<EducationItemInput>;
  educationItemId: Scalars['ID'];
};

export type UpdateEducationItemPayload = {
  __typename?: 'UpdateEducationItemPayload';
  clientMutationId: Scalars['String'];
  educationItem?: Maybe<EducationItem>;
};

export type UpdateExpertAdditionalRolesInput = {
  additionalRoles: Array<ServiceInput>;
  clientMutationId: Scalars['String'];
};

export type UpdateExpertAdditionalRolesPayload = {
  __typename?: 'UpdateExpertAdditionalRolesPayload';
  additionalRoles?: Maybe<Array<Maybe<BusinessService>>>;
  clientMutationId: Scalars['String'];
};

export type UpdateExpertAvailabilityInput = {
  availability?: InputMaybe<Scalars['String']>;
  clientMutationId: Scalars['String'];
  unavailableUntilDate?: InputMaybe<Scalars['String']>;
};

export type UpdateExpertAvailabilityPayload = {
  __typename?: 'UpdateExpertAvailabilityPayload';
  clientMutationId: Scalars['String'];
  user?: Maybe<User>;
};

export type UpdateExpertBusinessDetailsInput = {
  abn?: InputMaybe<Scalars['String']>;
  acn?: InputMaybe<Scalars['String']>;
  clientMutationId: Scalars['String'];
  gstRegistered?: InputMaybe<Scalars['Boolean']>;
  onboardingTaskId?: InputMaybe<Scalars['ID']>;
  operatingType?: InputMaybe<OperatingType>;
  registeredBusinessName?: InputMaybe<Scalars['String']>;
  tfn?: InputMaybe<Scalars['String']>;
};

export type UpdateExpertBusinessDetailsPayload = {
  __typename?: 'UpdateExpertBusinessDetailsPayload';
  clientMutationId: Scalars['String'];
  onboardingTask?: Maybe<OnboardingTask>;
  user?: Maybe<User>;
};

export type UpdateExpertBusinessServiceInput = {
  businessServiceId: Scalars['ID'];
};

export type UpdateExpertBusinessServicePayload = {
  __typename?: 'UpdateExpertBusinessServicePayload';
  businessService?: Maybe<BusinessService>;
};

export type UpdateExpertCommunicationPreferenceInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** ID is the communication preference ID not the user communication preference ID */
  id: Scalars['ID'];
  snoozeForMonths?: InputMaybe<Scalars['Int']>;
};

export type UpdateExpertCommunicationPreferencePayload = {
  __typename?: 'UpdateExpertCommunicationPreferencePayload';
  userCommunicationPreference?: Maybe<UserCommunicationPreference>;
};

export type UpdateExpertContactDetailsInput = {
  clientMutationId: Scalars['String'];
  phoneMobile?: InputMaybe<Scalars['String']>;
};

export type UpdateExpertContactDetailsPayload = {
  __typename?: 'UpdateExpertContactDetailsPayload';
  clientMutationId: Scalars['String'];
  user?: Maybe<User>;
};

export type UpdateExpertInput = {
  clientMutationId: Scalars['String'];
  dailyRate?: InputMaybe<Scalars['Float']>;
  firstname?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  lastname?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['ID']>;
  phoneMobile?: InputMaybe<Scalars['String']>;
};

export type UpdateExpertInsuranceDeclarationInput = {
  clientMutationId: Scalars['String'];
  hasInsurance: Scalars['Boolean'];
  professionalIndemnityLimitInMillion?: InputMaybe<Scalars['Int']>;
  publicLiabilityLimitInMillion?: InputMaybe<Scalars['Int']>;
  workersCompensationCover?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateExpertInsuranceDeclarationPayload = {
  __typename?: 'UpdateExpertInsuranceDeclarationPayload';
  clientMutationId: Scalars['String'];
  user?: Maybe<User>;
};

export type UpdateExpertLanguagesInput = {
  clientMutationId: Scalars['String'];
  languages?: InputMaybe<Array<UserLanguageInput>>;
};

export type UpdateExpertLanguagesPayload = {
  __typename?: 'UpdateExpertLanguagesPayload';
  clientMutationId: Scalars['String'];
  user?: Maybe<User>;
};

export type UpdateExpertPayload = {
  __typename?: 'UpdateExpertPayload';
  clientMutationId: Scalars['String'];
  user?: Maybe<User>;
};

export type UpdateExpertPaymentInformationInput = {
  abn?: InputMaybe<Scalars['String']>;
  acn?: InputMaybe<Scalars['String']>;
  ausResident?: InputMaybe<Scalars['Boolean']>;
  bankAccountType?: InputMaybe<BankAccountType>;
  clientMutationId: Scalars['String'];
  gstRegistered?: InputMaybe<Scalars['Boolean']>;
  hasInsurance?: InputMaybe<Scalars['Boolean']>;
  isLegallyAuthorised?: InputMaybe<Scalars['Boolean']>;
  operatingType?: InputMaybe<ConsultantBusinessType>;
  paypalEmail?: InputMaybe<Scalars['String']>;
  professionalIndemnityLimitInMillion?: InputMaybe<Scalars['Int']>;
  publicLiabilityLimitInMillion?: InputMaybe<Scalars['Int']>;
  registeredBusinessName?: InputMaybe<Scalars['String']>;
  residencyStatus?: InputMaybe<ResidencyStatusType>;
  residencyStatusOther?: InputMaybe<Scalars['String']>;
  workersCompensationCover?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateExpertPaymentInformationPayload = {
  __typename?: 'UpdateExpertPaymentInformationPayload';
  clientMutationId: Scalars['String'];
  user?: Maybe<User>;
};

export type UpdateExpertRatesInput = {
  clientMutationId: Scalars['String'];
  currency?: InputMaybe<Scalars['String']>;
  maxDailyRate?: InputMaybe<Scalars['Decimal']>;
  maxHourlyRate?: InputMaybe<Scalars['Decimal']>;
  minDailyRate?: InputMaybe<Scalars['Decimal']>;
  minHourlyRate?: InputMaybe<Scalars['Decimal']>;
};

export type UpdateExpertRatesPayload = {
  __typename?: 'UpdateExpertRatesPayload';
  clientMutationId: Scalars['String'];
  user?: Maybe<User>;
};

export type UpdateExpertTaxSettingsInput = {
  ausResident?: InputMaybe<Scalars['Boolean']>;
  clientMutationId: Scalars['String'];
  gstRegistered?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateExpertTaxSettingsPayload = {
  __typename?: 'UpdateExpertTaxSettingsPayload';
  clientMutationId: Scalars['String'];
  user?: Maybe<User>;
};

export type UpdateOrganisationDetailsInput = {
  clientMutationId: Scalars['String'];
  crn: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateOrganisationDetailsPayload = {
  __typename?: 'UpdateOrganisationDetailsPayload';
  clientMutationId: Scalars['String'];
  organisation?: Maybe<Organisation>;
};

export type UpdatePasswordInput = {
  clientMutationId: Scalars['String'];
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
};

export type UpdatePasswordPayload = {
  __typename?: 'UpdatePasswordPayload';
  clientMutationId: Scalars['String'];
  confirmation?: Maybe<Scalars['Boolean']>;
};

export type UpdateProfileInput = {
  clearanceLevel?: InputMaybe<ClearanceLevel>;
  clearanceLevelExpiry?: InputMaybe<Scalars['Date']>;
  clientMutationId: Scalars['String'];
  code: Scalars['String'];
  headline?: InputMaybe<Scalars['String']>;
  summary?: InputMaybe<Scalars['String']>;
};

export type UpdateProfilePayload = {
  __typename?: 'UpdateProfilePayload';
  clientMutationId: Scalars['String'];
  lifecycle?: Maybe<Lifecycle>;
  profile?: Maybe<Profile>;
};

export type UpdateProjectInput = {
  clientMutationId: Scalars['String'];
  projectBrief?: InputMaybe<ProjectBriefInput>;
  projectId: Scalars['ID'];
};

export type UpdateProjectPayload = {
  __typename?: 'UpdateProjectPayload';
  clientMutationId: Scalars['String'];
  project?: Maybe<Project>;
};

export type UpdateSkillsInput = {
  clientMutationId: Scalars['String'];
  skills: Array<SkillInput>;
};

export type UpdateSkillsPayload = {
  __typename?: 'UpdateSkillsPayload';
  clientMutationId: Scalars['String'];
  skills?: Maybe<Array<Maybe<Skill>>>;
};

export type UpdateWorkItemInput = {
  clientMutationId: Scalars['String'];
  workItem?: InputMaybe<WorkItemInput>;
  workItemId: Scalars['ID'];
};

export type UpdateWorkItemPayload = {
  __typename?: 'UpdateWorkItemPayload';
  clientMutationId: Scalars['String'];
  workItem?: Maybe<WorkHistory>;
};

export type User = Node & {
  __typename?: 'User';
  abn?: Maybe<Scalars['String']>;
  accountUrl?: Maybe<Scalars['String']>;
  activePostedProjects?: Maybe<Array<Project>>;
  additionalRoles?: Maybe<Array<Maybe<BusinessService>>>;
  availability?: Maybe<Availability>;
  averageProjectRating?: Maybe<Scalars['Float']>;
  claimed?: Maybe<Scalars['Boolean']>;
  /**
   * Details specific to a client.
   *
   * `client` when the user's role is `user`, and `null` when the user has any other role.
   */
  client?: Maybe<Client>;
  /**
   * Details specific to a consultant.
   *
   * `Consultant` when the user's role is `CONSULTANT`, and `null` when the user has any other role.
   */
  consultant?: Maybe<Consultant>;
  country?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customFieldValues?: Maybe<Array<Maybe<CustomFieldValue>>>;
  cvProcessingInProgress?: Maybe<Scalars['Boolean']>;
  dailyRate?: Maybe<Scalars['Float']>;
  dateCreated?: Maybe<Scalars['NaiveDateTime']>;
  dateUpdated?: Maybe<Scalars['NaiveDateTime']>;
  disciplineId?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  emailVerified?: Maybe<Scalars['Boolean']>;
  firstname?: Maybe<Scalars['String']>;
  gstRegistered?: Maybe<Scalars['Boolean']>;
  hourlyRate?: Maybe<Scalars['Float']>;
  /** The ID of an object */
  id: Scalars['ID'];
  isImpersonating?: Maybe<Scalars['Boolean']>;
  /** Whether or not the user is an admin of any organisation. */
  isOrgAdmin?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Array<Maybe<UserLanguage>>>;
  lastname?: Maybe<Scalars['String']>;
  location?: Maybe<LegacyLocation>;
  locationId?: Maybe<Scalars['ID']>;
  locked?: Maybe<Scalars['Boolean']>;
  operatingType?: Maybe<OperatingType>;
  organisation?: Maybe<Organisation>;
  organisationRole?: Maybe<OrganisationRole>;
  /** All Pay360 invoices for the logged in expert */
  pay360Invoices?: Maybe<Array<Maybe<Pay360Invoice>>>;
  phoneMobile?: Maybe<Scalars['String']>;
  platformWhitelabelling?: Maybe<Scalars['String']>;
  private?: Maybe<Scalars['Boolean']>;
  profileInterests?: Maybe<Array<Maybe<ProfileInterest>>>;
  profilePicture?: Maybe<ProfilePicture>;
  profilePictureDomain?: Maybe<Scalars['String']>;
  profileUrl?: Maybe<Scalars['String']>;
  publicCode?: Maybe<Scalars['String']>;
  receiveProjectInvitationEmail?: Maybe<Scalars['Boolean']>;
  receiveProjectOpportunityEmail?: Maybe<Scalars['Boolean']>;
  registeredBusinessName?: Maybe<Scalars['String']>;
  requiresTotpSetup?: Maybe<Scalars['Boolean']>;
  reviews: Array<RatingAndReview>;
  role?: Maybe<UserRole>;
  smsVerified?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['String']>;
  status: StatusOptions;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uploadedCv?: Maybe<Scalars['String']>;
  verificationLevel?: Maybe<VerificationLevel>;
  viewerHasFavourited: Scalars['Boolean'];
  workingSituation?: Maybe<WorkingSituation>;
};


export type UserProfilePictureArgs = {
  size: ProfilePictureSize;
};

/** The ID on this node is the communication preference ID not the user communication preference ID */
export type UserCommunicationPreference = Node & {
  __typename?: 'UserCommunicationPreference';
  enabled: Scalars['Boolean'];
  /** The ID of an object */
  id: Scalars['ID'];
  name: Scalars['String'];
  snoozedUntil?: Maybe<Scalars['DateTime']>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  pageInfo: PageInfo;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<User>;
};

export type UserLanguage = Node & {
  __typename?: 'UserLanguage';
  /** The ID of an object */
  id: Scalars['ID'];
  language: Scalars['String'];
  proficiency: LanguageProficiency;
};

export type UserLanguageInput = {
  language: Scalars['String'];
  proficiency: LanguageProficiency;
};

export enum UserRole {
  Admin = 'ADMIN',
  Client = 'CLIENT',
  Consultant = 'CONSULTANT',
  Superadmin = 'SUPERADMIN'
}

export enum VerificationLevel {
  Futured = 'FUTURED',
  Unvetted = 'UNVETTED',
  Vetted = 'VETTED'
}

export type VerifyEmailInput = {
  clientMutationId: Scalars['String'];
  code?: InputMaybe<Scalars['String']>;
};

export type VerifyEmailPayload = {
  __typename?: 'VerifyEmailPayload';
  clientMutationId: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
};

export type VerifySmsInput = {
  clientMutationId: Scalars['String'];
  code?: InputMaybe<Scalars['String']>;
};

export type VerifySmsPayload = {
  __typename?: 'VerifySmsPayload';
  clientMutationId: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
};

export type Viewer = Node & {
  __typename?: 'Viewer';
  canSearchSecurityClearances: Scalars['Boolean'];
  /** User's communcation preferences */
  communicationPreferences?: Maybe<Array<Maybe<UserCommunicationPreference>>>;
  displayBrowseProjects?: Maybe<Scalars['Boolean']>;
  displayInviteWelcome?: Maybe<Scalars['Boolean']>;
  /**
   * Whether or not the viewer has unread messages.
   *
   * This field always returns `false` for logged out users.
   */
  hasMessages?: Maybe<Scalars['Boolean']>;
  hasUnreadNotifications?: Maybe<Scalars['Boolean']>;
  /** The ID of an object */
  id: Scalars['ID'];
  isImpersonating?: Maybe<Scalars['Boolean']>;
  /** User's notifications */
  notifications?: Maybe<NotificationConnection>;
  role?: Maybe<Role>;
  totpEnabled: Scalars['Boolean'];
  /**
   * The user entity for viewer. This contains detiails for the currently logged in user.
   *
   * If impersonating, this will be the impersonated user.
   */
  user?: Maybe<User>;
};


export type ViewerNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  daysAgo?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
};

export type ViewerInvitation = {
  __typename?: 'ViewerInvitation';
  date?: Maybe<Scalars['Timestamp']>;
  declinedInvitation?: Maybe<DeclinedInvitation>;
};

export type WorkHistory = Node & {
  __typename?: 'WorkHistory';
  businessServices?: Maybe<Array<BusinessService>>;
  /**
   * The end month of the work history item. Values will be an integer from `0`-`12` or `null`.
   *
   * `1` through `12` represent January through December, sequentially.
   *
   * `0` and `null` represent empty values.
   *
   * This field has no meaning if `isCurrent` is `true`.
   */
  endMonth?: Maybe<Scalars['Int']>;
  /**
   * The end year of the work history item. Values will be an integer from `1901`-`2155`, `0`, or `null`.
   *
   * `0` and `null` represent empty values.
   *
   * This field has no meaning if `isCurrent` is `true`.
   */
  endYear?: Maybe<Scalars['Int']>;
  expertOrganisations?: Maybe<Array<LegacyOrganisation>>;
  /** The ID of an object */
  id: Scalars['ID'];
  industries?: Maybe<Array<Maybe<Industry>>>;
  /**
   * A flag designating whether or not the work history item is currently in progress. For historical reasons,
   * `endMonth` and `endYear` have no meaning if this field is `true`.
   */
  isCurrent?: Maybe<Scalars['Boolean']>;
  /** The organisation that the work was performed for. */
  organisation?: Maybe<LegacyOrganisation>;
  /**
   * The start month of the work history item. Values will be an integer from `0`-`12` or `null`.
   *
   * `1` through `12` represent January through December, sequentially.
   *
   * `0` and `null` represent empty values.
   */
  startMonth?: Maybe<Scalars['Int']>;
  /**
   * The start year of the work history item. Values will be an integer from `1901`-`2155`, `0`, or `null`.
   *
   * `0` and `null` represent empty values.
   */
  startYear?: Maybe<Scalars['Int']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  urlDescription?: Maybe<Scalars['String']>;
};

export type WorkHistoryConnection = {
  __typename?: 'WorkHistoryConnection';
  edges?: Maybe<Array<Maybe<WorkHistoryEdge>>>;
  pageInfo: PageInfo;
};

export type WorkHistoryEdge = {
  __typename?: 'WorkHistoryEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<WorkHistory>;
};

export type WorkItem = Node & {
  __typename?: 'WorkItem';
  businessServices?: Maybe<Array<BusinessService>>;
  endMonth?: Maybe<Scalars['Int']>;
  endYear?: Maybe<Scalars['Int']>;
  expertOrganisations?: Maybe<Array<LegacyOrganisation>>;
  /** The ID of an object */
  id: Scalars['ID'];
  industries?: Maybe<Array<Industry>>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  organisation?: Maybe<LegacyOrganisation>;
  selfEmployed?: Maybe<Scalars['Boolean']>;
  startMonth: Scalars['Int'];
  startYear?: Maybe<Scalars['Int']>;
  summary?: Maybe<Scalars['HtmlRichText']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  urlDescription?: Maybe<Scalars['String']>;
};

export type WorkItemInput = {
  businessServices: Array<ServiceInput>;
  company?: InputMaybe<Scalars['String']>;
  customBusinessServices?: InputMaybe<Array<Scalars['String']>>;
  endMonth?: InputMaybe<Scalars['Int']>;
  endYear?: InputMaybe<Scalars['Int']>;
  expertOrganisations: Array<ExpertOrganisationInput>;
  industries: Array<IndustryInput>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  organisationId?: InputMaybe<Scalars['ID']>;
  roleTitleId?: InputMaybe<Scalars['ID']>;
  startMonth?: InputMaybe<Scalars['Int']>;
  startYear?: InputMaybe<Scalars['Int']>;
  summary?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  urlDescription?: InputMaybe<Scalars['String']>;
};

export type WorkPreference = {
  __typename?: 'WorkPreference';
  company?: Maybe<WorkPreferenceCompany>;
  locations?: Maybe<Array<Maybe<WorkPreferenceLocation>>>;
  preferredIndustries?: Maybe<Array<Maybe<WorkPreferenceIndustry>>>;
  role?: Maybe<WorkPreferenceIdealRole>;
  skills?: Maybe<Array<Maybe<WorkPreferenceSkill>>>;
  titles?: Maybe<Array<Maybe<WorkPreferenceJobTitle>>>;
  undesirableIndustries?: Maybe<Array<Maybe<WorkPreferenceIndustry>>>;
};

export type WorkPreferenceCompany = Node & {
  __typename?: 'WorkPreferenceCompany';
  companySizes?: Maybe<Array<Maybe<Scalars['String']>>>;
  companyStages?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The ID of an object */
  id: Scalars['ID'];
};

export type WorkPreferenceIdealRole = Node & {
  __typename?: 'WorkPreferenceIdealRole';
  hoursPerWeek?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  projectLength?: Maybe<Array<Maybe<Scalars['String']>>>;
  roleStatus?: Maybe<Array<Maybe<Scalars['String']>>>;
  roleType?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WorkPreferenceIndustry = Node & {
  __typename?: 'WorkPreferenceIndustry';
  /** The ID of an object */
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
};

export type WorkPreferenceJobTitle = Node & {
  __typename?: 'WorkPreferenceJobTitle';
  /** The ID of an object */
  id: Scalars['ID'];
  jobTitle?: Maybe<Scalars['String']>;
};

export type WorkPreferenceLocation = Node & {
  __typename?: 'WorkPreferenceLocation';
  daysWfh?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  officeLocation?: Maybe<Array<Maybe<LegacyLocation>>>;
  order?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Array<Maybe<Scalars['String']>>>;
  travelDistance?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type WorkPreferenceSkill = Node & {
  __typename?: 'WorkPreferenceSkill';
  classificationSkill?: Maybe<Skill>;
  /** The ID of an object */
  id: Scalars['ID'];
  order?: Maybe<Scalars['String']>;
  skillLevel?: Maybe<Scalars['String']>;
};

export type WorkingRightsDocument = Node & {
  __typename?: 'WorkingRightsDocument';
  documentType: Scalars['String'];
  /** The ID of an object */
  id: Scalars['ID'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']>;
  url?: Maybe<Scalars['String']>;
};

export type WorkingRightsDocumentInput = {
  /** Unique identifier assigned when file was uploaded */
  documentCode: Scalars['String'];
  /** Passport, Driver Licence, Birth Ceritificate, etc. */
  documentType: Scalars['String'];
};

export enum WorkingSituation {
  Available = 'AVAILABLE',
  Considering = 'CONSIDERING'
}

export enum YearsExperience {
  Years_0_3 = 'YEARS_0_3',
  Years_3_5 = 'YEARS_3_5',
  Years_5_7 = 'YEARS_5_7',
  Years_7_10 = 'YEARS_7_10',
  Years_10Plus = 'YEARS_10_PLUS'
}

export type ClientProjectSummary_GraphFragment = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', client?: { __typename?: 'Client', memberOf: Array<{ __typename?: 'Organisation', name: string, id: string }>, project?: { __typename?: 'Project', title?: string | null, code?: string | null, hash?: string | null, unlisted?: boolean | null, summary?: string | null, companyType?: string | null, organisationIndustry?: string | null, extensionProbability?: ExtensionProbabilityType | null, duration?: string | null, dateStart?: any | null, startAsap?: boolean | null, earn?: string | null, budgetCurrency?: string | null, locationType?: string | null, intensity?: string | null, postedDateUtc?: any | null, applicantCount?: number | null, state?: ProjectState | null, companyName?: string | null, isInsured?: ProjectIsInsured | null, idealExpertSummary?: string | null, idealExpertTitle?: string | null, usesOneRatePricingModel?: boolean | null, id: string, viewerHasBookmarked?: boolean | null, companySize?: string | null, organisationMemberSinceDate?: any | null, clearanceLevel?: ClearanceLevel | null, seniorityLevel?: SeniorityLevel | null, yearsExperience?: YearsExperience | null, contractingCompany?: ContractingCompanyName | null, daysWfh?: number | null, companyOverview?: string | null, projectLocation?: string | null, servicesRequired: Array<{ __typename?: 'BusinessService', name: string }>, unapprovedServicesRequired: Array<{ __typename?: 'BusinessService', name: string }>, industries: Array<{ __typename?: 'Industry', name?: string | null }>, skills?: Array<{ __typename?: 'Skill', skill: string } | null> | null, locationDetails?: { __typename?: 'LegacyLocation', city?: string | null, country?: string | null } | null, organisation?: { __typename?: 'Organisation', id: string, name: string, contractingCompany?: string | null, hasMarketplace?: boolean | null, hasWhitelabel?: boolean | null, companySize?: string | null, isTimesheetRequired?: boolean | null, industries?: Array<{ __typename?: 'Industry', name?: string | null } | null> | null } | null, status?: { __typename?: 'ProjectStatus', applicationCount?: number | null, interviewCount?: number | null, offerCount?: number | null, expertStatus?: ExpertStatus | null, expertStatusDate?: any | null } | null, organisationIndustries?: Array<{ __typename?: 'Industry', name?: string | null } | null> | null, applications?: { __typename?: 'ApplicationConnection', edges?: Array<{ __typename?: 'ApplicationEdge', node?: { __typename?: 'Application', dateSubmitted?: any | null } | null } | null> | null } | null, remoteLocation?: { __typename?: 'RemoteLocation', country?: string | null, countryCode?: string | null, timezone?: string | null, timezoneRange?: number | null, type?: RemoteLocationType | null } | null } | null } | null } | null } | null };

export type AddApplicationViewedInteractionMutationVariables = Exact<{
  input: AddApplicationViewedInteractionInput;
}>;


export type AddApplicationViewedInteractionMutation = { __typename?: 'Mutation', addApplicationViewedInteraction?: { __typename?: 'AddApplicationViewedInteractionPayload', application?: { __typename?: 'Application', applicantStatus?: { __typename?: 'ApplicantStatus', viewed?: boolean | null } | null } | null } | null };

export type CancelProjectMutationVariables = Exact<{
  input: CancelProjectInput;
}>;


export type CancelProjectMutation = { __typename?: 'Mutation', cancelProject?: { __typename?: 'CancelProjectPayload', project?: { __typename?: 'Project', id: string, state?: ProjectState | null } | null } | null };

export type DeclineExpertApplicationMutationVariables = Exact<{
  input: DeclineExpertApplicationInput;
}>;


export type DeclineExpertApplicationMutation = { __typename?: 'Mutation', declineExpertApplication?: { __typename?: 'DeclineExpertApplicationPayload', application?: { __typename?: 'Application', applicantStatus?: { __typename?: 'ApplicantStatus', expertStatus?: ExpertStatus | null, expertDeclinedReason?: string | null } | null } | null } | null };

export type InviteExpertToInterviewMutationVariables = Exact<{
  input: InviteExpertToInterviewInput;
}>;


export type InviteExpertToInterviewMutation = { __typename?: 'Mutation', inviteExpertToInterview?: { __typename?: 'InviteExpertToInterviewPayload', application?: { __typename?: 'Application', applicantStatus?: { __typename?: 'ApplicantStatus', expertStatus?: ExpertStatus | null } | null } | null } | null };

export type OnholdProjectMutationVariables = Exact<{
  input: OnholdProjectInput;
}>;


export type OnholdProjectMutation = { __typename?: 'Mutation', onholdProject?: { __typename?: 'OnholdProjectPayload', project?: { __typename?: 'Project', id: string, state?: ProjectState | null } | null } | null };

export type PauseProjectMutationVariables = Exact<{
  input: PauseProjectInput;
}>;


export type PauseProjectMutation = { __typename?: 'Mutation', pauseProject?: { __typename?: 'PauseProjectPayload', project?: { __typename?: 'Project', id: string, state?: ProjectState | null } | null } | null };

export type UnpauseProjectMutationVariables = Exact<{
  input: UnpauseProjectInput;
}>;


export type UnpauseProjectMutation = { __typename?: 'Mutation', unpauseProject?: { __typename?: 'UnpauseProjectPayload', project?: { __typename?: 'Project', id: string, state?: ProjectState | null } | null } | null };

export type ContractListQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
}>;


export type ContractListQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', client?: { __typename?: 'Client', project?: { __typename?: 'Project', id: string, title?: string | null, code?: string | null, state?: ProjectState | null, unlisted?: boolean | null, usesOneRatePricingModel?: boolean | null, offers?: { __typename?: 'ContractConnection', edges?: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', approved?: boolean | null, code?: string | null, currency?: string | null, amount?: number | null, budgetUnit?: string | null, startDate?: any | null, createdDate?: any | null, status?: ContractStatus | null, offerInitiatedByAdmin?: boolean | null, expert?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, profileUrl?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null> | null } | null, agreedContracts?: { __typename?: 'ContractConnection', edges?: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', code?: string | null, currency?: string | null, amount?: number | null, budgetUnit?: string | null, startDate?: any | null, agreedDate?: any | null, createdDate?: any | null, status?: ContractStatus | null, active?: boolean | null, endingSoon?: boolean | null, ended?: boolean | null, expert?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, profileUrl?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null, review?: { __typename?: 'RatingAndReview', hash?: string | null, feedbackUserPublic?: { __typename?: 'FeedbackUserPublic', rating?: number | null, review?: string | null } | null } | null } | null } | null> | null } | null, extensionOffers?: { __typename?: 'ContractConnection', edges?: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', approved?: boolean | null, disapproved?: boolean | null, code?: string | null, currency?: string | null, amount?: number | null, budgetUnit?: string | null, startDate?: any | null, agreedDate?: any | null, createdDate?: any | null, status?: ContractStatus | null, active?: boolean | null, endingSoon?: boolean | null, ended?: boolean | null, expert?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, profileUrl?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null, review?: { __typename?: 'RatingAndReview', hash?: string | null, feedbackUserPublic?: { __typename?: 'FeedbackUserPublic', rating?: number | null, review?: string | null } | null } | null } | null } | null> | null } | null } | null } | null } | null } | null };

export type ExpertsToReviewDetailQueryVariables = Exact<{
  projectCode?: InputMaybe<Scalars['String']>;
  applicationId?: InputMaybe<Scalars['ID']>;
}>;


export type ExpertsToReviewDetailQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', client?: { __typename?: 'Client', project?: { __typename?: 'Project', id: string, application?: { __typename?: 'Application', id: string, dateSubmitted?: any | null, budget?: string | null, dateStart?: string | null, statement?: string | null, proposedRate?: any | null, proposedRateUnit?: string | null, applicant?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, phoneMobile?: string | null, email?: string | null, publicCode?: string | null, consultant?: { __typename?: 'Consultant', averageProjectRating?: number | null, projectCount?: number | null, profile?: { __typename?: 'Profile', code: string, headline?: string | null } | null, paymentInformation?: { __typename?: 'PaymentInformation', gstRegistered?: boolean | null } | null } | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null, customFieldValues?: Array<{ __typename?: 'CustomFieldValue', id: string, order?: number | null, value?: any | null, definition?: { __typename?: 'CustomFieldDefinition', id: string, name?: string | null, values?: any | null, type?: CustomFieldDefinitionType | null, default?: any | null, description?: string | null } | null } | null> | null } | null, applicantStatus?: { __typename?: 'ApplicantStatus', recommended?: boolean | null, viewed?: boolean | null, invited?: boolean | null, invitedBy?: string | null, expertStatus?: ExpertStatus | null, expertDeclinedReason?: string | null } | null, selectedExperiences?: { __typename?: 'ApplicationExperienceConnection', edges?: Array<{ __typename?: 'ApplicationExperienceEdge', node?: { __typename?: 'ApplicationExperience', id: string, description?: string | null, item?: { __typename: 'Project', id: string, title?: string | null, dateStart?: any | null, dateCompleted?: any | null, companyName?: string | null } | { __typename: 'WorkHistory', id: string, title?: string | null, startMonth?: number | null, startYear?: number | null, endMonth?: number | null, endYear?: number | null, isCurrent?: boolean | null, organisation?: { __typename?: 'LegacyOrganisation', name?: string | null } | null } | null } | null } | null> | null } | null } | null } | null } | null } | null } | null };

export type ExpertsToReviewQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
}>;


export type ExpertsToReviewQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', client?: { __typename?: 'Client', project?: { __typename?: 'Project', id: string, title?: string | null, code?: string | null, unlisted?: boolean | null, state?: ProjectState | null, dateStart?: any | null, duration?: string | null, budgetCurrency?: string | null, budgetMin?: number | null, summary?: string | null, rateUnit?: string | null, contractTerms?: string | null, usesOneRatePricingModel?: boolean | null, isLps?: boolean | null, createdBy?: { __typename?: 'User', publicCode?: string | null, organisation?: { __typename?: 'Organisation', name: string, commission?: number | null, hasMarketplace?: boolean | null, gstPercentage?: any | null } | null } | null, offers?: { __typename?: 'ContractConnection', edges?: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', code?: string | null, status?: ContractStatus | null, amount?: number | null, budgetUnit?: string | null, currency?: string | null, startDate?: any | null, createdDate?: any | null, expert?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, profileUrl?: string | null, publicCode?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null> | null } | null, agreedContracts?: { __typename?: 'ContractConnection', edges?: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', code?: string | null, expert?: { __typename?: 'User', profileUrl?: string | null, publicCode?: string | null } | null } | null } | null> | null } | null, applications?: { __typename?: 'ApplicationConnection', edges?: Array<{ __typename?: 'ApplicationEdge', node?: { __typename?: 'Application', id: string, dateSubmitted?: any | null, applicant?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, consultant?: { __typename?: 'Consultant', profile?: { __typename?: 'Profile', headline?: string | null } | null } | null } | null, applicantStatus?: { __typename?: 'ApplicantStatus', recommended?: boolean | null, viewed?: boolean | null, invited?: boolean | null, expertStatus?: ExpertStatus | null, expertDeclinedReason?: string | null } | null } | null } | null> | null } | null } | null } | null } | null } | null };

export type PageClientProjectDetailsQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
}>;


export type PageClientProjectDetailsQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', client?: { __typename?: 'Client', memberOf: Array<{ __typename?: 'Organisation', isTimesheetRequired?: boolean | null, name: string, id: string }>, project?: { __typename?: 'Project', id: string, title?: string | null, code?: string | null, hash?: string | null, unlisted?: boolean | null, state?: ProjectState | null, dateCreated?: any | null, isCreator?: boolean | null, summary?: string | null, companyType?: string | null, organisationIndustry?: string | null, extensionProbability?: ExtensionProbabilityType | null, duration?: string | null, dateStart?: any | null, startAsap?: boolean | null, earn?: string | null, budgetCurrency?: string | null, locationType?: string | null, intensity?: string | null, postedDateUtc?: any | null, applicantCount?: number | null, companyName?: string | null, isInsured?: ProjectIsInsured | null, idealExpertSummary?: string | null, idealExpertTitle?: string | null, usesOneRatePricingModel?: boolean | null, viewerHasBookmarked?: boolean | null, companySize?: string | null, organisationMemberSinceDate?: any | null, clearanceLevel?: ClearanceLevel | null, seniorityLevel?: SeniorityLevel | null, yearsExperience?: YearsExperience | null, contractingCompany?: ContractingCompanyName | null, daysWfh?: number | null, companyOverview?: string | null, projectLocation?: string | null, offers?: { __typename?: 'ContractConnection', edges?: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', code?: string | null } | null } | null> | null } | null, invoices?: { __typename?: 'PaymentInvoiceConnection', edges?: Array<{ __typename?: 'PaymentInvoiceEdge', node?: { __typename?: 'PaymentInvoice', id: string, code?: string | null, status?: InvoiceStatus | null, dateCreated?: any | null, expertName?: string | null, clientName?: string | null, dateStart?: any | null, dateEnd?: any | null, dateStatusUpdated?: any | null } | null } | null> | null } | null, organisation?: { __typename?: 'Organisation', isTimesheetRequired?: boolean | null, id: string, name: string, contractingCompany?: string | null, hasMarketplace?: boolean | null, hasWhitelabel?: boolean | null, companySize?: string | null, industries?: Array<{ __typename?: 'Industry', name?: string | null } | null> | null } | null, servicesRequired: Array<{ __typename?: 'BusinessService', name: string }>, unapprovedServicesRequired: Array<{ __typename?: 'BusinessService', name: string }>, industries: Array<{ __typename?: 'Industry', name?: string | null }>, skills?: Array<{ __typename?: 'Skill', skill: string } | null> | null, locationDetails?: { __typename?: 'LegacyLocation', city?: string | null, country?: string | null } | null, status?: { __typename?: 'ProjectStatus', applicationCount?: number | null, interviewCount?: number | null, offerCount?: number | null, expertStatus?: ExpertStatus | null, expertStatusDate?: any | null } | null, organisationIndustries?: Array<{ __typename?: 'Industry', name?: string | null } | null> | null, applications?: { __typename?: 'ApplicationConnection', edges?: Array<{ __typename?: 'ApplicationEdge', node?: { __typename?: 'Application', dateSubmitted?: any | null } | null } | null> | null } | null, remoteLocation?: { __typename?: 'RemoteLocation', country?: string | null, countryCode?: string | null, timezone?: string | null, timezoneRange?: number | null, type?: RemoteLocationType | null } | null } | null } | null } | null } | null };

export type ClientProjectArchivedCard_ProjectFragment = { __typename?: 'Project', id: string, code?: string | null, dateCreated?: any | null, title?: string | null, state?: ProjectState | null, privacy?: ProjectPrivacy | null, unlisted?: boolean | null, isCreator?: boolean | null, createdBy?: { __typename?: 'User', firstname?: string | null, lastname?: string | null } | null, status?: { __typename?: 'ProjectStatus', applicationCount?: number | null, interviewCount?: number | null, offerCount?: number | null } | null, agreedContracts?: { __typename?: 'ContractConnection', edges?: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', code?: string | null, expert?: { __typename?: 'User', firstname?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null, review?: { __typename?: 'RatingAndReview', hash?: string | null, feedbackUserPublic?: { __typename?: 'FeedbackUserPublic', rating?: number | null, review?: string | null } | null } | null } | null } | null> | null } | null };

export type ClientProjectArchivedList_GraphFragment = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', client?: { __typename?: 'Client', projects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: string, code?: string | null, dateCreated?: any | null, title?: string | null, state?: ProjectState | null, privacy?: ProjectPrivacy | null, unlisted?: boolean | null, isCreator?: boolean | null, createdBy?: { __typename?: 'User', firstname?: string | null, lastname?: string | null } | null, status?: { __typename?: 'ProjectStatus', applicationCount?: number | null, interviewCount?: number | null, offerCount?: number | null } | null, agreedContracts?: { __typename?: 'ContractConnection', edges?: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', code?: string | null, expert?: { __typename?: 'User', firstname?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null, review?: { __typename?: 'RatingAndReview', hash?: string | null, feedbackUserPublic?: { __typename?: 'FeedbackUserPublic', rating?: number | null, review?: string | null } | null } | null } | null } | null> | null } | null } | null } | null> | null } | null } | null } | null } | null };

export type ClientProjectArchivedTabQueryVariables = Exact<{
  filter?: InputMaybe<ClientProjectFilter>;
  count: Scalars['Int'];
}>;


export type ClientProjectArchivedTabQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', client?: { __typename?: 'Client', projects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: string, code?: string | null, dateCreated?: any | null, title?: string | null, state?: ProjectState | null, privacy?: ProjectPrivacy | null, unlisted?: boolean | null, isCreator?: boolean | null, createdBy?: { __typename?: 'User', firstname?: string | null, lastname?: string | null } | null, status?: { __typename?: 'ProjectStatus', applicationCount?: number | null, interviewCount?: number | null, offerCount?: number | null } | null, agreedContracts?: { __typename?: 'ContractConnection', edges?: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', code?: string | null, expert?: { __typename?: 'User', firstname?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null, review?: { __typename?: 'RatingAndReview', hash?: string | null, feedbackUserPublic?: { __typename?: 'FeedbackUserPublic', rating?: number | null, review?: string | null } | null } | null } | null } | null> | null } | null } | null } | null> | null } | null } | null } | null } | null };

export type ClientProjectFilledCard_ProjectFragment = { __typename?: 'Project', id: string, code?: string | null, dateCreated?: any | null, title?: string | null, unlisted?: boolean | null, isCreator?: boolean | null, createdBy?: { __typename?: 'User', firstname?: string | null, lastname?: string | null } | null, agreedContracts?: { __typename?: 'ContractConnection', edges?: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', code?: string | null, startDate?: any | null, endDate?: any | null, expert?: { __typename?: 'User', firstname?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null> | null } | null, extensionOffers?: { __typename?: 'ContractConnection', edges?: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', code?: string | null, startDate?: any | null, endDate?: any | null, expert?: { __typename?: 'User', firstname?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null> | null } | null };

export type ClientProjectFilledList_GraphFragment = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', client?: { __typename?: 'Client', projects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: string, code?: string | null, dateCreated?: any | null, title?: string | null, unlisted?: boolean | null, isCreator?: boolean | null, createdBy?: { __typename?: 'User', firstname?: string | null, lastname?: string | null } | null, agreedContracts?: { __typename?: 'ContractConnection', edges?: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', code?: string | null, startDate?: any | null, endDate?: any | null, expert?: { __typename?: 'User', firstname?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null> | null } | null, extensionOffers?: { __typename?: 'ContractConnection', edges?: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', code?: string | null, startDate?: any | null, endDate?: any | null, expert?: { __typename?: 'User', firstname?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null> | null } | null } | null } | null> | null } | null } | null } | null } | null };

export type ClientProjectFilledTabQueryVariables = Exact<{
  filter?: InputMaybe<ClientProjectFilter>;
  count: Scalars['Int'];
}>;


export type ClientProjectFilledTabQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', client?: { __typename?: 'Client', projects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: string, code?: string | null, dateCreated?: any | null, title?: string | null, unlisted?: boolean | null, isCreator?: boolean | null, createdBy?: { __typename?: 'User', firstname?: string | null, lastname?: string | null } | null, agreedContracts?: { __typename?: 'ContractConnection', edges?: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', code?: string | null, startDate?: any | null, endDate?: any | null, expert?: { __typename?: 'User', firstname?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null> | null } | null, extensionOffers?: { __typename?: 'ContractConnection', edges?: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', code?: string | null, startDate?: any | null, endDate?: any | null, expert?: { __typename?: 'User', firstname?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null> | null } | null } | null } | null> | null } | null } | null } | null } | null };

export type ClientProjectSourcingCard_ProjectFragment = { __typename?: 'Project', id: string, code?: string | null, dateCreated?: any | null, title?: string | null, state?: ProjectState | null, privacy?: ProjectPrivacy | null, unlisted?: boolean | null, isSharedWithPrivateCloud?: boolean | null, isCreator?: boolean | null, createdBy?: { __typename?: 'User', firstname?: string | null, lastname?: string | null } | null, status?: { __typename?: 'ProjectStatus', applicationCount?: number | null, interviewCount?: number | null, offerCount?: number | null } | null, offers?: { __typename?: 'ContractConnection', edges?: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', code?: string | null, status?: ContractStatus | null } | null } | null> | null } | null };

export type ClientProjectSourcingList_GraphFragment = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', organisationRole?: OrganisationRole | null, client?: { __typename?: 'Client', projects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: string, code?: string | null, dateCreated?: any | null, title?: string | null, state?: ProjectState | null, privacy?: ProjectPrivacy | null, unlisted?: boolean | null, isSharedWithPrivateCloud?: boolean | null, isCreator?: boolean | null, createdBy?: { __typename?: 'User', firstname?: string | null, lastname?: string | null } | null, status?: { __typename?: 'ProjectStatus', applicationCount?: number | null, interviewCount?: number | null, offerCount?: number | null } | null, offers?: { __typename?: 'ContractConnection', edges?: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', code?: string | null, status?: ContractStatus | null } | null } | null> | null } | null } | null } | null> | null } | null } | null } | null } | null };

export type ClientProjectSourcingTabQueryVariables = Exact<{
  filter?: InputMaybe<ClientProjectFilter>;
  count: Scalars['Int'];
}>;


export type ClientProjectSourcingTabQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', organisationRole?: OrganisationRole | null, client?: { __typename?: 'Client', projects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: string, code?: string | null, dateCreated?: any | null, title?: string | null, state?: ProjectState | null, privacy?: ProjectPrivacy | null, unlisted?: boolean | null, isSharedWithPrivateCloud?: boolean | null, isCreator?: boolean | null, createdBy?: { __typename?: 'User', firstname?: string | null, lastname?: string | null } | null, status?: { __typename?: 'ProjectStatus', applicationCount?: number | null, interviewCount?: number | null, offerCount?: number | null } | null, offers?: { __typename?: 'ContractConnection', edges?: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', code?: string | null, status?: ContractStatus | null } | null } | null> | null } | null } | null } | null> | null } | null } | null } | null } | null };

export type ActivateProjectMutationVariables = Exact<{
  input: ActivateProjectInput;
}>;


export type ActivateProjectMutation = { __typename?: 'Mutation', activateProject?: { __typename?: 'ActivateProjectPayload', project?: { __typename?: 'Project', code?: string | null, state?: ProjectState | null } | null } | null };

export type ClientAcceptOfferMutationVariables = Exact<{
  input: AcceptOfferInput;
}>;


export type ClientAcceptOfferMutation = { __typename?: 'Mutation', acceptOffer?: { __typename?: 'AcceptOfferPayload', contract?: { __typename?: 'Contract', id: string, code?: string | null, title?: string | null, amount?: number | null, currency?: string | null, budgetType?: string | null, budgetUnit?: string | null, status?: ContractStatus | null, createdDate?: any | null, startDate?: any | null, endDate?: any | null, agreedDate?: any | null, duration?: number | null, durationUnit?: string | null, allowReimbursements?: boolean | null, expensesCovered?: string | null, requiredReceipts?: boolean | null, milestones?: string | null, detail?: string | null, expert?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, abn?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null };

export type ClientApproveOfferMutationVariables = Exact<{
  input: ApproveOfferInput;
}>;


export type ClientApproveOfferMutation = { __typename?: 'Mutation', approveOffer?: { __typename?: 'ApproveOfferPayload', contract?: { __typename?: 'Contract', id: string, code?: string | null, title?: string | null, amount?: number | null, currency?: string | null, budgetType?: string | null, budgetUnit?: string | null, status?: ContractStatus | null, createdDate?: any | null, startDate?: any | null, endDate?: any | null, agreedDate?: any | null, duration?: number | null, durationUnit?: string | null, allowReimbursements?: boolean | null, expensesCovered?: string | null, requiredReceipts?: boolean | null, milestones?: string | null, detail?: string | null, approved?: boolean | null, offerInitiatedByAdmin?: boolean | null, expert?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, abn?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null };

export type ClientCreateOfferMutationVariables = Exact<{
  input: CreateOfferInput;
}>;


export type ClientCreateOfferMutation = { __typename?: 'Mutation', createOffer?: { __typename?: 'CreateOfferPayload', contract?: { __typename?: 'Contract', id: string, code?: string | null, expert?: { __typename?: 'User', publicCode?: string | null } | null } | null } | null };

export type ClientDisapproveOfferMutationVariables = Exact<{
  input: DisapproveOfferInput;
}>;


export type ClientDisapproveOfferMutation = { __typename?: 'Mutation', disapproveOffer?: { __typename?: 'DisapproveOfferPayload', contract?: { __typename?: 'Contract', id: string, code?: string | null, title?: string | null, amount?: number | null, currency?: string | null, budgetType?: string | null, budgetUnit?: string | null, status?: ContractStatus | null, createdDate?: any | null, startDate?: any | null, endDate?: any | null, agreedDate?: any | null, duration?: number | null, durationUnit?: string | null, disapproved?: boolean | null, allowReimbursements?: boolean | null, expensesCovered?: string | null, requiredReceipts?: boolean | null, milestones?: string | null, detail?: string | null, approved?: boolean | null, offerInitiatedByAdmin?: boolean | null, expert?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, abn?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null };

export type ClientModifyOfferMutationVariables = Exact<{
  input: ModifyOfferInput;
}>;


export type ClientModifyOfferMutation = { __typename?: 'Mutation', modifyOffer?: { __typename?: 'ModifyOfferPayload', contract?: { __typename?: 'Contract', id: string, code?: string | null, expert?: { __typename?: 'User', publicCode?: string | null } | null } | null } | null };

export type ExpertAcceptOfferMutationVariables = Exact<{
  input: AcceptOfferInput;
}>;


export type ExpertAcceptOfferMutation = { __typename?: 'Mutation', acceptOffer?: { __typename?: 'AcceptOfferPayload', contract?: { __typename?: 'Contract', id: string, code?: string | null, title?: string | null, amount?: number | null, currency?: string | null, budgetType?: string | null, budgetUnit?: string | null, status?: ContractStatus | null, createdDate?: any | null, startDate?: any | null, endDate?: any | null, agreedDate?: any | null, duration?: number | null, durationUnit?: string | null, allowReimbursements?: boolean | null, expensesCovered?: string | null, requiredReceipts?: boolean | null, milestones?: string | null, detail?: string | null, expert?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, abn?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null };

export type ExpertCounterOfferMutationVariables = Exact<{
  input: ModifyOfferInput;
}>;


export type ExpertCounterOfferMutation = { __typename?: 'Mutation', modifyOffer?: { __typename?: 'ModifyOfferPayload', contract?: { __typename?: 'Contract', id: string, code?: string | null, title?: string | null, createdDate?: any | null, agreedDate?: any | null, status?: ContractStatus | null, detail?: string | null, milestones?: string | null, allowReimbursements?: boolean | null, requiredReceipts?: boolean | null, expensesCovered?: string | null, amount?: number | null, budgetUnit?: string | null, currency?: string | null, startDate?: any | null, duration?: number | null, durationUnit?: string | null, terms?: string | null, expert?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, abn?: string | null, gstRegistered?: boolean | null, publicCode?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null };

export type ExpertCreateOfferMutationVariables = Exact<{
  input: CreateOfferInput;
}>;


export type ExpertCreateOfferMutation = { __typename?: 'Mutation', createOffer?: { __typename?: 'CreateOfferPayload', contract?: { __typename?: 'Contract', id: string, code?: string | null, title?: string | null, createdDate?: any | null, agreedDate?: any | null, status?: ContractStatus | null, detail?: string | null, milestones?: string | null, allowReimbursements?: boolean | null, requiredReceipts?: boolean | null, expensesCovered?: string | null, amount?: number | null, budgetUnit?: string | null, currency?: string | null, startDate?: any | null, duration?: number | null, durationUnit?: string | null, terms?: string | null, expert?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, abn?: string | null, gstRegistered?: boolean | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null };

export type ExpertDeclineOfferMutationVariables = Exact<{
  input: DeclineOfferInput;
}>;


export type ExpertDeclineOfferMutation = { __typename?: 'Mutation', declineOffer?: { __typename?: 'DeclineOfferPayload', contract?: { __typename?: 'Contract', id: string, code?: string | null, title?: string | null, amount?: number | null, currency?: string | null, budgetType?: string | null, budgetUnit?: string | null, status?: ContractStatus | null, createdDate?: any | null, startDate?: any | null, endDate?: any | null, agreedDate?: any | null, duration?: number | null, durationUnit?: string | null, allowReimbursements?: boolean | null, expensesCovered?: string | null, requiredReceipts?: boolean | null, milestones?: string | null, detail?: string | null, expert?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, abn?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null };

export type ContractDetailsQueryVariables = Exact<{
  projectCode?: InputMaybe<Scalars['String']>;
  contractCode?: InputMaybe<Scalars['String']>;
}>;


export type ContractDetailsQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', role?: UserRole | null, client?: { __typename?: 'Client', memberOf: Array<{ __typename?: 'Organisation', name: string, paymentTermDays?: number | null, expertPaymentTermDays?: number | null }>, project?: { __typename?: 'Project', id: string, title?: string | null, code?: string | null, state?: ProjectState | null, unlisted?: boolean | null, usesOneRatePricingModel?: boolean | null, contractingCompany?: ContractingCompanyName | null, createdBy?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, role?: UserRole | null, publicCode?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null, organisation?: { __typename?: 'Organisation', name: string, paymentTermDays?: number | null, expertPaymentTermDays?: number | null, usesOneRatePricingModel?: boolean | null, gstPercentage?: any | null } | null } | null } | null, contract?: { __typename?: 'Contract', id: string, canApprove?: boolean | null, paymentPolicy?: PaymentPolicy | null, applicationId?: string | null, code?: string | null, title?: string | null, amount?: number | null, currency?: string | null, budgetType?: string | null, budgetUnit?: string | null, status?: ContractStatus | null, createdDate?: any | null, startDate?: any | null, endDate?: any | null, agreedDate?: any | null, duration?: number | null, durationUnit?: string | null, allowReimbursements?: boolean | null, expensesCovered?: string | null, requiredReceipts?: boolean | null, milestones?: string | null, detail?: string | null, terms?: string | null, approved?: boolean | null, disapproved?: boolean | null, active?: boolean | null, endingSoon?: boolean | null, ended?: boolean | null, isLps?: boolean | null, isSourced?: boolean | null, offerInitiatedByAdmin?: boolean | null, taxRegion?: { __typename?: 'TaxRegion', currentRate: number } | null, expert?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, abn?: string | null, gstRegistered?: boolean | null, profileUrl?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null, relatedContracts?: Array<{ __typename?: 'Contract', id: string, canApprove?: boolean | null, code?: string | null, createdDate?: any | null, applicationId?: string | null, title?: string | null, amount?: number | null, currency?: string | null, budgetType?: string | null, budgetUnit?: string | null, status?: ContractStatus | null, startDate?: any | null, endDate?: any | null, agreedDate?: any | null, duration?: number | null, durationUnit?: string | null, allowReimbursements?: boolean | null, expensesCovered?: string | null, requiredReceipts?: boolean | null, milestones?: string | null, detail?: string | null, terms?: string | null, approved?: boolean | null, active?: boolean | null, endingSoon?: boolean | null, ended?: boolean | null, disapproved?: boolean | null, isLps?: boolean | null, isSourced?: boolean | null, offerInitiatedByAdmin?: boolean | null, paymentPolicy?: PaymentPolicy | null, expert?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, abn?: string | null, gstRegistered?: boolean | null, profileUrl?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null> | null } | null } | null } | null } | null };

export type UserContextHandlerQueryVariables = Exact<{ [key: string]: never; }>;


export type UserContextHandlerQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', id: string, role?: UserRole | null, organisationRole?: OrganisationRole | null, verificationLevel?: VerificationLevel | null, requiresTotpSetup?: boolean | null, email?: string | null, locked?: boolean | null, smsVerified?: boolean | null, emailVerified?: boolean | null, source?: string | null, consultant?: { __typename?: 'Consultant', lifecycle?: { __typename?: 'Lifecycle', accepted?: boolean | null, emailVerified?: boolean | null, basicProfileCompleted?: boolean | null, marketplaceMember?: boolean | null, privateCloudTalent?: boolean | null, claimed?: boolean | null } | null } | null, client?: { __typename?: 'Client', memberOf: Array<{ __typename?: 'Organisation', name: string, hasExplore?: boolean | null, ssoConfig?: { __typename?: 'SsoConfig', requireSso?: boolean | null } | null }> } | null } | null } | null };

export type ExpertDashboardRendererQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpertDashboardRendererQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', displayBrowseProjects?: boolean | null, user?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, location?: { __typename?: 'LegacyLocation', country?: string | null } | null, consultant?: { __typename?: 'Consultant', averageProjectRating?: number | null, totalProjectCount?: number | null, profile?: { __typename?: 'Profile', isTop1000?: boolean | null, headline?: string | null, testimonial?: string | null } | null, lifecycle?: { __typename?: 'Lifecycle', privateCloudTalent?: boolean | null, marketplaceMember?: boolean | null } | null, dashboardProjects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: string, dateCompleted?: any | null } | null } | null> | null } | null, recommendedProjects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', title?: string | null, earn?: string | null, locationType?: string | null, location?: string | null, intensity?: string | null, duration?: string | null, hash?: string | null } | null } | null> | null } | null, memberOf: Array<{ __typename?: 'Organisation', name: string, id: string }>, latestMilestone?: { __typename?: 'LatestMilestone', name?: MilestoneName | null, projectHash?: string | null } | null, dedicatedContact?: { __typename?: 'DedicatedContact', title?: string | null, firstname?: string | null, lastname?: string | null, about?: string | null, chiliPiperUrl?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null, reviews: Array<{ __typename?: 'RatingAndReview', id: string }> } | null, notifications?: { __typename?: 'NotificationConnection', totalCount: number, edges?: Array<{ __typename?: 'NotificationEdge', node?: { __typename?: 'ProjectNotification', id: string } | null } | null> | null } | null } | null, communityEvents?: { __typename?: 'CommunityEventConnection', edges?: Array<{ __typename?: 'CommunityEventEdge', node?: { __typename?: 'CommunityEvent', id: string, eventDate?: any | null, eventDetails?: string | null, topic?: string | null, name?: string | null, location?: string | null, organiser?: string | null, hostGuestProfilePicture?: string | null, image?: string | null, guestName?: string | null, slug?: string | null } | null } | null> | null } | null, articles?: { __typename?: 'ArticleConnection', edges?: Array<{ __typename?: 'ArticleEdge', node?: { __typename?: 'Article', author?: string | null, authorProfilePicture?: string | null, articleFeaturedContent?: string | null, name?: string | null, featured?: boolean | null, mainImage?: string | null, readingTime?: number | null, releaseDate?: any | null, slug?: string | null } | null } | null> | null } | null };

export type SliderComponent_GraphFragment = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null, consultant?: { __typename?: 'Consultant', averageProjectRating?: number | null, profile?: { __typename?: 'Profile', headline?: string | null, isTop1000?: boolean | null, testimonial?: string | null } | null, dashboardProjects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: string, dateCompleted?: any | null } | null } | null> | null } | null } | null, reviews: Array<{ __typename?: 'RatingAndReview', id: string }> } | null } | null };

export type ExpertDashboardAccountCard_GraphFragment = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', consultant?: { __typename?: 'Consultant', dedicatedContact?: { __typename?: 'DedicatedContact', title?: string | null, firstname?: string | null, lastname?: string | null, about?: string | null, chiliPiperUrl?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null } | null };

export type MobileAccountCard_GraphFragment = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', consultant?: { __typename?: 'Consultant', dedicatedContact?: { __typename?: 'DedicatedContact', title?: string | null, firstname?: string | null, lastname?: string | null, about?: string | null, chiliPiperUrl?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null } | null };

export type MobilePersonCardHandle_GraphFragment = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', firstname?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null };

export type ExpertDashboardNotifications_GraphFragment = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', notifications?: { __typename?: 'NotificationConnection', totalCount: number, edges?: Array<{ __typename?: 'NotificationEdge', node?: { __typename?: 'ProjectNotification', id: string } | null } | null> | null } | null } | null };

export type ExpertDashboardPanel_GraphFragment = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', consultant?: { __typename?: 'Consultant', latestMilestone?: { __typename?: 'LatestMilestone', name?: MilestoneName | null, projectHash?: string | null } | null } | null } | null } | null };

export type DismissLatestMilestoneMutationVariables = Exact<{
  input: DismissLatestMilestoneInput;
}>;


export type DismissLatestMilestoneMutation = { __typename?: 'Mutation', dismissLatestMilestone?: { __typename?: 'DismissLatestMilestonePayload', success?: boolean | null } | null };

export type ExpertDashboardPersonCard_GraphFragment = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null, consultant?: { __typename?: 'Consultant', averageProjectRating?: number | null, profile?: { __typename?: 'Profile', headline?: string | null, isTop1000?: boolean | null, testimonial?: string | null } | null, dashboardProjects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: string, dateCompleted?: any | null } | null } | null> | null } | null } | null, reviews: Array<{ __typename?: 'RatingAndReview', id: string }> } | null } | null };

export type ExpertDashboardRecommendedProjects_GraphFragment = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', consultant?: { __typename?: 'Consultant', totalProjectCount?: number | null, recommendedProjects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', title?: string | null, earn?: string | null, locationType?: string | null, location?: string | null, intensity?: string | null, duration?: string | null, hash?: string | null } | null } | null> | null } | null, memberOf: Array<{ __typename?: 'Organisation', name: string, id: string }> } | null } | null } | null };

export type ClaimMindTheGapMutationVariables = Exact<{ [key: string]: never; }>;


export type ClaimMindTheGapMutation = { __typename?: 'Mutation', claimMindTheGap?: { __typename?: 'ClaimMindTheGapPayload', success?: boolean | null } | null };

export type AstuteRegistration_GraphFragment = { __typename?: 'AstuteRegistration', id: string, status: OnboardingTaskStatus, paymentInformation?: { __typename?: 'PaymentInformation', id: string, hasAcn?: boolean | null } | null };

export type ConfirmAbnAcnNonPayroll_GraphFragment = { __typename?: 'ConfirmAbnAcnNonPayroll', id: string, status: OnboardingTaskStatus, paymentInformation?: { __typename?: 'PaymentInformation', id: string, abn?: string | null, acn?: string | null, gstRegistered?: boolean | null, registeredBusinessName?: string | null, hasAcn?: boolean | null } | null };

export type ConfirmAbnAcnPayroll_GraphFragment = { __typename?: 'ConfirmAbnAcnPayroll', id: string, status: OnboardingTaskStatus, paymentInformation?: { __typename?: 'PaymentInformation', id: string, abn?: string | null, acn?: string | null, gstRegistered?: boolean | null, registeredBusinessName?: string | null, hasAcn?: boolean | null } | null };

type ConfirmAbnAcn_Graph_AstuteRegistration_Fragment = { __typename?: 'AstuteRegistration', id: string, name: string };

type ConfirmAbnAcn_Graph_ConfirmAbnAcnNonPayroll_Fragment = { __typename?: 'ConfirmAbnAcnNonPayroll', id: string, name: string, status: OnboardingTaskStatus, paymentInformation?: { __typename?: 'PaymentInformation', id: string, abn?: string | null, acn?: string | null, gstRegistered?: boolean | null, registeredBusinessName?: string | null, hasAcn?: boolean | null } | null };

type ConfirmAbnAcn_Graph_ConfirmAbnAcnPayroll_Fragment = { __typename?: 'ConfirmAbnAcnPayroll', id: string, name: string, status: OnboardingTaskStatus, paymentInformation?: { __typename?: 'PaymentInformation', id: string, abn?: string | null, acn?: string | null, gstRegistered?: boolean | null, registeredBusinessName?: string | null, hasAcn?: boolean | null } | null };

type ConfirmAbnAcn_Graph_RemoteWorkSafetyChecklist_Fragment = { __typename?: 'RemoteWorkSafetyChecklist', id: string, name: string };

type ConfirmAbnAcn_Graph_RightToWorkInAustralia_Fragment = { __typename?: 'RightToWorkInAustralia', id: string, name: string };

export type ConfirmAbnAcn_GraphFragment = ConfirmAbnAcn_Graph_AstuteRegistration_Fragment | ConfirmAbnAcn_Graph_ConfirmAbnAcnNonPayroll_Fragment | ConfirmAbnAcn_Graph_ConfirmAbnAcnPayroll_Fragment | ConfirmAbnAcn_Graph_RemoteWorkSafetyChecklist_Fragment | ConfirmAbnAcn_Graph_RightToWorkInAustralia_Fragment;

export type RemoteWorkSafetyChecklist_GraphFragment = { __typename?: 'RemoteWorkSafetyChecklist', id: string, status: OnboardingTaskStatus, url?: string | null, contract?: { __typename?: 'Contract', startDate?: any | null } | null };

export type RightToWorkInAustralia_GraphFragment = { __typename?: 'RightToWorkInAustralia', id: string, status: OnboardingTaskStatus, documents?: Array<{ __typename?: 'WorkingRightsDocument', documentType: string, insertedAt?: any | null } | null> | null };

type RightToWork_Graph_AstuteRegistration_Fragment = { __typename?: 'AstuteRegistration', id: string, name: string };

type RightToWork_Graph_ConfirmAbnAcnNonPayroll_Fragment = { __typename?: 'ConfirmAbnAcnNonPayroll', id: string, name: string };

type RightToWork_Graph_ConfirmAbnAcnPayroll_Fragment = { __typename?: 'ConfirmAbnAcnPayroll', id: string, name: string };

type RightToWork_Graph_RemoteWorkSafetyChecklist_Fragment = { __typename?: 'RemoteWorkSafetyChecklist', id: string, name: string };

type RightToWork_Graph_RightToWorkInAustralia_Fragment = { __typename?: 'RightToWorkInAustralia', id: string, name: string, status: OnboardingTaskStatus, documents?: Array<{ __typename?: 'WorkingRightsDocument', documentType: string, insertedAt?: any | null } | null> | null };

export type RightToWork_GraphFragment = RightToWork_Graph_AstuteRegistration_Fragment | RightToWork_Graph_ConfirmAbnAcnNonPayroll_Fragment | RightToWork_Graph_ConfirmAbnAcnPayroll_Fragment | RightToWork_Graph_RemoteWorkSafetyChecklist_Fragment | RightToWork_Graph_RightToWorkInAustralia_Fragment;

export type ConfirmAbnAcnMutationVariables = Exact<{
  input: UpdateExpertBusinessDetailsInput;
}>;


export type ConfirmAbnAcnMutation = { __typename?: 'Mutation', updateExpertBusinessDetails?: { __typename?: 'UpdateExpertBusinessDetailsPayload', onboardingTask?: { __typename: 'AstuteRegistration', id: string, name: string, status: OnboardingTaskStatus } | { __typename: 'ConfirmAbnAcnNonPayroll', id: string, name: string, status: OnboardingTaskStatus, paymentInformation?: { __typename?: 'PaymentInformation', id: string, abn?: string | null, acn?: string | null, gstRegistered?: boolean | null, registeredBusinessName?: string | null, hasAcn?: boolean | null } | null } | { __typename: 'ConfirmAbnAcnPayroll', id: string, name: string, status: OnboardingTaskStatus, paymentInformation?: { __typename?: 'PaymentInformation', id: string, abn?: string | null, acn?: string | null, gstRegistered?: boolean | null, registeredBusinessName?: string | null, hasAcn?: boolean | null } | null } | { __typename: 'RemoteWorkSafetyChecklist', id: string, name: string, status: OnboardingTaskStatus } | { __typename: 'RightToWorkInAustralia', id: string, name: string, status: OnboardingTaskStatus } | null } | null };

export type ProvideWorkingRightsDocumentsMutationVariables = Exact<{
  input: ProvideWorkingRightsDocumentsInput;
}>;


export type ProvideWorkingRightsDocumentsMutation = { __typename?: 'Mutation', provideWorkingRightsDocuments?: { __typename?: 'ProvideWorkingRightsDocumentsPayload', success?: boolean | null, onboardingTask?: { __typename: 'AstuteRegistration', id: string, name: string, status: OnboardingTaskStatus } | { __typename: 'ConfirmAbnAcnNonPayroll', id: string, name: string, status: OnboardingTaskStatus } | { __typename: 'ConfirmAbnAcnPayroll', id: string, name: string, status: OnboardingTaskStatus } | { __typename: 'RemoteWorkSafetyChecklist', id: string, name: string, status: OnboardingTaskStatus } | { __typename: 'RightToWorkInAustralia', id: string, name: string, status: OnboardingTaskStatus, documents?: Array<{ __typename?: 'WorkingRightsDocument', documentType: string, insertedAt?: any | null } | null> | null } | null } | null };

export type OnboardingChecklist_GraphFragment = { __typename?: 'Contract', onboardingChecklist?: Array<{ __typename?: 'AstuteRegistration', id: string, name: string, status: OnboardingTaskStatus, paymentInformation?: { __typename?: 'PaymentInformation', id: string, hasAcn?: boolean | null } | null } | { __typename?: 'ConfirmAbnAcnNonPayroll', id: string, name: string, status: OnboardingTaskStatus, paymentInformation?: { __typename?: 'PaymentInformation', id: string, abn?: string | null, acn?: string | null, gstRegistered?: boolean | null, registeredBusinessName?: string | null, hasAcn?: boolean | null } | null } | { __typename?: 'ConfirmAbnAcnPayroll', id: string, name: string, status: OnboardingTaskStatus, paymentInformation?: { __typename?: 'PaymentInformation', id: string, abn?: string | null, acn?: string | null, gstRegistered?: boolean | null, registeredBusinessName?: string | null, hasAcn?: boolean | null } | null } | { __typename?: 'RemoteWorkSafetyChecklist', id: string, name: string, status: OnboardingTaskStatus, url?: string | null, contract?: { __typename?: 'Contract', startDate?: any | null } | null } | { __typename?: 'RightToWorkInAustralia', id: string, name: string, status: OnboardingTaskStatus, documents?: Array<{ __typename?: 'WorkingRightsDocument', documentType: string, insertedAt?: any | null } | null> | null } | null> | null };

export type AcceptInviteMutationVariables = Exact<{
  input: AcceptExpertInvitationInput;
}>;


export type AcceptInviteMutation = { __typename?: 'Mutation', acceptExpertInvitation?: { __typename?: 'AcceptExpertInvitationPayload', isValid?: boolean | null } | null };

export type ExpertInviteQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']>;
}>;


export type ExpertInviteQuery = { __typename?: 'Query', expertInvitation?: { __typename?: 'ExpertInvitation', isValid: boolean, token: string, firstname?: string | null, lastname?: string | null, email?: string | null, invitedBy?: { __typename?: 'InvitedByUser', firstname?: string | null, lastname?: string | null, phoneMobile?: string | null, profilePicture?: { __typename?: 'ProfilePicture', width: number, height: number, source: string } | null } | null } | null };

export type InviteWelcomeQueryVariables = Exact<{ [key: string]: never; }>;


export type InviteWelcomeQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', firstname?: string | null, uploadedCv?: string | null, operatingType?: OperatingType | null, workingSituation?: WorkingSituation | null, source?: string | null, consultant?: { __typename?: 'Consultant', workHistory?: { __typename?: 'WorkHistoryConnection', edges?: Array<{ __typename?: 'WorkHistoryEdge', node?: { __typename?: 'WorkHistory', id: string } | null } | null> | null } | null } | null } | null } | null };

export type RequestResourceMutationVariables = Exact<{
  input: RequestResourceInput;
}>;


export type RequestResourceMutation = { __typename?: 'Mutation', requestResource?: { __typename?: 'RequestResourcePayload', success?: boolean | null } | null };

export type UpdateExpertClearancesMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateExpertClearancesMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'UpdateProfilePayload', profile?: { __typename?: 'Profile', id: string, clearanceLevel?: ClearanceLevel | null, clearanceLevelExpiry?: any | null } | null } | null };

export type UpdateExpertLanguagesMutationVariables = Exact<{
  input: UpdateExpertLanguagesInput;
}>;


export type UpdateExpertLanguagesMutation = { __typename?: 'Mutation', updateExpertLanguages?: { __typename?: 'UpdateExpertLanguagesPayload', user?: { __typename?: 'User', languages?: Array<{ __typename?: 'UserLanguage', language: string, proficiency: LanguageProficiency } | null> | null } | null } | null };

export type UpdateExpertRatesMutationVariables = Exact<{
  input: UpdateExpertRatesInput;
}>;


export type UpdateExpertRatesMutation = { __typename?: 'Mutation', updateExpertRates?: { __typename?: 'UpdateExpertRatesPayload', user?: { __typename?: 'User', currency?: string | null, consultant?: { __typename?: 'Consultant', profile?: { __typename?: 'Profile', minHourlyRate?: any | null, maxHourlyRate?: any | null, minDailyRate?: any | null, maxDailyRate?: any | null } | null } | null } | null } | null };

export type CreateAchievementMutationVariables = Exact<{
  input: CreateAchievementInput;
}>;


export type CreateAchievementMutation = { __typename?: 'Mutation', createAchievement?: { __typename?: 'CreateAchievementPayload', achievement?: { __typename?: 'Achievement', id: string, title?: string | null, role?: string | null, description?: string | null, startDate?: any | null, endDate?: any | null, isPublished?: boolean | null, skills?: Array<{ __typename?: 'Skill', skill: string }> | null, media?: Array<{ __typename?: 'AchievementMedia', type?: string | null, isFeatured?: boolean | null, path?: string | null, source?: string | null, order?: number | null }> | null } | null } | null };

export type CreateEducationItemMutationVariables = Exact<{
  input: CreateEducationItemInput;
}>;


export type CreateEducationItemMutation = { __typename?: 'Mutation', createEducationItem?: { __typename?: 'CreateEducationItemPayload', educationItem?: { __typename?: 'EducationItem', id: string, schoolName?: string | null, degree?: string | null, startYear?: number | null, endYear?: number | null, fieldOfStudy?: string | null, description?: string | null } | null } | null };

export type CreateWorkItemMutationVariables = Exact<{
  input: CreateWorkItemInput;
}>;


export type CreateWorkItemMutation = { __typename?: 'Mutation', createWorkItem?: { __typename?: 'CreateWorkItemPayload', workItem?: { __typename?: 'WorkHistory', endMonth?: number | null, endYear?: number | null, isCurrent?: boolean | null, startMonth?: number | null, startYear?: number | null, summary?: string | null, title?: string | null, url?: string | null, urlDescription?: string | null, businessServices?: Array<{ __typename?: 'BusinessService', id: string, isApproved: boolean, name: string }> | null, organisation?: { __typename?: 'LegacyOrganisation', id: string, name?: string | null } | null, expertOrganisations?: Array<{ __typename?: 'LegacyOrganisation', id: string, name?: string | null }> | null, industries?: Array<{ __typename?: 'Industry', id: string, name?: string | null } | null> | null } | null, lifecycle?: { __typename?: 'Lifecycle', id: string, basicProfileCompleted?: boolean | null } | null } | null };

export type DeleteAchievementMutationVariables = Exact<{
  input: DeleteAchievementInput;
}>;


export type DeleteAchievementMutation = { __typename?: 'Mutation', deleteAchievement?: { __typename?: 'DeleteAchievementPayload', achievement?: { __typename?: 'Achievement', title?: string | null } | null } | null };

export type DeleteEducationItemMutationVariables = Exact<{
  input: DeleteEducationItemInput;
}>;


export type DeleteEducationItemMutation = { __typename?: 'Mutation', deleteEducationItem?: { __typename?: 'DeleteEducationItemPayload', educationItem?: { __typename?: 'EducationItem', id: string } | null } | null };

export type DeleteWorkItemMutationVariables = Exact<{
  input: DeleteWorkItemInput;
}>;


export type DeleteWorkItemMutation = { __typename?: 'Mutation', deleteWorkItem?: { __typename?: 'DeleteWorkItemPayload', workItem?: { __typename?: 'WorkHistory', id: string } | null } | null };

export type DismissInviteModalMutationVariables = Exact<{
  input: DismissInviteModalInput;
}>;


export type DismissInviteModalMutation = { __typename?: 'Mutation', dismissInviteModal?: { __typename?: 'DismissInviteModalPayload', success?: boolean | null } | null };

export type UpdateAchievementMutationVariables = Exact<{
  item: UpdateAchievementInput;
}>;


export type UpdateAchievementMutation = { __typename?: 'Mutation', updateAchievement?: { __typename?: 'UpdateAchievementPayload', achievement?: { __typename?: 'Achievement', title?: string | null, role?: string | null, description?: string | null, startDate?: any | null, endDate?: any | null, isPublished?: boolean | null, skills?: Array<{ __typename?: 'Skill', skill: string }> | null, media?: Array<{ __typename?: 'AchievementMedia', type?: string | null, isFeatured?: boolean | null, path?: string | null, source?: string | null, order?: number | null }> | null } | null } | null };

export type UpdateEducationItemMutationVariables = Exact<{
  item: UpdateEducationItemInput;
}>;


export type UpdateEducationItemMutation = { __typename?: 'Mutation', updateEducationItem?: { __typename?: 'UpdateEducationItemPayload', educationItem?: { __typename?: 'EducationItem', id: string, degree?: string | null, endYear?: number | null, fieldOfStudy?: string | null, schoolName?: string | null, startYear?: number | null, description?: string | null } | null } | null };

export type UpdateExpertAvailabilityMutationVariables = Exact<{
  input: UpdateExpertAvailabilityInput;
}>;


export type UpdateExpertAvailabilityMutation = { __typename?: 'Mutation', updateExpertAvailability?: { __typename?: 'UpdateExpertAvailabilityPayload', user?: { __typename?: 'User', consultant?: { __typename?: 'Consultant', expertAvailability?: { __typename?: 'Availability', currentAvailability?: AvailabilityStatus | null, unavailableUntilDate?: any | null } | null } | null } | null } | null };

export type UpdateExpertMutationVariables = Exact<{
  input: UpdateExpertInput;
}>;


export type UpdateExpertMutation = { __typename?: 'Mutation', updateExpert?: { __typename?: 'UpdateExpertPayload', user?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, hourlyRate?: number | null, dailyRate?: number | null, phoneMobile?: string | null, location?: { __typename?: 'LegacyLocation', id: string, city?: string | null, country?: string | null } | null } | null } | null };

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'UpdateProfilePayload', profile?: { __typename?: 'Profile', id: string, summary?: any | null, headline?: string | null } | null, lifecycle?: { __typename?: 'Lifecycle', id: string, basicProfileCompleted?: boolean | null } | null } | null };

export type UpdateSkillsMutationVariables = Exact<{
  input: UpdateSkillsInput;
}>;


export type UpdateSkillsMutation = { __typename?: 'Mutation', updateSkills?: { __typename?: 'UpdateSkillsPayload', skills?: Array<{ __typename?: 'Skill', id: string, skill: string } | null> | null } | null };

export type UpdateWorkItemMutationVariables = Exact<{
  input: UpdateWorkItemInput;
}>;


export type UpdateWorkItemMutation = { __typename?: 'Mutation', updateWorkItem?: { __typename?: 'UpdateWorkItemPayload', workItem?: { __typename?: 'WorkHistory', endMonth?: number | null, endYear?: number | null, isCurrent?: boolean | null, startMonth?: number | null, startYear?: number | null, summary?: string | null, title?: string | null, url?: string | null, urlDescription?: string | null, businessServices?: Array<{ __typename?: 'BusinessService', id: string, isApproved: boolean, name: string }> | null, organisation?: { __typename?: 'LegacyOrganisation', id: string, name?: string | null } | null, expertOrganisations?: Array<{ __typename?: 'LegacyOrganisation', id: string, name?: string | null }> | null, industries?: Array<{ __typename?: 'Industry', id: string, name?: string | null } | null> | null } | null } | null };

export type ExpertProfileBuilderQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type ExpertProfileBuilderQuery = { __typename?: 'Query', businessServices?: { __typename?: 'BusinessServiceConnection', edges?: Array<{ __typename?: 'BusinessServiceEdge', node?: { __typename?: 'BusinessService', id: string, name: string, group: string } | null } | null> | null } | null, viewer?: { __typename?: 'Viewer', displayInviteWelcome?: boolean | null, user?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, phoneMobile?: string | null, currency?: string | null, source?: string | null, uploadedCv?: string | null, platformWhitelabelling?: string | null, profilePictureDomain?: string | null, additionalRoles?: Array<{ __typename?: 'BusinessService', id: string, name: string, group: string } | null> | null, languages?: Array<{ __typename?: 'UserLanguage', language: string, proficiency: LanguageProficiency } | null> | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null, location?: { __typename?: 'LegacyLocation', id: string, city?: string | null, country?: string | null } | null, consultant?: { __typename?: 'Consultant', id: string, lifecycle?: { __typename?: 'Lifecycle', id: string, accepted?: boolean | null, declined?: boolean | null, basicProfileCompleted?: boolean | null, marketplaceMember?: boolean | null, privateCloudTalent?: boolean | null } | null, expertAvailability?: { __typename?: 'Availability', currentAvailability?: AvailabilityStatus | null, unavailableUntilDate?: any | null } | null, profile?: { __typename?: 'Profile', id: string, availability?: string | null, summary?: any | null, headline?: string | null, code: string, discipline?: string | null, businessService?: string | null, clearanceLevel?: ClearanceLevel | null, clearanceLevelExpiry?: any | null, minHourlyRate?: any | null, maxHourlyRate?: any | null, minDailyRate?: any | null, maxDailyRate?: any | null, workPreference?: { __typename?: 'WorkPreference', titles?: Array<{ __typename?: 'WorkPreferenceJobTitle', jobTitle?: string | null } | null> | null, skills?: Array<{ __typename?: 'WorkPreferenceSkill', id: string, skillLevel?: string | null, order?: string | null, classificationSkill?: { __typename?: 'Skill', id: string, skill: string } | null } | null> | null, role?: { __typename?: 'WorkPreferenceIdealRole', roleType?: Array<string | null> | null, roleStatus?: Array<string | null> | null, hoursPerWeek?: string | null, projectLength?: Array<string | null> | null } | null, locations?: Array<{ __typename?: 'WorkPreferenceLocation', id: string, daysWfh?: string | null, order?: number | null, timezone?: Array<string | null> | null, travelDistance?: string | null, type?: string | null, officeLocation?: Array<{ __typename?: 'LegacyLocation', city?: string | null, country?: string | null, countryCode?: string | null, id: string, subdivision?: string | null } | null> | null } | null> | null, company?: { __typename?: 'WorkPreferenceCompany', companySizes?: Array<string | null> | null, companyStages?: Array<string | null> | null, id: string } | null, preferredIndustries?: Array<{ __typename?: 'WorkPreferenceIndustry', id: string, industry?: string | null } | null> | null, undesirableIndustries?: Array<{ __typename?: 'WorkPreferenceIndustry', id: string, industry?: string | null } | null> | null } | null, achievements?: { __typename?: 'AchievementConnection', edges?: Array<{ __typename?: 'AchievementEdge', node?: { __typename?: 'Achievement', id: string, title?: string | null, isPublished?: boolean | null, role?: string | null, description?: string | null, startDate?: any | null, endDate?: any | null, skills?: Array<{ __typename?: 'Skill', id: string, skill: string }> | null, media?: Array<{ __typename?: 'AchievementMedia', id: string, isFeatured?: boolean | null, path?: string | null, type?: string | null, source?: string | null, order?: number | null }> | null } | null } | null> | null } | null, educationItems?: Array<{ __typename?: 'EducationItem', id: string, schoolName?: string | null, degree?: string | null, startYear?: number | null, endYear?: number | null, fieldOfStudy?: string | null, description?: string | null }> | null, industries?: Array<{ __typename?: 'Industry', name?: string | null }> | null, skills?: Array<{ __typename?: 'Skill', id: string, skill: string }> | null } | null, workHistory?: { __typename?: 'WorkHistoryConnection', edges?: Array<{ __typename?: 'WorkHistoryEdge', node?: { __typename?: 'WorkHistory', id: string, endMonth?: number | null, endYear?: number | null, isCurrent?: boolean | null, startMonth?: number | null, startYear?: number | null, summary?: string | null, title?: string | null, url?: string | null, urlDescription?: string | null, organisation?: { __typename?: 'LegacyOrganisation', id: string, name?: string | null } | null, expertOrganisations?: Array<{ __typename?: 'LegacyOrganisation', id: string, name?: string | null }> | null, businessServices?: Array<{ __typename?: 'BusinessService', id: string, group: string, isApproved: boolean, name: string }> | null, industries?: Array<{ __typename?: 'Industry', id: string, name?: string | null } | null> | null } | null } | null> | null } | null } | null } | null } | null };

export type ExpertProfileBuilderCvProcessingQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpertProfileBuilderCvProcessingQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', id: string, cvProcessingInProgress?: boolean | null } | null } | null };

export type SubmitExpertCompaniesMutationVariables = Exact<{
  input: SubmitExpertCompaniesInput;
}>;


export type SubmitExpertCompaniesMutation = { __typename?: 'Mutation', submitExpertCompanies?: { __typename?: 'SubmitExpertCompaniesPayload', workPreferenceCompany?: { __typename?: 'WorkPreferenceCompany', companySizes?: Array<string | null> | null, companyStages?: Array<string | null> | null } | null } | null };

export type SubmitExpertIndustriesMutationVariables = Exact<{
  input: SubmitExpertIndustriesInput;
}>;


export type SubmitExpertIndustriesMutation = { __typename?: 'Mutation', submitExpertIndustries?: { __typename?: 'SubmitExpertIndustriesPayload', workPreferencePreferredIndustries?: Array<{ __typename?: 'WorkPreferenceIndustry', id: string, industry?: string | null } | null> | null, workPreferenceUndesirableIndustries?: Array<{ __typename?: 'WorkPreferenceIndustry', id: string, industry?: string | null } | null> | null } | null };

export type SubmitExpertIdealRoleMutationVariables = Exact<{
  input: SubmitExpertIdealRoleInput;
}>;


export type SubmitExpertIdealRoleMutation = { __typename?: 'Mutation', submitExpertIdealRole?: { __typename?: 'SubmitExpertIdealRolePayload', role?: { __typename?: 'WorkPreferenceIdealRole', hoursPerWeek?: string | null, projectLength?: Array<string | null> | null, roleStatus?: Array<string | null> | null, roleType?: Array<string | null> | null } | null } | null };

export type SubmitExpertTopSkillsMutationVariables = Exact<{
  input: SubmitExpertTopSkillsInput;
}>;


export type SubmitExpertTopSkillsMutation = { __typename?: 'Mutation', submitExpertTopSkills?: { __typename?: 'SubmitExpertTopSkillsPayload', workPreferenceSkills?: Array<{ __typename?: 'WorkPreferenceSkill', skillLevel?: string | null, order?: string | null, classificationSkill?: { __typename?: 'Skill', skill: string } | null } | null> | null } | null };

export type WorkLocationTypeaheadQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type WorkLocationTypeaheadQuery = { __typename?: 'Query', legacyLocations?: { __typename?: 'LegacyLocationConnection', edges?: Array<{ __typename?: 'LegacyLocationEdge', node?: { __typename?: 'LegacyLocation', id: string, city?: string | null, subdivision?: string | null, country?: string | null, countryCode?: string | null } | null } | null> | null } | null };

export type SubmitExpertLocationsMutationVariables = Exact<{
  input: SubmitExpertLocationsInput;
}>;


export type SubmitExpertLocationsMutation = { __typename?: 'Mutation', submitExpertLocations?: { __typename?: 'SubmitExpertLocationsPayload', workPreferenceLocations?: Array<{ __typename?: 'WorkPreferenceLocation', daysWfh?: string | null, order?: number | null, timezone?: Array<string | null> | null, travelDistance?: string | null, type?: string | null, details?: string | null, officeLocation?: Array<{ __typename?: 'LegacyLocation', city?: string | null, country?: string | null, countryCode?: string | null, subdivision?: string | null } | null> | null } | null> | null } | null };

export type UpdateExpertCommunicationPreferenceMutationVariables = Exact<{
  input: UpdateExpertCommunicationPreferenceInput;
}>;


export type UpdateExpertCommunicationPreferenceMutation = { __typename?: 'Mutation', updateExpertCommunicationPreference?: { __typename?: 'UpdateExpertCommunicationPreferencePayload', userCommunicationPreference?: { __typename?: 'UserCommunicationPreference', name: string, enabled: boolean, snoozedUntil?: any | null, id: string } | null } | null };

export type ConfirmProjectOpportunityEmailMutationVariables = Exact<{
  input: ConfirmProjectOpportunityEmailInput;
}>;


export type ConfirmProjectOpportunityEmailMutation = { __typename?: 'Mutation', confirmProjectOpportunityEmail?: { __typename?: 'ConfirmProjectOpportunityEmailPayload', alreadyConfirmed?: boolean | null } | null };

export type DeleteExpertAccountMutationVariables = Exact<{
  input: DeleteExpertAccountInput;
}>;


export type DeleteExpertAccountMutation = { __typename?: 'Mutation', deleteExpertAccount?: { __typename?: 'DeleteExpertAccountPayload', confirmation?: boolean | null } | null };

export type OptOutProjectEmailMutationVariables = Exact<{
  input: OptOutProjectEmailInput;
}>;


export type OptOutProjectEmailMutation = { __typename?: 'Mutation', optOutProjectEmail?: { __typename?: 'OptOutProjectEmailPayload', success?: boolean | null } | null };

export type UpdateExpertBusinessDetailsMutationVariables = Exact<{
  input: UpdateExpertBusinessDetailsInput;
}>;


export type UpdateExpertBusinessDetailsMutation = { __typename?: 'Mutation', updateExpertBusinessDetails?: { __typename?: 'UpdateExpertBusinessDetailsPayload', user?: { __typename?: 'User', consultant?: { __typename?: 'Consultant', paymentInformation?: { __typename?: 'PaymentInformation', operatingType?: ConsultantBusinessType | null, registeredBusinessName?: string | null, abn?: string | null, acn?: string | null, tfn?: string | null } | null } | null } | null } | null };

export type UpdateExpertContactDetailsMutationVariables = Exact<{
  input: UpdateExpertContactDetailsInput;
}>;


export type UpdateExpertContactDetailsMutation = { __typename?: 'Mutation', updateExpertContactDetails?: { __typename?: 'UpdateExpertContactDetailsPayload', user?: { __typename?: 'User', phoneMobile?: string | null } | null } | null };

export type UpdateExpertInsuranceDeclarationMutationVariables = Exact<{
  input: UpdateExpertInsuranceDeclarationInput;
}>;


export type UpdateExpertInsuranceDeclarationMutation = { __typename?: 'Mutation', updateExpertInsuranceDeclaration?: { __typename?: 'UpdateExpertInsuranceDeclarationPayload', clientMutationId: string, user?: { __typename?: 'User', consultant?: { __typename?: 'Consultant', insuranceInformation?: { __typename?: 'InsuranceInformation', hasInsurance?: boolean | null, workersCompensationCover?: boolean | null, publicLiabilityLimitInMillion?: number | null, professionalIndemnityLimitInMillion?: number | null } | null } | null } | null } | null };

export type UpdateExpertTaxSettingsMutationVariables = Exact<{
  input: UpdateExpertTaxSettingsInput;
}>;


export type UpdateExpertTaxSettingsMutation = { __typename?: 'Mutation', updateExpertTaxSettings?: { __typename?: 'UpdateExpertTaxSettingsPayload', user?: { __typename?: 'User', consultant?: { __typename?: 'Consultant', paymentInformation?: { __typename?: 'PaymentInformation', ausResident?: boolean | null, gstRegistered?: boolean | null } | null } | null } | null } | null };

export type ContactDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactDetailsQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', id: string, email?: string | null, phoneMobile?: string | null, platformWhitelabelling?: string | null, location?: { __typename?: 'LegacyLocation', countryCode?: string | null } | null, consultant?: { __typename?: 'Consultant', lifecycle?: { __typename?: 'Lifecycle', marketplaceMember?: boolean | null, basicProfileCompleted?: boolean | null } | null } | null } | null } | null };

export type InsuranceQueryVariables = Exact<{ [key: string]: never; }>;


export type InsuranceQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', platformWhitelabelling?: string | null, consultant?: { __typename?: 'Consultant', insuranceInformation?: { __typename?: 'InsuranceInformation', hasInsurance?: boolean | null, workersCompensationCover?: boolean | null, publicLiabilityLimitInMillion?: number | null, professionalIndemnityLimitInMillion?: number | null } | null, lifecycle?: { __typename?: 'Lifecycle', basicProfileCompleted?: boolean | null, marketplaceMember?: boolean | null } | null } | null } | null } | null };

export type PaymentMethodQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', id: string, platformWhitelabelling?: string | null, consultant?: { __typename?: 'Consultant', paymentInformation?: { __typename?: 'PaymentInformation', ausResident?: boolean | null, bankAccountType?: BankAccountType | null, operatingType?: ConsultantBusinessType | null, isLegallyAuthorised?: boolean | null, paypalEmail?: string | null, ausBankAccount?: { __typename?: 'BankAccountAus', accountName?: string | null, bsb?: string | null, accountNumber?: string | null } | null, insuranceInformation?: { __typename?: 'InsuranceInformation', hasInsurance?: boolean | null, professionalIndemnityLimitInMillion?: number | null, publicLiabilityLimitInMillion?: number | null, workersCompensationCover?: boolean | null } | null, internationalBankAccount?: { __typename?: 'BankAccountInternational', accountName?: string | null, beneficiaryAddress?: string | null, swiftCode?: string | null, iban?: string | null } | null, usBankAccount?: { __typename?: 'BankAccountUs', accountTitle?: string | null, beneficiaryAddress?: string | null, routingNumber?: string | null, swiftCode?: string | null, accountNumber?: string | null } | null, nzBankAccount?: { __typename?: 'BankAccountNz', accountName?: string | null, accountNumber?: string | null } | null } | null, lifecycle?: { __typename?: 'Lifecycle', basicProfileCompleted?: boolean | null, marketplaceMember?: boolean | null } | null } | null } | null } | null };

export type PreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type PreferencesQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', communicationPreferences?: Array<{ __typename?: 'UserCommunicationPreference', id: string, name: string, enabled: boolean, snoozedUntil?: any | null } | null> | null, user?: { __typename?: 'User', id: string, consultant?: { __typename?: 'Consultant', receiveProjectOpportunityEmail?: boolean | null, receiveProjectInvitationEmail?: boolean | null, lifecycle?: { __typename?: 'Lifecycle', basicProfileCompleted?: boolean | null } | null } | null } | null } | null };

export type TaxQueryVariables = Exact<{ [key: string]: never; }>;


export type TaxQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', id: string, platformWhitelabelling?: string | null, consultant?: { __typename?: 'Consultant', paymentInformation?: { __typename?: 'PaymentInformation', ausResident?: boolean | null, gstRegistered?: boolean | null } | null, lifecycle?: { __typename?: 'Lifecycle', basicProfileCompleted?: boolean | null, marketplaceMember?: boolean | null } | null } | null } | null } | null };

export type YourBusinessQueryVariables = Exact<{ [key: string]: never; }>;


export type YourBusinessQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', isImpersonating?: boolean | null, user?: { __typename?: 'User', platformWhitelabelling?: string | null, consultant?: { __typename?: 'Consultant', paymentInformation?: { __typename?: 'PaymentInformation', operatingType?: ConsultantBusinessType | null, registeredBusinessName?: string | null, abn?: string | null, acn?: string | null, tfn?: string | null } | null, lifecycle?: { __typename?: 'Lifecycle', marketplaceMember?: boolean | null, basicProfileCompleted?: boolean | null } | null } | null } | null } | null };

export type MultiProjectRendererQueryVariables = Exact<{ [key: string]: never; }>;


export type MultiProjectRendererQuery = { __typename?: 'Query', invoices?: { __typename?: 'PaymentInvoiceConnection', edges?: Array<{ __typename?: 'PaymentInvoiceEdge', node?: { __typename?: 'PaymentInvoice', rate?: any | null, notes?: string | null, id: string, status?: InvoiceStatus | null, dateEnd?: any | null, dateStart?: any | null, project?: { __typename?: 'Project', title?: string | null, id: string, hash?: string | null, companyName?: string | null, createdBy?: { __typename?: 'User', firstname?: string | null, lastname?: string | null } | null, currentContract?: { __typename?: 'Contract', id: string, currency?: string | null, allowReimbursements?: boolean | null } | null } | null, contract?: { __typename?: 'Contract', code?: string | null, id: string } | null, expenses?: Array<{ __typename?: 'Expense', amount?: any | null, gst?: any | null, date?: any | null, receiptFileName?: string | null, receiptFileUuid?: string | null, type?: string | null } | null> | null, timesheets?: Array<{ __typename?: 'Timesheet', quantity?: any | null, dateStart?: any | null } | null> | null } | null } | null> | null } | null, drafts?: { __typename?: 'PaymentInvoiceConnection', edges?: Array<{ __typename?: 'PaymentInvoiceEdge', node?: { __typename?: 'PaymentInvoice', notes?: string | null, rate?: any | null, id: string, status?: InvoiceStatus | null, dateEnd?: any | null, dateStart?: any | null, project?: { __typename?: 'Project', title?: string | null, id: string, hash?: string | null, companyName?: string | null, createdBy?: { __typename?: 'User', firstname?: string | null, lastname?: string | null } | null, currentContract?: { __typename?: 'Contract', id: string, currency?: string | null, allowReimbursements?: boolean | null } | null } | null, contract?: { __typename?: 'Contract', code?: string | null, id: string, budgetUnit?: string | null } | null, expenses?: Array<{ __typename?: 'Expense', amount?: any | null, gst?: any | null, date?: any | null, receiptFileName?: string | null, receiptFileUuid?: string | null, type?: string | null } | null> | null, timesheets?: Array<{ __typename?: 'Timesheet', quantity?: any | null, dateStart?: any | null } | null> | null } | null } | null> | null } | null, viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, location?: { __typename?: 'LegacyLocation', countryCode?: string | null } | null, consultant?: { __typename?: 'Consultant', activeHiredProjects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: string, unlisted?: boolean | null, title?: string | null, hash?: string | null, dateEnd?: any | null, state?: ProjectState | null, contractingCompany?: ContractingCompanyName | null, showExpertGst?: boolean | null, earliestContractStartDate?: any | null, lastInvoice?: { __typename?: 'Invoice', id: string, dateStart?: any | null, dateEnd?: any | null, amount?: any | null, invoiceOnlyDeliverables?: Array<{ __typename?: 'Deliverable', description?: string | null, amount?: any | null, note?: string | null, invoiceOnly?: boolean | null } | null> | null } | null, createdBy?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, organisation?: { __typename?: 'Organisation', name: string, isTimesheetRequired?: boolean | null, displayPaymentInformation?: boolean | null, location?: { __typename?: 'LegacyLocation', countryCode?: string | null } | null } | null } | null, expertsContracts?: { __typename?: 'ContractConnection', edges?: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', id: string, title?: string | null, amount?: number | null, budgetType?: string | null, currency?: string | null, budgetUnit?: string | null, milestones?: string | null, code?: string | null, allowReimbursements?: boolean | null, startDate?: any | null, endDate?: any | null, createdDate?: any | null, invoicedPeriods?: Array<{ __typename?: 'InvoicingPeriod', dateStart?: any | null, dateEnd?: any | null } | null> | null } | null } | null> | null } | null, invoices?: { __typename?: 'PaymentInvoiceConnection', edges?: Array<{ __typename?: 'PaymentInvoiceEdge', node?: { __typename?: 'PaymentInvoice', id: string, dateStart?: any | null, dateEnd?: any | null, status?: InvoiceStatus | null } | null } | null> | null } | null } | null } | null> | null } | null } | null } | null } | null };

export type ReviewTimesheetAnonymouslyMutationVariables = Exact<{
  input: ReviewTimesheetAnonymouslyInput;
}>;


export type ReviewTimesheetAnonymouslyMutation = { __typename?: 'Mutation', reviewTimesheetAnonymously?: { __typename?: 'ReviewTimesheetAnonymouslyPayload', alreadyReviewed?: boolean | null } | null };

export type PaymentDashboardQueryVariables = Exact<{
  startDate: Scalars['String'];
}>;


export type PaymentDashboardQuery = { __typename?: 'Query', invoices?: { __typename?: 'PaymentInvoiceConnection', edges?: Array<{ __typename?: 'PaymentInvoiceEdge', node?: { __typename?: 'PaymentInvoice', id: string, code?: string | null, status?: InvoiceStatus | null, dateCreated?: any | null, expectedDatePaid?: any | null, datePaid?: any | null, dateStatusUpdated?: any | null, timesheetSubtotal?: any | null, deliverableSubtotal?: any | null, expenseTotal?: any | null, total?: any | null, displayPaymentInformation?: boolean | null, paymentTermsType?: PaymentTermsType | null, paymentTermsFee?: any | null, expertPaymentStatus?: ExpertPaymentStatus | null, amountOutstanding?: any | null, amountPaid?: any | null, contract?: { __typename?: 'Contract', currency?: string | null, budgetType?: string | null } | null, project?: { __typename?: 'Project', hash?: string | null, title?: string | null, isLps?: boolean | null, organisation?: { __typename?: 'Organisation', name: string, isTimesheetRequired?: boolean | null } | null } | null } | null } | null> | null } | null, viewer?: { __typename?: 'Viewer', displayBrowseProjects?: boolean | null, user?: { __typename?: 'User', firstname?: string | null, country?: string | null, location?: { __typename?: 'LegacyLocation', countryCode?: string | null } | null, consultant?: { __typename?: 'Consultant', pay360EligibilityStatus?: string | null, identityVerification?: { __typename?: 'IdentityVerification', verified?: boolean | null, awaitingResult?: boolean | null } | null, profile?: { __typename?: 'Profile', vettedIntoMarketplace?: boolean | null } | null, pay360Projects?: Array<{ __typename?: 'Pay360Project', projectName?: string | null, projectCode?: string | null, clientName?: string | null, clientCompanyName?: string | null, invoices?: Array<{ __typename?: 'Pay360Invoice', id: string, reference?: string | null, status?: Pay360InvoiceStatus | null, amount?: number | null, expertAmount?: number | null, datePaid?: any | null, insertedAt?: any | null } | null> | null } | null> | null, activeHiredProjects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', title?: string | null, hash?: string | null } | null } | null> | null } | null } | null } | null } | null };

export type ReviewTimesheetAnonymouslyQueryVariables = Exact<{
  code: Scalars['String'];
  tag: Scalars['String'];
}>;


export type ReviewTimesheetAnonymouslyQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', role?: UserRole | null } | null } | null, anonymousInvoice?: { __typename?: 'PaymentInvoice', dateStart?: any | null, dateEnd?: any | null, status?: InvoiceStatus | null, timesheets?: Array<{ __typename?: 'Timesheet', dateStart?: any | null, quantity?: any | null, note?: string | null } | null> | null, deliverables?: Array<{ __typename?: 'Deliverable', description?: string | null, note?: string | null } | null> | null, contract?: { __typename?: 'Contract', budgetUnit?: string | null } | null } | null };

export type InvitingOrganisationQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type InvitingOrganisationQuery = { __typename?: 'Query', organisations?: { __typename?: 'OrganisationConnection', edges?: Array<{ __typename?: 'OrganisationEdge', node?: { __typename?: 'Organisation', id: string, name: string, lightWhitelabelImage?: string | null } | null } | null> | null } | null };

export type ReferringCompanyQueryVariables = Exact<{
  displayName?: InputMaybe<Scalars['String']>;
}>;


export type ReferringCompanyQuery = { __typename?: 'Query', contractingCompany?: { __typename?: 'ContractingCompany', lightLogoUrl?: string | null } | null };

export type LegalDocumentationQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']>;
}>;


export type LegalDocumentationQuery = { __typename?: 'Query', legalDocumentation?: { __typename?: 'OrganisationLegalDocumentation', document?: string | null, type?: string | null } | null };

export type EnableTotpMutationVariables = Exact<{
  input: EnableTotpInput;
}>;


export type EnableTotpMutation = { __typename?: 'Mutation', enableTotp?: { __typename?: 'EnableTotpPayload', success?: boolean | null } | null };

export type InitTotpSetupMutationVariables = Exact<{
  input: InitTotpSetupInput;
}>;


export type InitTotpSetupMutation = { __typename?: 'Mutation', initTotpSetup?: { __typename?: 'InitTotpSetupPayload', secret?: string | null, totpUri?: string | null } | null };

export type NotificationsRenderer_GraphFragment = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', notifications?: { __typename?: 'NotificationConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'NotificationEdge', cursor?: string | null, node?: { __typename: 'ProjectNotification', id: string, read: boolean, name: NotificationName, insertedAt: any, project?: { __typename?: 'Project', hash?: string | null, title?: string | null, organisation?: { __typename?: 'Organisation', name: string } | null } | null } | null } | null> | null } | null } | null };

export type NotificationsRendererRefetchQueryVariables = Exact<{
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type NotificationsRendererRefetchQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', notifications?: { __typename?: 'NotificationConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'NotificationEdge', cursor?: string | null, node?: { __typename: 'ProjectNotification', id: string, read: boolean, name: NotificationName, insertedAt: any, project?: { __typename?: 'Project', hash?: string | null, title?: string | null, organisation?: { __typename?: 'Organisation', name: string } | null } | null } | null } | null> | null } | null } | null };

export type NotificationsRendererQueryVariables = Exact<{
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type NotificationsRendererQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', notifications?: { __typename?: 'NotificationConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'NotificationEdge', cursor?: string | null, node?: { __typename: 'ProjectNotification', id: string, read: boolean, name: NotificationName, insertedAt: any, project?: { __typename?: 'Project', hash?: string | null, title?: string | null, organisation?: { __typename?: 'Organisation', name: string } | null } | null } | null } | null> | null } | null } | null };

export type ProjectNotification_GraphFragment = { __typename?: 'ProjectNotification', id: string, name: NotificationName, read: boolean, insertedAt: any, project?: { __typename?: 'Project', hash?: string | null, title?: string | null, organisation?: { __typename?: 'Organisation', name: string } | null } | null };

export type Notification_GraphFragment = { __typename: 'ProjectNotification', id: string, name: NotificationName, read: boolean, insertedAt: any, project?: { __typename?: 'Project', hash?: string | null, title?: string | null, organisation?: { __typename?: 'Organisation', name: string } | null } | null };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{
  input: MarkAllNotificationsAsReadInput;
}>;


export type MarkAllNotificationsAsReadMutation = { __typename?: 'Mutation', markAllNotificationsAsRead?: { __typename?: 'MarkAllNotificationsAsReadPayload', success?: boolean | null } | null };

export type InvitationAcceptFormQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type InvitationAcceptFormQuery = { __typename?: 'Query', organisationInvitation?: { __typename?: 'OrganisationInvitation', firstName?: string | null, lastName?: string | null, email?: string | null, status?: InvitationMessageStatus | null, organisation?: { __typename?: 'Organisation', name: string } | null } | null };

export type InvitationList_GraphFragment = { __typename?: 'Query', organisationInvitations?: { __typename?: 'OrganisationInvitationConnection', edges?: Array<{ __typename?: 'OrganisationInvitationEdge', node?: { __typename?: 'OrganisationInvitation', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, status?: InvitationMessageStatus | null, code?: string | null, updatedAt?: any | null, acceptedAt?: any | null, recipient?: { __typename?: 'Contact', firstname?: string | null, lastname?: string | null, profileUrl?: string | null, headline?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null> | null } | null };

export type InvitationListQueryVariables = Exact<{
  count: Scalars['Int'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type InvitationListQuery = { __typename?: 'Query', organisationInvitations?: { __typename?: 'OrganisationInvitationConnection', edges?: Array<{ __typename?: 'OrganisationInvitationEdge', node?: { __typename?: 'OrganisationInvitation', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, status?: InvitationMessageStatus | null, code?: string | null, updatedAt?: any | null, acceptedAt?: any | null, recipient?: { __typename?: 'Contact', firstname?: string | null, lastname?: string | null, profileUrl?: string | null, headline?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null> | null } | null };

export type InvitationTabQueryVariables = Exact<{
  count: Scalars['Int'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type InvitationTabQuery = { __typename?: 'Query', organisationInvitations?: { __typename?: 'OrganisationInvitationConnection', edges?: Array<{ __typename?: 'OrganisationInvitationEdge', node?: { __typename?: 'OrganisationInvitation', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, status?: InvitationMessageStatus | null, code?: string | null, updatedAt?: any | null, acceptedAt?: any | null, recipient?: { __typename?: 'Contact', firstname?: string | null, lastname?: string | null, profileUrl?: string | null, headline?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null> | null } | null, organisation?: { __typename?: 'Organisation', name: string } | null };

export type MemberList_GraphFragment = { __typename?: 'Query', organisationMembers?: { __typename?: 'UserConnection', edges?: Array<{ __typename?: 'UserEdge', node?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, dateCreated?: any | null, client?: { __typename?: 'Client', title?: string | null, profileUrl?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null> | null } | null };

export type MemberListQueryVariables = Exact<{
  count: Scalars['Int'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type MemberListQuery = { __typename?: 'Query', organisationMembers?: { __typename?: 'UserConnection', edges?: Array<{ __typename?: 'UserEdge', node?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, dateCreated?: any | null, client?: { __typename?: 'Client', title?: string | null, profileUrl?: string | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null } | null } | null } | null> | null } | null };

export type PrivateTalentInvitation_GraphFragment = { __typename?: 'Query', organisation?: { __typename?: 'Organisation', name: string } | null };

export type ClientClaimAccountQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
}>;


export type ClientClaimAccountQuery = { __typename?: 'Query', isAccountClaimed?: boolean | null };

export type PartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type PartnersQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, email?: string | null } | null } | null };

export type EligibilityPageQueryVariables = Exact<{ [key: string]: never; }>;


export type EligibilityPageQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', consultant?: { __typename?: 'Consultant', pay360EligibilityStatus?: string | null, identityVerification?: { __typename?: 'IdentityVerification', verified?: boolean | null, awaitingResult?: boolean | null } | null, paymentInformation?: { __typename?: 'PaymentInformation', abn?: string | null } | null } | null } | null } | null };

export type QualifyPay360UserMutationVariables = Exact<{
  input: QualifyPay360UserInput;
}>;


export type QualifyPay360UserMutation = { __typename?: 'Mutation', qualifyPay360User?: { __typename?: 'QualifyPay360UserPayload', pay360EligibilityStatus?: string | null } | null };

export type IdConfirmationFormQueryVariables = Exact<{ [key: string]: never; }>;


export type IdConfirmationFormQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', consultant?: { __typename?: 'Consultant', identityVerification?: { __typename?: 'IdentityVerification', verified?: boolean | null, awaitingResult?: boolean | null } | null } | null } | null } | null };

export type IdVerificationPageQueryVariables = Exact<{ [key: string]: never; }>;


export type IdVerificationPageQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', phoneMobile?: string | null, firstname?: string | null, consultant?: { __typename?: 'Consultant', pay360EligibilityStatus?: string | null } | null } | null } | null };

export type StartUserVerificationMutationVariables = Exact<{
  input: StartUserVerificationInput;
}>;


export type StartUserVerificationMutation = { __typename?: 'Mutation', startUserVerification?: { __typename?: 'StartUserVerificationPayload', success?: boolean | null } | null };

export type CreatePay360InvoiceMutationVariables = Exact<{
  input: CreatePay360InvoiceInput;
}>;


export type CreatePay360InvoiceMutation = { __typename?: 'Mutation', createPay360Invoice?: { __typename?: 'CreatePay360InvoicePayload', pay360Invoice?: { __typename?: 'Pay360Invoice', id: string } | null } | null };

export type InvoiceUploadPageQueryVariables = Exact<{
  projectCode?: InputMaybe<Scalars['String']>;
}>;


export type InvoiceUploadPageQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, email?: string | null, consultant?: { __typename?: 'Consultant', pay360EligibilityStatus?: string | null, paymentInformation?: { __typename?: 'PaymentInformation', abn?: string | null, acn?: string | null, registeredBusinessName?: string | null, bankAccountType?: BankAccountType | null, ausResident?: boolean | null, operatingType?: ConsultantBusinessType | null, isLegallyAuthorised?: boolean | null, paypalEmail?: string | null, ausBankAccount?: { __typename?: 'BankAccountAus', accountName?: string | null, bsb?: string | null } | null, insuranceInformation?: { __typename?: 'InsuranceInformation', hasInsurance?: boolean | null, professionalIndemnityLimitInMillion?: number | null, publicLiabilityLimitInMillion?: number | null, workersCompensationCover?: boolean | null } | null, internationalBankAccount?: { __typename?: 'BankAccountInternational', accountName?: string | null, beneficiaryAddress?: string | null, swiftCode?: string | null } | null, usBankAccount?: { __typename?: 'BankAccountUs', accountTitle?: string | null, beneficiaryAddress?: string | null, routingNumber?: string | null, swiftCode?: string | null } | null } | null, pay360Project?: { __typename?: 'Pay360Project', pay360FeePercent?: any | null, projectName?: string | null, clientCompanyName?: string | null, clientCompanyAbn?: string | null, clientEmail?: string | null, clientName?: string | null } | null } | null } | null } | null };

export type CreatePay360ProjectMutationVariables = Exact<{
  input: CreatePay360ProjectInput;
}>;


export type CreatePay360ProjectMutation = { __typename?: 'Mutation', createPay360Project?: { __typename?: 'CreatePay360ProjectPayload', pay360Project?: { __typename?: 'Pay360Project', projectCode?: string | null } | null } | null };

export type ProjectCreationPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectCreationPageQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', consultant?: { __typename?: 'Consultant', pay360EligibilityStatus?: string | null } | null } | null } | null };

export type ProjectSelectionPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectSelectionPageQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', firstname?: string | null, consultant?: { __typename?: 'Consultant', pay360EligibilityStatus?: string | null, pay360Projects?: Array<{ __typename?: 'Pay360Project', projectName?: string | null, projectCode?: string | null, clientCompanyName?: string | null } | null> | null, activeHiredProjects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', title?: string | null, hash?: string | null } | null } | null> | null } | null, paymentInformation?: { __typename?: 'PaymentInformation', abn?: string | null, acn?: string | null, registeredBusinessName?: string | null } | null } | null } | null } | null };

export type AddExpertBankAccountMutationVariables = Exact<{
  input: AddExpertBankAccountInput;
}>;


export type AddExpertBankAccountMutation = { __typename?: 'Mutation', addExpertBankAccount?: { __typename?: 'AddExpertBankAccountPayload', bankAccountAus?: { __typename?: 'BankAccountAus', accountName?: string | null, bsb?: string | null } | null, bankAccountInternational?: { __typename?: 'BankAccountInternational', accountName?: string | null, beneficiaryAddress?: string | null, swiftCode?: string | null } | null, bankAccountUs?: { __typename?: 'BankAccountUs', accountTitle?: string | null, beneficiaryAddress?: string | null, swiftCode?: string | null, routingNumber?: string | null } | null } | null };

export type Achievements_ProfileGraphFragment = { __typename?: 'Profile', user: { __typename?: 'User', firstname?: string | null, lastname?: string | null, role?: UserRole | null, largeProfilePicture?: { __typename?: 'ProfilePicture', source: string } | null, smallProfilePicture?: { __typename?: 'ProfilePicture', source: string } | null } };

export type BasicProfileInformationCard_ProfileGraphFragment = { __typename?: 'Profile', headline?: string | null, summary?: any | null, tier?: number | null, availabilityStatus?: EventType | null, projectCount?: number | null, user: { __typename?: 'User', firstname?: string | null, lastname?: string | null, averageProjectRating?: number | null, isOrgAdmin?: boolean | null, role?: UserRole | null, title?: string | null, largeProfilePicture?: { __typename?: 'ProfilePicture', source: string } | null, location?: { __typename?: 'LegacyLocation', city?: string | null, country?: string | null } | null, reviews: Array<{ __typename?: 'RatingAndReview', project: { __typename?: 'Project', code?: string | null } }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, availability?: { __typename?: 'Availability', currentAvailability?: AvailabilityStatus | null, unavailableUntilDate?: any | null } | null, smallProfilePicture?: { __typename?: 'ProfilePicture', source: string } | null }, viewerPrivateTalentOrganisations: Array<{ __typename?: 'Organisation', name: string }> };

export type BasicProfileInformationCard_ViewerGraphFragment = { __typename?: 'Viewer', role?: Role | null, user?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null };

export type ClearancesCard_GraphFragment = { __typename?: 'Profile', clearanceLevel?: ClearanceLevel | null, clearanceLevelExpiry?: any | null };

export type ClearancesCardShadowProfile_GraphFragment = { __typename?: 'ShadowProfile', clearanceLevel?: string | null };

export type ConsultantProject_GraphFragment = { __typename?: 'Project', unlisted?: boolean | null, privacy?: ProjectPrivacy | null, dateStart?: any | null, dateCompleted?: any | null, title?: string | null, deprecatedStatus?: Status | null, code?: string | null };

export type EducationItems_GraphFragment = { __typename?: 'Profile', educationItems?: Array<{ __typename?: 'EducationItem', degree?: string | null, fieldOfStudy?: string | null, schoolName?: string | null, startYear?: number | null, endYear?: number | null, description?: string | null }> | null };

export type ExperienceCard_GraphFragment = { __typename?: 'ShadowProfile', seniorityLevel?: string | null, yearsExperienceNumber?: number | null, companyCategoryExperience?: Array<string | null> | null };

export type LanguagesCard_GraphFragment = { __typename?: 'Profile', user: { __typename?: 'User', languages?: Array<{ __typename?: 'UserLanguage', language: string, proficiency: LanguageProficiency } | null> | null } };

export type OrganisationBasicProfileCard_GraphFragment = { __typename?: 'User', title?: string | null, organisation?: { __typename?: 'Organisation', name: string, id: string } | null };

export type OrganisationOverviewCard_GraphFragment = { __typename?: 'Profile', user: { __typename?: 'User', organisation?: { __typename?: 'Organisation', name: string, description?: any | null, companySize?: string | null, location?: { __typename?: 'LegacyLocation', city?: string | null, country?: string | null } | null, industry?: { __typename?: 'Industry', name?: string | null } | null } | null } };

export type OverviewCard_GraphFragment = { __typename?: 'Profile', summary?: any | null };

export type FavouriteButton_GraphFragment = { __typename?: 'Profile', code: string, user: { __typename?: 'User', id: string, viewerHasFavourited: boolean } };

export type ProfileActions_ProfileGraphFragment = { __typename?: 'Profile', code: string, headline?: string | null, curatedProjectInvitations?: { __typename?: 'UserCommunicationPreference', enabled: boolean, snoozedUntil?: any | null } | null, user: { __typename?: 'User', id: string, status: StatusOptions, firstname?: string | null, lastname?: string | null, accountUrl?: string | null, role?: UserRole | null, publicCode?: string | null, receiveProjectInvitationEmail?: boolean | null, viewerHasFavourited: boolean, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null, availability?: { __typename?: 'Availability', currentAvailability?: AvailabilityStatus | null } | null, largeProfilePicture?: { __typename?: 'ProfilePicture', source: string } | null, smallProfilePicture?: { __typename?: 'ProfilePicture', source: string } | null } };

export type ProfileActions_ViewerGraphFragment = { __typename?: 'Viewer', role?: Role | null, user?: { __typename?: 'User', id: string, organisationRole?: OrganisationRole | null, activePostedProjects?: Array<{ __typename?: 'Project', id: string, code?: string | null, title?: string | null, invitedUsers?: Array<{ __typename?: 'User', id: string }> | null, appliedUsers?: Array<{ __typename?: 'User', id: string }> | null }> | null } | null };

export type ProfilePicture_GraphFragment = { __typename?: 'User', firstname?: string | null, lastname?: string | null, largeProfilePicture?: { __typename?: 'ProfilePicture', source: string } | null, smallProfilePicture?: { __typename?: 'ProfilePicture', source: string } | null };

export type ProjectList_GraphFragment = { __typename?: 'Query', projects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', title?: string | null, dateCompleted?: any | null, privacy?: ProjectPrivacy | null, deprecatedStatus?: Status | null, code?: string | null, unlisted?: boolean | null, dateStart?: any | null, organisation?: { __typename?: 'Organisation', id: string } | null } | null } | null> | null } | null, profile?: { __typename?: 'Profile', projectCount?: number | null, user: { __typename?: 'User', firstname?: string | null, role?: UserRole | null, reviews: Array<{ __typename?: 'RatingAndReview', project: { __typename?: 'Project', code?: string | null, organisation?: { __typename?: 'Organisation', id: string } | null }, feedbackUserPublic?: { __typename?: 'FeedbackUserPublic', review?: string | null } | null }> } } | null, viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', client?: { __typename?: 'Client', memberOf: Array<{ __typename?: 'Organisation', id: string, name: string, hasFms?: boolean | null }> } | null } | null } | null };

export type SupplementalInformationCard_GraphFragment = { __typename?: 'Profile', user: { __typename?: 'User', firstname?: string | null, dateCreated?: any | null, email?: string | null, phoneMobile?: string | null, location?: { __typename?: 'LegacyLocation', city?: string | null, country?: string | null } | null }, viewerPrivateTalentOrganisations: Array<{ __typename?: 'Organisation', name: string, id: string }> };

export type SupplementalInformationCardShadowProfile_GraphFragment = { __typename?: 'ShadowProfile', updatedAt?: any | null };

export type WorkItems_GraphFragment = { __typename?: 'Profile', workItems?: Array<{ __typename?: 'WorkItem', title?: string | null, summary?: any | null, startMonth: number, startYear?: number | null, endMonth?: number | null, endYear?: number | null, isCurrent?: boolean | null, url?: string | null, urlDescription?: string | null, businessServices?: Array<{ __typename?: 'BusinessService', name: string }> | null, organisation?: { __typename?: 'LegacyOrganisation', name?: string | null } | null, expertOrganisations?: Array<{ __typename?: 'LegacyOrganisation', name?: string | null }> | null, industries?: Array<{ __typename?: 'Industry', name?: string | null }> | null }> | null };

export type PrintProfile_GraphFragment = { __typename?: 'Profile', headline?: string | null, summary?: any | null, user: { __typename?: 'User', firstname?: string | null, lastname?: string | null, dateCreated?: any | null, email?: string | null, phoneMobile?: string | null, location?: { __typename?: 'LegacyLocation', city?: string | null, country?: string | null } | null }, skills?: Array<{ __typename?: 'Skill', skill: string }> | null, industries?: Array<{ __typename?: 'Industry', name?: string | null }> | null, workItems?: Array<{ __typename?: 'WorkItem', title?: string | null, endYear?: number | null, startYear?: number | null, summary?: any | null, startMonth: number, endMonth?: number | null, isCurrent?: boolean | null, organisation?: { __typename?: 'LegacyOrganisation', name?: string | null } | null }> | null, educationItems?: Array<{ __typename?: 'EducationItem', description?: string | null, fieldOfStudy?: string | null, schoolName?: string | null, startYear?: number | null, endYear?: number | null, degree?: string | null }> | null };

export type ProfilePageQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type ProfilePageQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', isImpersonating?: boolean | null, role?: Role | null, user?: { __typename?: 'User', role?: UserRole | null, firstname?: string | null, lastname?: string | null, currency?: string | null, id: string, organisationRole?: OrganisationRole | null, consultant?: { __typename?: 'Consultant', profile?: { __typename?: 'Profile', discipline?: string | null, minHourlyRate?: any | null, maxHourlyRate?: any | null, minDailyRate?: any | null, maxDailyRate?: any | null, workPreference?: { __typename?: 'WorkPreference', titles?: Array<{ __typename?: 'WorkPreferenceJobTitle', jobTitle?: string | null } | null> | null, skills?: Array<{ __typename?: 'WorkPreferenceSkill', skillLevel?: string | null, classificationSkill?: { __typename?: 'Skill', skill: string } | null } | null> | null, role?: { __typename?: 'WorkPreferenceIdealRole', roleType?: Array<string | null> | null, roleStatus?: Array<string | null> | null, hoursPerWeek?: string | null, projectLength?: Array<string | null> | null } | null, company?: { __typename?: 'WorkPreferenceCompany', companySizes?: Array<string | null> | null, companyStages?: Array<string | null> | null, id: string } | null, preferredIndustries?: Array<{ __typename?: 'WorkPreferenceIndustry', industry?: string | null } | null> | null, undesirableIndustries?: Array<{ __typename?: 'WorkPreferenceIndustry', industry?: string | null } | null> | null } | null } | null } | null, client?: { __typename?: 'Client', memberOf: Array<{ __typename?: 'Organisation', id: string, name: string, hasFms?: boolean | null }> } | null, activePostedProjects?: Array<{ __typename?: 'Project', id: string, code?: string | null, title?: string | null, invitedUsers?: Array<{ __typename?: 'User', id: string }> | null, appliedUsers?: Array<{ __typename?: 'User', id: string }> | null }> | null, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null } | null, shadowProfile?: { __typename?: 'ShadowProfile', id: string, roleTitle?: string | null, clearanceLevel?: string | null, clearanceConfidence?: string | null, seniorityLevel?: string | null, seniorityExplanation?: string | null, yearsExperienceNumber?: number | null, yearsExperienceExplanation?: string | null, experienceExplanation?: string | null, companyCategoryExperience?: Array<string | null> | null, updatedAt?: any | null, skills?: Array<{ __typename?: 'ShadowProfileSkill', skill: string } | null> | null, certifications?: Array<{ __typename?: 'ShadowProfileCertification', name: string, dateExpiry?: any | null } | null> | null } | null, profile?: { __typename?: 'Profile', headline?: string | null, discipline?: string | null, businessService?: string | null, summary?: any | null, projectCount?: number | null, code: string, tier?: number | null, availabilityStatus?: EventType | null, clearanceLevel?: ClearanceLevel | null, clearanceLevelExpiry?: any | null, workPreference?: { __typename?: 'WorkPreference', titles?: Array<{ __typename?: 'WorkPreferenceJobTitle', jobTitle?: string | null } | null> | null, skills?: Array<{ __typename?: 'WorkPreferenceSkill', skillLevel?: string | null, classificationSkill?: { __typename?: 'Skill', skill: string } | null } | null> | null, role?: { __typename?: 'WorkPreferenceIdealRole', roleType?: Array<string | null> | null, roleStatus?: Array<string | null> | null, hoursPerWeek?: string | null, projectLength?: Array<string | null> | null } | null, locations?: Array<{ __typename?: 'WorkPreferenceLocation', id: string, daysWfh?: string | null, order?: number | null, timezone?: Array<string | null> | null, travelDistance?: string | null, type?: string | null, officeLocation?: Array<{ __typename?: 'LegacyLocation', city?: string | null, country?: string | null, countryCode?: string | null, id: string, subdivision?: string | null } | null> | null } | null> | null, company?: { __typename?: 'WorkPreferenceCompany', companySizes?: Array<string | null> | null, companyStages?: Array<string | null> | null, id: string } | null, preferredIndustries?: Array<{ __typename?: 'WorkPreferenceIndustry', industry?: string | null } | null> | null, undesirableIndustries?: Array<{ __typename?: 'WorkPreferenceIndustry', industry?: string | null } | null> | null } | null, achievements?: { __typename?: 'AchievementConnection', edges?: Array<{ __typename?: 'AchievementEdge', node?: { __typename?: 'Achievement', id: string, title?: string | null, isPublished?: boolean | null, role?: string | null, description?: string | null, startDate?: any | null, endDate?: any | null, skills?: Array<{ __typename?: 'Skill', id: string, skill: string }> | null, media?: Array<{ __typename?: 'AchievementMedia', id: string, isFeatured?: boolean | null, path?: string | null, source?: string | null, order?: number | null, largePath?: string | null }> | null } | null } | null> | null } | null, user: { __typename?: 'User', firstname?: string | null, lastname?: string | null, locked?: boolean | null, role?: UserRole | null, accountUrl?: string | null, dateCreated?: any | null, receiveProjectInvitationEmail?: boolean | null, id: string, status: StatusOptions, publicCode?: string | null, email?: string | null, phoneMobile?: string | null, averageProjectRating?: number | null, isOrgAdmin?: boolean | null, viewerHasFavourited: boolean, title?: string | null, location?: { __typename?: 'LegacyLocation', city?: string | null, country?: string | null } | null, additionalRoles?: Array<{ __typename?: 'BusinessService', name: string } | null> | null, reviews: Array<{ __typename?: 'RatingAndReview', project: { __typename?: 'Project', code?: string | null, organisation?: { __typename?: 'Organisation', id: string } | null }, feedbackUserPublic?: { __typename?: 'FeedbackUserPublic', review?: string | null } | null }>, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null, availability?: { __typename?: 'Availability', currentAvailability?: AvailabilityStatus | null, unavailableUntilDate?: any | null } | null, organisation?: { __typename?: 'Organisation', name: string, description?: any | null, companySize?: string | null, id: string, location?: { __typename?: 'LegacyLocation', city?: string | null, country?: string | null } | null, industry?: { __typename?: 'Industry', name?: string | null } | null } | null, largeProfilePicture?: { __typename?: 'ProfilePicture', source: string } | null, languages?: Array<{ __typename?: 'UserLanguage', language: string, proficiency: LanguageProficiency } | null> | null, smallProfilePicture?: { __typename?: 'ProfilePicture', source: string } | null }, workItems?: Array<{ __typename?: 'WorkItem', title?: string | null, endYear?: number | null, startYear?: number | null, summary?: any | null, startMonth: number, endMonth?: number | null, isCurrent?: boolean | null, url?: string | null, urlDescription?: string | null, organisation?: { __typename?: 'LegacyOrganisation', name?: string | null } | null, businessServices?: Array<{ __typename?: 'BusinessService', name: string }> | null, expertOrganisations?: Array<{ __typename?: 'LegacyOrganisation', name?: string | null }> | null, industries?: Array<{ __typename?: 'Industry', name?: string | null }> | null }> | null, educationItems?: Array<{ __typename?: 'EducationItem', description?: string | null, fieldOfStudy?: string | null, schoolName?: string | null, startYear?: number | null, endYear?: number | null, degree?: string | null }> | null, skills?: Array<{ __typename?: 'Skill', skill: string }> | null, industries?: Array<{ __typename?: 'Industry', name?: string | null }> | null, curatedProjectInvitations?: { __typename?: 'UserCommunicationPreference', enabled: boolean, snoozedUntil?: any | null } | null, viewerPrivateTalentOrganisations: Array<{ __typename?: 'Organisation', name: string, id: string }> } | null, projects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', title?: string | null, dateCompleted?: any | null, privacy?: ProjectPrivacy | null, deprecatedStatus?: Status | null, code?: string | null, unlisted?: boolean | null, dateStart?: any | null, organisation?: { __typename?: 'Organisation', id: string } | null } | null } | null> | null } | null };

export type ApproveContractOfferQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
}>;


export type ApproveContractOfferQuery = { __typename?: 'Query', isAccountClaimed?: boolean | null };

export type ResendFastApplyEmailMutationVariables = Exact<{
  input: ResendFastApplyEmailInput;
}>;


export type ResendFastApplyEmailMutation = { __typename?: 'Mutation', resendFastApplyEmail?: { __typename?: 'ResendFastApplyEmailPayload', success?: boolean | null } | null };

export type ProjectBrief_GraphFragment = { __typename?: 'Project', id: string, code?: string | null, viewerHasBookmarked?: boolean | null, summary?: string | null, title?: string | null, companyType?: string | null, organisationIndustry?: string | null, duration?: string | null, dateStart?: any | null, startAsap?: boolean | null, extensionProbability?: ExtensionProbabilityType | null, earn?: string | null, budgetCurrency?: string | null, locationType?: string | null, intensity?: string | null, postedDateUtc?: any | null, applicantCount?: number | null, state?: ProjectState | null, companyName?: string | null, companySize?: string | null, organisationMemberSinceDate?: any | null, usesOneRatePricingModel?: boolean | null, isInsured?: ProjectIsInsured | null, idealExpertSummary?: string | null, idealExpertTitle?: string | null, clearanceLevel?: ClearanceLevel | null, seniorityLevel?: SeniorityLevel | null, yearsExperience?: YearsExperience | null, contractingCompany?: ContractingCompanyName | null, daysWfh?: number | null, companyOverview?: string | null, projectLocation?: string | null, servicesRequired: Array<{ __typename?: 'BusinessService', name: string }>, unapprovedServicesRequired: Array<{ __typename?: 'BusinessService', name: string }>, industries: Array<{ __typename?: 'Industry', name?: string | null }>, skills?: Array<{ __typename?: 'Skill', skill: string } | null> | null, organisationIndustries?: Array<{ __typename?: 'Industry', name?: string | null } | null> | null, locationDetails?: { __typename?: 'LegacyLocation', city?: string | null, country?: string | null } | null, organisation?: { __typename?: 'Organisation', id: string, name: string, contractingCompany?: string | null, hasMarketplace?: boolean | null, hasWhitelabel?: boolean | null, companySize?: string | null, isTimesheetRequired?: boolean | null, industries?: Array<{ __typename?: 'Industry', name?: string | null } | null> | null } | null, status?: { __typename?: 'ProjectStatus', applicationCount?: number | null, interviewCount?: number | null, offerCount?: number | null, expertStatus?: ExpertStatus | null, expertStatusDate?: any | null } | null, applications?: { __typename?: 'ApplicationConnection', edges?: Array<{ __typename?: 'ApplicationEdge', node?: { __typename?: 'Application', dateSubmitted?: any | null } | null } | null> | null } | null, remoteLocation?: { __typename?: 'RemoteLocation', country?: string | null, countryCode?: string | null, timezone?: string | null, timezoneRange?: number | null, type?: RemoteLocationType | null } | null };

export type ApproveContractOfferMutationVariables = Exact<{
  input: ApproveContractOfferInput;
}>;


export type ApproveContractOfferMutation = { __typename?: 'Mutation', approveContractOffer?: { __typename?: 'ApproveContractOfferPayload', alreadyApproved?: boolean | null, manualApprovalRequired?: boolean | null, manualApprovalUrl?: string | null } | null };

export type SubmitWorkingRightsDeclarationMutationVariables = Exact<{
  input: SubmitWorkingRightsDeclarationInput;
}>;


export type SubmitWorkingRightsDeclarationMutation = { __typename?: 'Mutation', submitWorkingRightsDeclaration?: { __typename?: 'SubmitWorkingRightsDeclarationPayload', workingRights?: ExpertWorkingRights | null, workingRightsDeclarationDate?: any | null } | null };

export type ArchivedCompletedCard_GraphFragment = { __typename?: 'Project', code?: string | null, hash?: string | null, title?: string | null, unlisted?: boolean | null, companyType?: string | null, companyName?: string | null, organisationIndustry?: string | null, postedDateUtc?: any | null, locationType?: string | null, projectLocation?: string | null, industries: Array<{ __typename?: 'Industry', name?: string | null }>, locationDetails?: { __typename?: 'LegacyLocation', city?: string | null, country?: string | null } | null, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, legacyApplications?: { __typename?: 'LegacyApplicationConnection', edges?: Array<{ __typename?: 'LegacyApplicationEdge', node?: { __typename?: 'LegacyApplication', dateSubmitted?: any | null } | null } | null> | null } | null, applications?: { __typename?: 'ApplicationConnection', edges?: Array<{ __typename?: 'ApplicationEdge', node?: { __typename?: 'Application', dateSubmitted?: any | null } | null } | null> | null } | null, viewerContract?: { __typename?: 'Contract', code?: string | null, title?: string | null, agreedDate?: any | null, amount?: number | null, budgetType?: string | null, budgetUnit?: string | null, currency?: string | null, startDate?: any | null, endDate?: any | null, createdDate?: any | null, status?: ContractStatus | null, active?: boolean | null, endingSoon?: boolean | null, ended?: boolean | null } | null };

export type ArchivedCompletedCard_ConsultantFragment = { __typename?: 'Consultant', memberOf: Array<{ __typename?: 'Organisation', name: string, id: string }>, profile?: { __typename?: 'Profile', code: string } | null };

export type OfferedProjectCard_GraphFragment = { __typename?: 'Project', hash?: string | null, code?: string | null, title?: string | null, unlisted?: boolean | null, companyType?: string | null, companyName?: string | null, organisationIndustry?: string | null, postedDateUtc?: any | null, locationType?: string | null, projectLocation?: string | null, legacyApplications?: { __typename?: 'LegacyApplicationConnection', edges?: Array<{ __typename?: 'LegacyApplicationEdge', node?: { __typename?: 'LegacyApplication', dateSubmitted?: any | null } | null } | null> | null } | null, applications?: { __typename?: 'ApplicationConnection', edges?: Array<{ __typename?: 'ApplicationEdge', node?: { __typename?: 'Application', dateSubmitted?: any | null } | null } | null> | null } | null, industries: Array<{ __typename?: 'Industry', name?: string | null }>, locationDetails?: { __typename?: 'LegacyLocation', city?: string | null, country?: string | null } | null, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, viewerContract?: { __typename?: 'Contract', agreedDate?: any | null, createdDate?: any | null, status?: ContractStatus | null, amount?: number | null, budgetUnit?: string | null, currency?: string | null, startDate?: any | null, endDate?: any | null, duration?: number | null, durationUnit?: string | null } | null };

export type OfferedProjectsList_GraphFragment = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', displayBrowseProjects?: boolean | null, user?: { __typename?: 'User', consultant?: { __typename?: 'Consultant', memberOf: Array<{ __typename?: 'Organisation', name: string, id: string }>, dashboardProjects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', hash?: string | null, code?: string | null, title?: string | null, unlisted?: boolean | null, companyType?: string | null, companyName?: string | null, organisationIndustry?: string | null, postedDateUtc?: any | null, locationType?: string | null, projectLocation?: string | null, legacyApplications?: { __typename?: 'LegacyApplicationConnection', edges?: Array<{ __typename?: 'LegacyApplicationEdge', node?: { __typename?: 'LegacyApplication', dateSubmitted?: any | null } | null } | null> | null } | null, applications?: { __typename?: 'ApplicationConnection', edges?: Array<{ __typename?: 'ApplicationEdge', node?: { __typename?: 'Application', dateSubmitted?: any | null } | null } | null> | null } | null, industries: Array<{ __typename?: 'Industry', name?: string | null }>, locationDetails?: { __typename?: 'LegacyLocation', city?: string | null, country?: string | null } | null, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, viewerContract?: { __typename?: 'Contract', agreedDate?: any | null, createdDate?: any | null, status?: ContractStatus | null, amount?: number | null, budgetUnit?: string | null, currency?: string | null, startDate?: any | null, endDate?: any | null, duration?: number | null, durationUnit?: string | null } | null } | null } | null> | null } | null } | null } | null } | null };

export type OfferedProjectsTabQueryVariables = Exact<{
  expertStage?: InputMaybe<ExpertStages>;
  count: Scalars['Int'];
}>;


export type OfferedProjectsTabQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', displayBrowseProjects?: boolean | null, user?: { __typename?: 'User', consultant?: { __typename?: 'Consultant', memberOf: Array<{ __typename?: 'Organisation', name: string, id: string }>, dashboardProjects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', hash?: string | null, code?: string | null, title?: string | null, unlisted?: boolean | null, companyType?: string | null, companyName?: string | null, organisationIndustry?: string | null, postedDateUtc?: any | null, locationType?: string | null, projectLocation?: string | null, legacyApplications?: { __typename?: 'LegacyApplicationConnection', edges?: Array<{ __typename?: 'LegacyApplicationEdge', node?: { __typename?: 'LegacyApplication', dateSubmitted?: any | null } | null } | null> | null } | null, applications?: { __typename?: 'ApplicationConnection', edges?: Array<{ __typename?: 'ApplicationEdge', node?: { __typename?: 'Application', dateSubmitted?: any | null } | null } | null> | null } | null, industries: Array<{ __typename?: 'Industry', name?: string | null }>, locationDetails?: { __typename?: 'LegacyLocation', city?: string | null, country?: string | null } | null, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, viewerContract?: { __typename?: 'Contract', agreedDate?: any | null, createdDate?: any | null, status?: ContractStatus | null, amount?: number | null, budgetUnit?: string | null, currency?: string | null, startDate?: any | null, endDate?: any | null, duration?: number | null, durationUnit?: string | null } | null } | null } | null> | null } | null } | null } | null } | null };

export type RequestPasswordResetMutationVariables = Exact<{
  input: RequestPasswordResetInput;
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset?: { __typename?: 'RequestPasswordResetPayload', confirmation?: boolean | null, hasSso?: boolean | null, requireSso?: boolean | null } | null };

export type FindExpertsRenderer_GraphFragment = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', canSearchSecurityClearances: boolean, user?: { __typename?: 'User', client?: { __typename?: 'Client', memberOf: Array<{ __typename?: 'Organisation', name: string }> } | null } | null } | null, experts?: { __typename?: 'SearchConsultantConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'SearchConsultantEdge', node?: { __typename?: 'SearchConsultant', dateLastActivity?: any | null, id: string, name: string, rating?: number | null, currency?: string | null, favourite?: boolean | null, favouritedBy?: string | null, profileUrl?: string | null, skills?: Array<string | null> | null, currentAvailability?: string | null, dateAvailable?: any | null, projectInvitationsEnabled?: boolean | null, projectInvitationsSnoozedUntil?: any | null, organisations?: Array<{ __typename?: 'SearchOrganisation', orgId?: string | null, name?: string | null }> | null, profile: { __typename?: 'SearchConsultantProfile', headline?: string | null, projectCount?: number | null, minDailyRate?: string | null, maxDailyRate?: string | null, organisationNames?: Array<string> | null, location?: { __typename?: 'SearchLocation', city?: string | null, country?: string | null } | null, workItems?: Array<{ __typename?: 'SearchWorkItem', organisation?: { __typename?: 'SearchOrganisation', name?: string | null } | null }> | null }, languages?: Array<{ __typename?: 'UserLanguage', language: string, proficiency: LanguageProficiency }> | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null, backOffice?: { __typename?: 'BackOffice', isClaimed?: boolean | null, isFutured?: boolean | null, isLocked?: boolean | null, isPrivate?: boolean | null, backOfficeLink?: string | null, dateLastInteracted?: any | null, dateUserLastUpdated?: any | null, dateRegistered?: any | null, dateLastLogin?: any | null, dateAvailabilityUpdated?: any | null, dateLastActivity?: any | null } | null, currentProject?: { __typename?: 'Project', title?: string | null, id: string, deprecatedStatus?: Status | null, summary?: string | null, dateEnd?: any | null, createdBy?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null } | null, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, currentContract?: { __typename?: 'Contract', id: string, startDate?: any | null, endDate?: any | null } | null } | null } | null } | null> | null } | null };

export type FindExpertsRendererRefetchQueryVariables = Exact<{
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ExpertFilterInput>;
}>;


export type FindExpertsRendererRefetchQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', canSearchSecurityClearances: boolean, user?: { __typename?: 'User', client?: { __typename?: 'Client', memberOf: Array<{ __typename?: 'Organisation', name: string }> } | null } | null } | null, experts?: { __typename?: 'SearchConsultantConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'SearchConsultantEdge', node?: { __typename?: 'SearchConsultant', dateLastActivity?: any | null, id: string, name: string, rating?: number | null, currency?: string | null, favourite?: boolean | null, favouritedBy?: string | null, profileUrl?: string | null, skills?: Array<string | null> | null, currentAvailability?: string | null, dateAvailable?: any | null, projectInvitationsEnabled?: boolean | null, projectInvitationsSnoozedUntil?: any | null, organisations?: Array<{ __typename?: 'SearchOrganisation', orgId?: string | null, name?: string | null }> | null, profile: { __typename?: 'SearchConsultantProfile', headline?: string | null, projectCount?: number | null, minDailyRate?: string | null, maxDailyRate?: string | null, organisationNames?: Array<string> | null, location?: { __typename?: 'SearchLocation', city?: string | null, country?: string | null } | null, workItems?: Array<{ __typename?: 'SearchWorkItem', organisation?: { __typename?: 'SearchOrganisation', name?: string | null } | null }> | null }, languages?: Array<{ __typename?: 'UserLanguage', language: string, proficiency: LanguageProficiency }> | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null, backOffice?: { __typename?: 'BackOffice', isClaimed?: boolean | null, isFutured?: boolean | null, isLocked?: boolean | null, isPrivate?: boolean | null, backOfficeLink?: string | null, dateLastInteracted?: any | null, dateUserLastUpdated?: any | null, dateRegistered?: any | null, dateLastLogin?: any | null, dateAvailabilityUpdated?: any | null, dateLastActivity?: any | null } | null, currentProject?: { __typename?: 'Project', title?: string | null, id: string, deprecatedStatus?: Status | null, summary?: string | null, dateEnd?: any | null, createdBy?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null } | null, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, currentContract?: { __typename?: 'Contract', id: string, startDate?: any | null, endDate?: any | null } | null } | null } | null } | null> | null } | null };

export type FindExpertsRendererQueryVariables = Exact<{
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ExpertFilterInput>;
}>;


export type FindExpertsRendererQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', canSearchSecurityClearances: boolean, user?: { __typename?: 'User', client?: { __typename?: 'Client', memberOf: Array<{ __typename?: 'Organisation', name: string }> } | null } | null } | null, experts?: { __typename?: 'SearchConsultantConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'SearchConsultantEdge', node?: { __typename?: 'SearchConsultant', dateLastActivity?: any | null, id: string, name: string, rating?: number | null, currency?: string | null, favourite?: boolean | null, favouritedBy?: string | null, profileUrl?: string | null, skills?: Array<string | null> | null, currentAvailability?: string | null, dateAvailable?: any | null, projectInvitationsEnabled?: boolean | null, projectInvitationsSnoozedUntil?: any | null, organisations?: Array<{ __typename?: 'SearchOrganisation', orgId?: string | null, name?: string | null }> | null, profile: { __typename?: 'SearchConsultantProfile', headline?: string | null, projectCount?: number | null, minDailyRate?: string | null, maxDailyRate?: string | null, organisationNames?: Array<string> | null, location?: { __typename?: 'SearchLocation', city?: string | null, country?: string | null } | null, workItems?: Array<{ __typename?: 'SearchWorkItem', organisation?: { __typename?: 'SearchOrganisation', name?: string | null } | null }> | null }, languages?: Array<{ __typename?: 'UserLanguage', language: string, proficiency: LanguageProficiency }> | null, profilePicture?: { __typename?: 'ProfilePicture', source: string } | null, backOffice?: { __typename?: 'BackOffice', isClaimed?: boolean | null, isFutured?: boolean | null, isLocked?: boolean | null, isPrivate?: boolean | null, backOfficeLink?: string | null, dateLastInteracted?: any | null, dateUserLastUpdated?: any | null, dateRegistered?: any | null, dateLastLogin?: any | null, dateAvailabilityUpdated?: any | null, dateLastActivity?: any | null } | null, currentProject?: { __typename?: 'Project', title?: string | null, id: string, deprecatedStatus?: Status | null, summary?: string | null, dateEnd?: any | null, createdBy?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null } | null, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, currentContract?: { __typename?: 'Contract', id: string, startDate?: any | null, endDate?: any | null } | null } | null } | null } | null> | null } | null };

export type AllSavedSearchesQueryVariables = Exact<{
  first: Scalars['Int'];
}>;


export type AllSavedSearchesQuery = { __typename?: 'Query', savedSearches?: { __typename?: 'SavedSearchConnection', totalCount: number, edges?: Array<{ __typename?: 'SavedSearchEdge', node?: { __typename?: 'SavedSearch', id: string, name: string, form: string, formValues: any, insertedAt: any } | null } | null> | null } | null };

export type CreateSavedSearchMutationVariables = Exact<{
  input: CreateSavedSearchInput;
}>;


export type CreateSavedSearchMutation = { __typename?: 'Mutation', createSavedSearch?: { __typename?: 'CreateSavedSearchPayload', savedSearch?: { __typename?: 'SavedSearch', id: string, name: string, form: string, formValues: any } | null } | null };

export type DeleteSavedSearchMutationVariables = Exact<{
  input: DeleteSavedSearchInput;
}>;


export type DeleteSavedSearchMutation = { __typename?: 'Mutation', deleteSavedSearch?: { __typename?: 'DeleteSavedSearchPayload', savedSearch?: { __typename?: 'SavedSearch', id: string, name: string, form: string, formValues: any } | null } | null };

export type RenameSavedSearchMutationVariables = Exact<{
  input: RenameSavedSearchInput;
}>;


export type RenameSavedSearchMutation = { __typename?: 'Mutation', renameSavedSearch?: { __typename?: 'RenameSavedSearchPayload', savedSearch?: { __typename?: 'SavedSearch', id: string, name: string, form: string, formValues: any } | null } | null };

export type SavedSearchesQueryVariables = Exact<{ [key: string]: never; }>;


export type SavedSearchesQuery = { __typename?: 'Query', savedSearches?: { __typename?: 'SavedSearchConnection', totalCount: number, edges?: Array<{ __typename?: 'SavedSearchEdge', node?: { __typename?: 'SavedSearch', id: string, name: string, form: string, formValues: any } | null } | null> | null } | null };

export type CountryTypeaheadQueryVariables = Exact<{ [key: string]: never; }>;


export type CountryTypeaheadQuery = { __typename?: 'Query', countries?: Array<{ __typename?: 'Country', id: string, name?: string | null, alpha2Code?: string | null } | null> | null };

export type LocationTypeaheadQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type LocationTypeaheadQuery = { __typename?: 'Query', legacyLocations?: { __typename?: 'LegacyLocationConnection', edges?: Array<{ __typename?: 'LegacyLocationEdge', node?: { __typename?: 'LegacyLocation', id: string, city?: string | null, subdivision?: string | null, country?: string | null } | null } | null> | null } | null };

export type TimezoneTypeaheadQueryVariables = Exact<{ [key: string]: never; }>;


export type TimezoneTypeaheadQuery = { __typename?: 'Query', timezones?: Array<{ __typename?: 'Timezone', label: string, value: string }> | null };

export type BusinessServicesQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type BusinessServicesQuery = { __typename?: 'Query', businessServices?: { __typename?: 'BusinessServiceConnection', edges?: Array<{ __typename?: 'BusinessServiceEdge', node?: { __typename?: 'BusinessService', id: string, name: string, group: string } | null } | null> | null } | null };

export type CompaniesTypeaheadQueryVariables = Exact<{
  company: Scalars['String'];
}>;


export type CompaniesTypeaheadQuery = { __typename?: 'Query', legacyOrganisations?: { __typename?: 'LegacyOrganisationConnection', edges?: Array<{ __typename?: 'LegacyOrganisationEdge', node?: { __typename?: 'LegacyOrganisation', id: string, name?: string | null } | null } | null> | null } | null };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', countries?: Array<{ __typename?: 'Country', name?: string | null, alpha2Code?: string | null } | null> | null };

export type CountryByCodeQueryVariables = Exact<{
  countryCode: Scalars['String'];
}>;


export type CountryByCodeQuery = { __typename?: 'Query', countries?: Array<{ __typename?: 'Country', alpha2Code?: string | null, name?: string | null } | null> | null };

export type CountryByNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type CountryByNameQuery = { __typename?: 'Query', countries?: Array<{ __typename?: 'Country', alpha2Code?: string | null, name?: string | null } | null> | null };

export type DisciplinesQueryVariables = Exact<{
  discipline?: InputMaybe<Scalars['String']>;
}>;


export type DisciplinesQuery = { __typename?: 'Query', disciplines?: { __typename?: 'DisciplineConnection', edges?: Array<{ __typename?: 'DisciplineEdge', node?: { __typename?: 'Discipline', id: string, name: string } | null } | null> | null } | null };

export type IndustryTypeaheadQueryVariables = Exact<{
  name: Scalars['String'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type IndustryTypeaheadQuery = { __typename?: 'Query', industryAutocomplete?: { __typename?: 'IndustryConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'IndustryEdge', node?: { __typename?: 'Industry', id: string, name?: string | null, parentName?: string | null, parentId?: number | null } | null } | null> | null } | null };

export type InterestsQueryVariables = Exact<{
  interest?: InputMaybe<Scalars['String']>;
}>;


export type InterestsQuery = { __typename?: 'Query', interests?: { __typename?: 'InterestConnection', edges?: Array<{ __typename?: 'InterestEdge', node?: { __typename?: 'Interest', id: string, name: string } | null } | null> | null } | null, viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', profileInterests?: Array<{ __typename?: 'ProfileInterest', id: string, interestId: string } | null> | null } | null } | null };

export type LanguagesTypeaheadQueryVariables = Exact<{
  language: Scalars['String'];
}>;


export type LanguagesTypeaheadQuery = { __typename?: 'Query', languages?: Array<{ __typename?: 'Language', name: string }> | null };

export type LegacyOrganisationsQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type LegacyOrganisationsQuery = { __typename?: 'Query', legacyOrganisations?: { __typename?: 'LegacyOrganisationConnection', edges?: Array<{ __typename?: 'LegacyOrganisationEdge', node?: { __typename?: 'LegacyOrganisation', id: string, name?: string | null } | null } | null> | null } | null };

export type LocationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LocationQuery = { __typename?: 'Query', node?: { __typename?: 'Achievement', id: string } | { __typename?: 'AchievementMedia', id: string } | { __typename?: 'Application', id: string } | { __typename?: 'ApplicationExperience', id: string } | { __typename?: 'Article', id: string } | { __typename?: 'AstuteRegistration', id: string } | { __typename?: 'BusinessService', id: string } | { __typename?: 'CalendlyEvent', id: string } | { __typename?: 'CommunityEvent', id: string } | { __typename?: 'ConfirmAbnAcnNonPayroll', id: string } | { __typename?: 'ConfirmAbnAcnPayroll', id: string } | { __typename?: 'Consultant', id: string } | { __typename?: 'Contact', id: string } | { __typename?: 'Contract', id: string } | { __typename?: 'ContractingCompany', id: string } | { __typename?: 'Country', id: string } | { __typename?: 'CustomFieldDefinition', id: string } | { __typename?: 'CustomFieldValue', id: string } | { __typename?: 'Deliverable', id: string } | { __typename?: 'Discipline', id: string } | { __typename?: 'EducationItem', id: string } | { __typename?: 'Event', id: string } | { __typename?: 'Industry', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'Invoice', id: string } | { __typename?: 'Language', id: string } | { __typename?: 'LegacyApplication', id: string } | { __typename?: 'LegacyLocation', city?: string | null, country?: string | null, countryCode?: string | null, subdivision?: string | null, id: string } | { __typename?: 'LegacyOrganisation', id: string } | { __typename?: 'Lifecycle', id: string } | { __typename?: 'Message', id: string } | { __typename?: 'OauthProfile', id: string } | { __typename?: 'Organisation', id: string } | { __typename?: 'OrganisationDomain', id: string } | { __typename?: 'OrganisationInvitation', id: string } | { __typename?: 'OrganisationLegalDocumentation', id: string } | { __typename?: 'Pay360Invoice', id: string } | { __typename?: 'Pay360Project', id: string } | { __typename?: 'Pay360User', id: string } | { __typename?: 'PaymentInformation', id: string } | { __typename?: 'Profile', id: string } | { __typename?: 'ProfileInterest', id: string } | { __typename?: 'Project', id: string } | { __typename?: 'ProjectNotification', id: string } | { __typename?: 'RateCardRole', id: string } | { __typename?: 'RatingAndReview', id: string } | { __typename?: 'RemoteWorkSafetyChecklist', id: string } | { __typename?: 'RightToWorkInAustralia', id: string } | { __typename?: 'RoleTitle', id: string } | { __typename?: 'SavedSearch', id: string } | { __typename?: 'SearchConsultant', id: string } | { __typename?: 'SearchProject', id: string } | { __typename?: 'ShadowProfile', id: string } | { __typename?: 'ShadowProfileCertification', id: string } | { __typename?: 'ShadowProfileSkill', id: string } | { __typename?: 'Skill', id: string } | { __typename?: 'SsoConfig', id: string } | { __typename?: 'Tag', id: string } | { __typename?: 'TaxRate', id: string } | { __typename?: 'TaxRegion', id: string } | { __typename?: 'Thread', id: string } | { __typename?: 'User', id: string } | { __typename?: 'UserCommunicationPreference', id: string } | { __typename?: 'UserLanguage', id: string } | { __typename?: 'Viewer', id: string } | { __typename?: 'WorkHistory', id: string } | { __typename?: 'WorkItem', id: string } | { __typename?: 'WorkPreferenceCompany', id: string } | { __typename?: 'WorkPreferenceIdealRole', id: string } | { __typename?: 'WorkPreferenceIndustry', id: string } | { __typename?: 'WorkPreferenceJobTitle', id: string } | { __typename?: 'WorkPreferenceLocation', id: string } | { __typename?: 'WorkPreferenceSkill', id: string } | { __typename?: 'WorkingRightsDocument', id: string } | null };

export type LocationsTypeaheadQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type LocationsTypeaheadQuery = { __typename?: 'Query', legacyLocations?: { __typename?: 'LegacyLocationConnection', edges?: Array<{ __typename?: 'LegacyLocationEdge', node?: { __typename?: 'LegacyLocation', id: string, city?: string | null, subdivision?: string | null, country?: string | null } | null } | null> | null } | null };

export type PrivateCloudCustomFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type PrivateCloudCustomFieldsQuery = { __typename?: 'Query', privateClouds?: { __typename?: 'OrganisationConnection', edges?: Array<{ __typename?: 'OrganisationEdge', node?: { __typename?: 'Organisation', id: string, name: string, customFieldDefinitions: Array<{ __typename?: 'CustomFieldDefinition', id: string, name?: string | null, type?: CustomFieldDefinitionType | null, values?: any | null }> } | null } | null> | null } | null };

export type PrivateCloudsQueryVariables = Exact<{ [key: string]: never; }>;


export type PrivateCloudsQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', role?: UserRole | null, client?: { __typename?: 'Client', memberOf: Array<{ __typename?: 'Organisation', name: string, hasPrivateCloud?: boolean | null }> } | null } | null } | null, privateClouds?: { __typename?: 'OrganisationConnection', edges?: Array<{ __typename?: 'OrganisationEdge', node?: { __typename?: 'Organisation', id: string, name: string } | null } | null> | null } | null };

export type RoleTitlesQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type RoleTitlesQuery = { __typename?: 'Query', roleTitles?: { __typename?: 'RoleTitleConnection', edges?: Array<{ __typename?: 'RoleTitleEdge', node?: { __typename?: 'RoleTitle', id: string, name?: string | null } | null } | null> | null } | null };

export type SkillTypeaheadQueryVariables = Exact<{
  skill: Scalars['String'];
}>;


export type SkillTypeaheadQuery = { __typename?: 'Query', skills?: { __typename?: 'SkillConnection', edges?: Array<{ __typename?: 'SkillEdge', node?: { __typename?: 'Skill', id: string, skill: string } | null } | null> | null } | null };

export type TagsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type TagsQuery = { __typename?: 'Query', tags?: { __typename?: 'TagConnection', edges?: Array<{ __typename?: 'TagEdge', node?: { __typename?: 'Tag', id: string, name?: string | null } | null } | null> | null } | null };

export type DisableTotpMutationVariables = Exact<{
  input: DisableTotpInput;
}>;


export type DisableTotpMutation = { __typename?: 'Mutation', disableTotp?: { __typename?: 'DisableTotpPayload', success?: boolean | null } | null };

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword?: { __typename?: 'UpdatePasswordPayload', confirmation?: boolean | null } | null };

export type ChangePasswordQueryVariables = Exact<{ [key: string]: never; }>;


export type ChangePasswordQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', platformWhitelabelling?: string | null, consultant?: { __typename?: 'Consultant', lifecycle?: { __typename?: 'Lifecycle', basicProfileCompleted?: boolean | null } | null } | null } | null } | null };

export type MfaQueryVariables = Exact<{ [key: string]: never; }>;


export type MfaQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', totpEnabled: boolean, user?: { __typename?: 'User', platformWhitelabelling?: string | null, consultant?: { __typename?: 'Consultant', lifecycle?: { __typename?: 'Lifecycle', basicProfileCompleted?: boolean | null } | null } | null } | null } | null };

export type BookMeetingQueryVariables = Exact<{ [key: string]: never; }>;


export type BookMeetingQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', firstname?: string | null, lastname?: string | null, email?: string | null, country?: string | null } | null } | null };

export type CompleteApplicationMutationVariables = Exact<{
  input: CompleteApplicationInput;
}>;


export type CompleteApplicationMutation = { __typename?: 'Mutation', completeApplication?: { __typename?: 'CompleteApplicationPayload', success?: boolean | null } | null };

export type MatchOrganisationFromEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type MatchOrganisationFromEmailQuery = { __typename?: 'Query', organisation?: { __typename?: 'Organisation', id: string, name: string } | null };

export type ClientOrganisationTypeaheadQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type ClientOrganisationTypeaheadQuery = { __typename?: 'Query', organisations?: { __typename?: 'OrganisationConnection', edges?: Array<{ __typename?: 'OrganisationEdge', node?: { __typename?: 'Organisation', id: string, name: string, organisationDomains?: Array<{ __typename?: 'OrganisationDomain', regex?: string | null, matchSignup?: boolean | null } | null> | null } | null } | null> | null } | null };

export type ExpertApplicationQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpertApplicationQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', country?: string | null, firstname?: string | null, email?: string | null, smsVerified?: boolean | null, emailVerified?: boolean | null, uploadedCv?: string | null, operatingType?: OperatingType | null, workingSituation?: WorkingSituation | null, disciplineId?: string | null, additionalRoles?: Array<{ __typename?: 'BusinessService', name: string, id: string } | null> | null, profileInterests?: Array<{ __typename?: 'ProfileInterest', id: string, interestId: string, userId: string } | null> | null, consultant?: { __typename?: 'Consultant', paymentInformation?: { __typename?: 'PaymentInformation', registeredBusinessName?: string | null } | null, latestMilestone?: { __typename?: 'LatestMilestone', name?: MilestoneName | null } | null, profile?: { __typename?: 'Profile', id: string, code: string, hash?: string | null, vettedIntoMarketplace?: boolean | null, linkedinUrl?: string | null, websiteUrl?: string | null, businessService?: string | null, businessServiceGroup?: string | null, businessServiceId?: string | null, discipline?: string | null, calendlyEvents?: { __typename?: 'CalendlyEventConnection', edges?: Array<{ __typename?: 'CalendlyEventEdge', node?: { __typename?: 'CalendlyEvent', id: string, insertedAt: any, calendlyEventId: string, calendlyInviteeId: string } | null } | null> | null } | null, skills?: Array<{ __typename?: 'Skill', id: string, skill: string }> | null, workPreference?: { __typename?: 'WorkPreference', titles?: Array<{ __typename?: 'WorkPreferenceJobTitle', jobTitle?: string | null } | null> | null, skills?: Array<{ __typename?: 'WorkPreferenceSkill', id: string, skillLevel?: string | null, order?: string | null, classificationSkill?: { __typename?: 'Skill', id: string, skill: string } | null } | null> | null, role?: { __typename?: 'WorkPreferenceIdealRole', id: string, roleType?: Array<string | null> | null, roleStatus?: Array<string | null> | null, hoursPerWeek?: string | null, projectLength?: Array<string | null> | null } | null, locations?: Array<{ __typename?: 'WorkPreferenceLocation', id: string, daysWfh?: string | null, order?: number | null, timezone?: Array<string | null> | null, travelDistance?: string | null, type?: string | null, details?: string | null, officeLocation?: Array<{ __typename?: 'LegacyLocation', city?: string | null, country?: string | null, countryCode?: string | null, id: string, subdivision?: string | null } | null> | null } | null> | null, company?: { __typename?: 'WorkPreferenceCompany', companySizes?: Array<string | null> | null, companyStages?: Array<string | null> | null, id: string } | null, preferredIndustries?: Array<{ __typename?: 'WorkPreferenceIndustry', id: string, industry?: string | null } | null> | null, undesirableIndustries?: Array<{ __typename?: 'WorkPreferenceIndustry', id: string, industry?: string | null } | null> | null } | null, workItems?: Array<{ __typename?: 'WorkItem', id: string, title?: string | null, summary?: any | null, startMonth: number, startYear?: number | null, endMonth?: number | null, endYear?: number | null, isCurrent?: boolean | null, url?: string | null, urlDescription?: string | null, businessServices?: Array<{ __typename?: 'BusinessService', name: string }> | null, organisation?: { __typename?: 'LegacyOrganisation', id: string, name?: string | null } | null, expertOrganisations?: Array<{ __typename?: 'LegacyOrganisation', name?: string | null }> | null, industries?: Array<{ __typename?: 'Industry', name?: string | null }> | null }> | null } | null, lifecycle?: { __typename?: 'Lifecycle', accepted?: boolean | null, declined?: boolean | null, emailVerified?: boolean | null, applicationStep?: ApplicationSteps | null, applicationCompleted?: boolean | null, basicProfileCompleted?: boolean | null, marketplaceMember?: boolean | null, privateCloudTalent?: boolean | null } | null } | null } | null } | null };

export type CreateWorkItemApplicationMutationVariables = Exact<{
  input: CreateWorkItemInput;
}>;


export type CreateWorkItemApplicationMutation = { __typename?: 'Mutation', createWorkItem?: { __typename?: 'CreateWorkItemPayload', workItem?: { __typename?: 'WorkHistory', endMonth?: number | null, endYear?: number | null, isCurrent?: boolean | null, startMonth?: number | null, startYear?: number | null, summary?: string | null, title?: string | null, url?: string | null, urlDescription?: string | null, businessServices?: Array<{ __typename?: 'BusinessService', id: string, isApproved: boolean, name: string }> | null, organisation?: { __typename?: 'LegacyOrganisation', id: string, name?: string | null } | null, expertOrganisations?: Array<{ __typename?: 'LegacyOrganisation', id: string, name?: string | null }> | null, industries?: Array<{ __typename?: 'Industry', id: string, name?: string | null } | null> | null } | null, lifecycle?: { __typename?: 'Lifecycle', id: string, basicProfileCompleted?: boolean | null } | null } | null };

export type DeleteWorkItemApplicationMutationVariables = Exact<{
  input: DeleteWorkItemInput;
}>;


export type DeleteWorkItemApplicationMutation = { __typename?: 'Mutation', deleteWorkItem?: { __typename?: 'DeleteWorkItemPayload', workItem?: { __typename?: 'WorkHistory', id: string } | null } | null };

export type UpdateWorkItemApplicationMutationVariables = Exact<{
  input: UpdateWorkItemInput;
}>;


export type UpdateWorkItemApplicationMutation = { __typename?: 'Mutation', updateWorkItem?: { __typename?: 'UpdateWorkItemPayload', workItem?: { __typename?: 'WorkHistory', endMonth?: number | null, endYear?: number | null, isCurrent?: boolean | null, startMonth?: number | null, startYear?: number | null, summary?: string | null, title?: string | null, url?: string | null, urlDescription?: string | null, businessServices?: Array<{ __typename?: 'BusinessService', id: string, isApproved: boolean, name: string }> | null, organisation?: { __typename?: 'LegacyOrganisation', id: string, name?: string | null } | null, expertOrganisations?: Array<{ __typename?: 'LegacyOrganisation', id: string, name?: string | null }> | null, industries?: Array<{ __typename?: 'Industry', id: string, name?: string | null } | null> | null } | null } | null };

export type ClearEducationItemsMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearEducationItemsMutation = { __typename?: 'Mutation', clearEducationItems?: { __typename?: 'ClearEducationItemsPayload', success?: boolean | null } | null };

export type ClearWorkItemsMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearWorkItemsMutation = { __typename?: 'Mutation', clearWorkItems?: { __typename?: 'ClearWorkItemsPayload', success?: boolean | null } | null };

export type UpdateExpertAdditionalRolesMutationVariables = Exact<{
  input: UpdateExpertAdditionalRolesInput;
}>;


export type UpdateExpertAdditionalRolesMutation = { __typename?: 'Mutation', updateExpertAdditionalRoles?: { __typename?: 'UpdateExpertAdditionalRolesPayload', additionalRoles?: Array<{ __typename?: 'BusinessService', id: string, name: string } | null> | null } | null };

export type UpdateExpertBusinessServiceMutationVariables = Exact<{
  input: UpdateExpertBusinessServiceInput;
}>;


export type UpdateExpertBusinessServiceMutation = { __typename?: 'Mutation', updateExpertBusinessService?: { __typename?: 'UpdateExpertBusinessServicePayload', businessService?: { __typename?: 'BusinessService', id: string, name: string } | null } | null };

export type RecommendedRolesQueryVariables = Exact<{
  group: Scalars['String'];
}>;


export type RecommendedRolesQuery = { __typename?: 'Query', businessServices?: { __typename?: 'BusinessServiceConnection', edges?: Array<{ __typename?: 'BusinessServiceEdge', node?: { __typename?: 'BusinessService', id: string, name: string, group: string } | null } | null> | null } | null };

export type RecommendedSkillsQueryVariables = Exact<{
  businessServiceId: Scalars['ID'];
}>;


export type RecommendedSkillsQuery = { __typename?: 'Query', skills?: { __typename?: 'SkillConnection', edges?: Array<{ __typename?: 'SkillEdge', node?: { __typename?: 'Skill', id: string, skill: string } | null } | null> | null } | null };

export type CreateProfileInterestMutationVariables = Exact<{
  input: CreateProfileInterestInput;
}>;


export type CreateProfileInterestMutation = { __typename?: 'Mutation', createProfileInterest?: { __typename?: 'CreateProfileInterestPayload', interestId: string } | null };

export type DeleteProfileInterestMutationVariables = Exact<{
  input: DeleteProfileInterestInput;
}>;


export type DeleteProfileInterestMutation = { __typename?: 'Mutation', deleteProfileInterest?: { __typename?: 'DeleteProfileInterestPayload', interestId: string } | null };

export type ExpertSignUpQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpertSignUpQuery = { __typename?: 'Query', countries?: Array<{ __typename?: 'Country', name?: string | null, alpha2Code?: string | null } | null> | null, viewer?: { __typename?: 'Viewer', user?: { __typename?: 'User', phoneMobile?: string | null, email?: string | null, firstname?: string | null, lastname?: string | null, country?: string | null } | null } | null, oauthProfile?: { __typename?: 'OauthProfile', provider?: OauthProvider | null, familyName?: string | null, givenName?: string | null, email?: string | null } | null };

export type SendVerifyEmailMutationVariables = Exact<{
  input: SendVerifyEmailInput;
}>;


export type SendVerifyEmailMutation = { __typename?: 'Mutation', sendVerifyEmail?: { __typename?: 'SendVerifyEmailPayload', success?: boolean | null } | null };

export type SendVerifySmsMutationVariables = Exact<{
  input: SendVerifySmsInput;
}>;


export type SendVerifySmsMutation = { __typename?: 'Mutation', sendVerifySms?: { __typename?: 'SendVerifySmsPayload', success?: boolean | null } | null };

export type VerifyEmailMutationVariables = Exact<{
  input: VerifyEmailInput;
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail?: { __typename?: 'VerifyEmailPayload', success?: boolean | null } | null };

export type VerifySmsMutationVariables = Exact<{
  input: VerifySmsInput;
}>;


export type VerifySmsMutation = { __typename?: 'Mutation', verifySms?: { __typename?: 'VerifySmsPayload', success?: boolean | null } | null };

export type SubmitExpertApplicationMutationVariables = Exact<{
  input: SubmitExpertApplicationInput;
}>;


export type SubmitExpertApplicationMutation = { __typename?: 'Mutation', submitExpertApplication?: { __typename?: 'SubmitExpertApplicationPayload', user?: { __typename?: 'User', firstname?: string | null, publicCode?: string | null, uploadedCv?: string | null, operatingType?: OperatingType | null, workingSituation?: WorkingSituation | null, consultant?: { __typename?: 'Consultant', paymentInformation?: { __typename?: 'PaymentInformation', registeredBusinessName?: string | null } | null, profile?: { __typename?: 'Profile', code: string, id: string, hash?: string | null, vettedIntoMarketplace?: boolean | null, linkedinUrl?: string | null, websiteUrl?: string | null } | null, lifecycle?: { __typename?: 'Lifecycle', accepted?: boolean | null, declined?: boolean | null, applicationStep?: ApplicationSteps | null, applicationCompleted?: boolean | null } | null } | null } | null } | null };
